if (PJQ.app.module === PJQ.constants.modules.PROJECTWALL) {
    PJQ.app.addOldRoutes([
        {
            route: '',
            name: 'default',
            callback: function () {
                PJQ.app.router.navigate('projects', {
                    trigger: true,
                    replace: true
                });
            }
        }
    ]);
}

PJQ.modules.projectWall = {
    oldRoutes: [
        {
            route: "?projectid",
            callback: function (projectId) {
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        }
    ],
    routes: [
        {
            route: 'projects/:projectId',
            name: 'projectRoot',
            callback: function (projectId) {
                let moduleName = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_MODULE) ?
                    PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_MODULE) : 'dashboard';
                PJQ.app.router.navigate('projects/' + projectId.toString() + '/' + moduleName, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/added',
            name: 'projectRoot',
            callback: function (projectId) {
                if (PJQ.app.session.user == null) {
                    PJQ.app.router.signInNavigate({
                        cacheRoute: true
                    });
                    return;
                }

                let moduleName = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_MODULE) ?
                    PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_MODULE) : 'dashboard';
                PJQ.app.router.navigate('projects/' + projectId.toString() + '/' + moduleName, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/submitbid#tabPrivateMessage',
            name: 'projectSubmitBidLegacy',
            callback: function (projectId) {
                PJQ.app.session.set('submitBid', true);
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/SubmitBid#tabPrivateMessage',
            name: 'projectSubmitBidLegacy',
            callback: function (projectId) {
                PJQ.app.session.set('submitBid', true);
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/SubmitBid',
            name: 'projectSubmitBid',
            callback: function (projectId) {
                PJQ.app.session.set('submitBid', true);
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/submitbid',
            name: 'projectSubmitBid',
            callback: function (projectId) {
                PJQ.app.session.set('submitBid', true);
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/?response=:response',
            name: 'projectWithResponse',
            callback: function (projectId, response) {
                PJQ.app.session.set('bidStatus', response);
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/ACCEPT',
            name: 'projectWithAcceptResponse',
            callback: function (projectId) {
                PJQ.app.session.set('bidStatus', 'ACCEPT');
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/DECLINE',
            name: 'projectWithDeclineResponse',
            callback: function (projectId) {
                PJQ.app.session.set('bidStatus', 'DECLINE');
                PJQ.app.router.navigate('projects/' + projectId, {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/dashboard',
            name: 'projectDashboard',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dashboard");
            }
        },
        {
            route: 'projects/:projectId/details',
            name: 'projectDetails',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "details", {
                    detailedProject: true
                });
            }
        },
        {
            route: 'projects/:projectId/locations',
            name: 'projectDetails',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "locations");
            }
        },
        {
            route: 'projects/:projectId/mall',
            name: 'projectContainer',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "mall", {
                    detailedProject: true
                });
            }
        },
        {
            route: 'projects/:projectId/messaging',
            name: 'projectMessaging',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging");
            }
        },
        {
            route: 'projects/:projectId/messaging/:projectMessageId',
            name: 'projectMessagingView',
            callback: function (projectId, projectMessageId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging", {
                    viewProjectMessageId: projectMessageId
                });
            }
        },
        {
            route: 'projects/:projectId/messagingnew',
            name: 'projectMessaging',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messagingnew");
            }
        },
        {
            route: 'projects/:projectId/messagingnew/:projectMessageId',
            name: 'projectMessagingViewNew',
            callback: function (projectId, projectMessageId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messagingnew", {
                    viewProjectMessageId: projectMessageId
                });
            }
        },
        {
            route: 'projects/:projectId/messaging/:projectMessageId/copy',
            name: 'projectMessagingCopy',
            callback: function (projectId, projectMessageId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging", {
                    copyProjectMessageId: projectMessageId
                });
            }
        },
        {
            route: 'projects/:projectId/messagingnew/:projectMessageId/copy',
            name: 'projectMessagingCopyNew',
            callback: function (projectId, projectMessageId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messagingnew", {
                    copyProjectMessageId: projectMessageId
                });
            }
        },
        {
            route: 'projects/:projectId/messaging/:projectMessageId/delete',
            name: 'projectMessagingDelete',
            callback: function (projectId, projectMessageId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging", {
                    deleteProjectMessageId: projectMessageId
                });
            }
        },
        {
            route: 'projects/:projectId/privatemessaging/view/:viewName',
            name: 'privateMessagingSent',
            callback: function (projectId, viewName) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "privatemessaging", {
                    view: viewName,
                    noRoute: true
                });
            }
        },
        {
            route: 'projects/:projectId/privatemessaging',
            name: 'privateMessaging',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "privatemessaging");
            }
        },
        {
            route: 'projects/:projectId/privatemessaging/:projectMessageId',
            name: 'privateMessagingMessage',
            callback: function (projectId, projectMessageId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "privatemessaging", {
                    viewUserMessageId: projectMessageId
                });
            }
        },
        {
            route: 'projects/:projectId/documents',
            name: 'projectDocuments',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectdocuments");
            }
        },
        {
            route: 'projects/:projectId/attachments',
            name: 'projectAttachments',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "attachments");
            }
        },
        {
            route: 'projects/:projectId/submittalsold',
            name: 'submittalList',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittals_old");
            }
        },
        {
            route: 'projects/:projectId/submittals',
            name: 'submittalList',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittals");
            }
        },
        {
            route: 'projects/:projectId/submittals/:submittalId',
            name: 'submittal',
            callback: function (projectId, submittalId) {
                window.pjqSubmittalLoadId = submittalId;
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittals", {
                    submittalId: submittalId
                });
            }
        },
        {
            route: 'projects/:projectId/reports',
            name: 'projectreports',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectreports");
            }
        },
        {
            route: 'projects/:projectId/autoreport',
            name: 'autoReport',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "rsvpautoreport");
            }
        },
        {
            route: 'projects/:projectId/proposals',
            name: 'proposals',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "proposals");
            }
        },
        {
            route: 'projects/:projectId/messaging/context/:msgContext/:sessionId/new',
            name: 'projectMessagingContextOld',
            callback: function (projectId, msgContext, sessionId) {
                window.projectContactTemp = msgContext;
                window.pjqSessionId = sessionId;
                PJQ.app.session.set('sessionId', sessionId);
                window.isNewMsg = true;
                PJQ.app.router.navigate('projects/' + projectId + '/messaging', {
                    trigger: true,
                    replace: true
                });
            }
        },
        {
            route: 'projects/:projectId/messaging/context/:msgContext/:sessionId',
            name: 'projectMessagingContextOld',
            callback: function (projectId, msgContext, sessionId) {
                window.projectContactTemp = msgContext;
                window.pjqSessionId = sessionId;
                PJQ.app.session.set('sessionId', sessionId);
                window.isNewMsg = false;
                PJQ.app.router.navigate('projects/' + projectId + '/messaging', {
                    trigger: true,
                    replace: true
                });
            }
        },
    ],
    initProjectNavigator(projectId, activeItem, viewOptions) {
        if (!PJQ.app.session.project || !PJQ.app.session.project.isFetched || PJQ.app.session.project.id !== projectId) {
            PJQ.app.session.project = new PJQ.models.projects.Project({
                projectId: projectId
            }, {isDetail: viewOptions != null && viewOptions.detailedProject === true});
            if (PJQ.app.session.project.id > 0) {
                PJQ.app.session.project.fetch({
                    notify: false,
                    success: function () {
                        if (activeItem === 'dashboard' && PJQ.app.session.project.get('status') === 'ARCHIVE')
                            activeItem = 'details';

                        if (PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')
                            && PJQ.app.session.project.nda != null) {
                            new PJQ.views.projects.SignProjectNDAModal({
                                model: PJQ.app.session.project,
                                activeItem: activeItem,
                                viewOptions: viewOptions
                            });
                            return;
                        }

                        let accessKey = PJQ.app.session.get('accessKey');
                        if (_.size(accessKey) > 0) {
                            new PJQ.ajax.Request({
                                endpoint: "/projects/" + PJQ.app.session.project.id + "/viewed?accessKey=" + accessKey
                            }).post();
                        } else if (PJQ.app.session.user && PJQ.app.session.user.id > 0 && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
                            new PJQ.ajax.Request({
                                endpoint: "/projects/" + PJQ.app.session.project.id + "/viewed"
                            }).post();
                        }

                        if (window.settings != null) {
                            window.settings.SelectectContactGroupsTemp = [];
                            window.settings.SelectectContactsTemp = [];
                            window.settings.SharedFolderId = PJQ.app.session.project.get('sharedFolderId');
                        }

                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'session'
                                },
                                {
                                    endpoint: 'project',
                                    value: projectId
                                }
                            ])
                        }).put().done(_.bind(function () {
                            let initNav = function () {
                                PJQ.app.initNavigator({
                                    activeItem: activeItem,
                                    viewOptions: viewOptions
                                });
                            };

                            if (PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
                                PJQ.app.session.project.fetchUserMessageTypes(function () {
                                    let accessKey = PJQ.app.session.get('accessKey');
                                    if (_.size(accessKey) > 0) {
                                        PJQ.app.TokenManager.getTokensForAccessKey(accessKey, (success, error) => {
                                            initNav();
                                        });
                                        return;
                                    }

                                    initNav();
                                });
                            } else {
                                initNav();
                            }
                        }, this))
                    },
                    error: function (model, response) {
                        if (response.status === 401 && _.size(PJQ.app.session.get('accessKey')) > 0) {
                            PJQ.notifications.notify.warningNotify({
                                message: 'This access key has expired'
                            });
                        } else {
                            new PJQ.ErrorHandler({}).handle(response, model.toJSON());
                        }
                        PJQ.app.router.navigate('/', {
                            trigger: true,
                            replace: true
                        });
                    }
                });
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'This project cannot be found currently'
                });
                PJQ.app.router.navigate('/', {
                    trigger: true,
                    replace: true
                });
            }
        } else {
            PJQ.app.initNavigator({
                activeItem: activeItem,
                viewOptions: viewOptions
            });
        }
    }
};

PJQ.app.addRoutes(PJQ.modules.projectWall.routes);
PJQ.app.addOldRoutes(PJQ.modules.projectWall.oldRoutes);

PJQ.views.projects.AddParticipantsDetailedModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Add-Participants-Detailed'),
		minWidth: '90%',
		onSave: null,
		isWrapForm: true,
		wrapFormName: 'modal-add-participants',
		isUseNewAddressBook: false
	},
	events: {
		'click .btn-add-selected': 'addSelected'
	},
	beforeModalCreated: function () {
	},
	renderData: function () {
		return {
			wrapFormName: this.options.wrapFormName,
			isUseNewAddressBook: this.options.isUseNewAddressBook
		};
	},
	beforeRender: function () {

	},
	afterRender: function () {
		if (this.options.isUseNewAddressBook) {
			let projectId = null
			if (this.options.projects) {
				projectId = this.options.projects[0].get('projectId');
			}
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: projectId ? projectId : PJQ.app.session.project.get('projectId')
					},
					{
						endpoint: 'pcg'
					}
				])
			}).get().done(_.bind(function (data) {
				if (PJQ.app.session.project) {
					new PJQ.Alert(this.$('.alert-project-name'), {
						type: 'primary',
						text: 'Project Info: ' + PJQ.app.session.project.get('projectName') + ' ' + PJQ.app.session.project.get('city') + ' ' + PJQ.app.session.project.get('state') + ' ' + PJQ.app.session.project.get('zip'),
						extraClasses: ['d-flex', 'text-align-center', 'align-content-center', 'justify-content-center']
					});
				}

				this.addressBookView = new PJQ.views.addressbook.AddressBook({
					el: this.$('.addressbook-container'),
					selectionMode: PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT,
					disabledContacts: this.options.disableContacts ? this.options.disableContacts : data.contactsNoGroup,
					disabledContactGroups: this.options.isMultipleProjects ? null : data.contactGroups,
					onSelection: _.bind(function (contactsAll, contactsNoGroup, contactGroups) {
						this.$('.btn-add-selected').prop('disabled', (_.size(contactsNoGroup) + _.size(contactGroups)) === 0);
						this.selectedContactsAll = contactsAll;
					}, this)
				});
			}, this)).fail(function () {
				PJQ.notifications.notify.errorNotify({
					message: 'Something went wrong!'
				});
			});
		}
		else {
			window.selectedCompanies = [];
			window.selectedContacts = [];
			window.selectedGroups = [];
			window.selectedContactGroups = [];
			window.pjqSessionId = PJQ.app.session.id;
			window.pjqABContext = 'ap2';
			window.pjqIsAddProjectContacts = false;
			window.isHideMerge = true;
			window.isHideAddSelectedContacts = true;
			window.isHideReturnToProject = true;
			window.isHideImportExport = true;
			window.initAbEditCallback = _.bind(function (isEditing) {
				if (isEditing) {
					this.$('.modal-btn-outer').hide();
				}
				else {
					this.$('.modal-btn-outer').show();
				}
			}, this);

			let $form = this.$("Form[name='" + this.options.wrapFormName + "']");
			window.validator = $form.validate({
				onsubmit: false,
				onkeyup: false,
				showErrors: function showErrors(errorMap, errorList) {
					for (let i = 0; errorList[i]; i++) {
						let element = this.errorList[i].element;
						//solves the problem with brute force
						//remove existing error label and thus force plugin to recreate it
						//recreation == call to error placement function
						this.errorsFor(element).remove();
					}
					this.defaultShowErrors();
				},
				errorPlacement: function errorPlacement(error, element) {
					error.html('<br />' + error.text());
					if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
						error.appendTo(element.parent().parent());
					else
						error.appendTo(element.parent());
				},
				errorClass: "pjq-errortext",
				ignore: "pjq-validate-ignore"
			});

			initAddressBook($form);
		}
	},
	addSelected: function () {
		this.selectedContacts = [];
		this.selectedCompanies = [];
		this.selectedGroups = [];

		if (this.options.isUseNewAddressBook) {
			this.selectedContacts = this.addressBookView.selectedContactsNoGroup;
			this.selectedGroups = this.addressBookView.selectedContactGroups;
		}
		else {
			this.selectedContacts = window.selectedContacts;
			this.selectedCompanies = window.selectedCompanies;
			this.selectedGroups = window.selectedGroups;
		}

		if (_.size(this.selectedContacts) + _.size(this.selectedCompanies) + _.size(this.selectedGroups) === 0) {
			PJQ.notifications.notify.errorNotify({
				message: 'No contacts were selected.  Please make selections to continue.'
			});
			return;
		}

		if (_.size(this.selectedContacts) + _.size(this.selectedCompanies) > 3200 || _.size(this.selectedGroups) > 3200) {
			PJQ.notifications.notify.errorNotify({
				message: 'Too many results were selected.  Please refine your search to continue.'
			});
			return;
		}

		if (!this.options.isMultipleProjects) {
			let callback = _.bind(function () {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'projects',
							value: PJQ.app.session.project.id
						},
						{
							endpoint: 'addpcg'
						}]),
					data: {
						contactIds: this.selectedContacts,
						contactCompanyIds: this.selectedCompanies,
						contactGroupIds: this.selectedGroups
					}
				}).post().done(_.bind(function (data) {
					if (typeof this.options.onSave === 'function') {
						this.options.onSave(data.contactIds, data.projectContactIds);
					}
					this.removeModal();
				}, this)).fail(function () {
				});
			}, this);

			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: PJQ.app.session.project.id
					},
					{
						endpoint: 'checkpcg'
					}]),
				data: {
					contactIds: this.selectedContacts,
					contactCompanyIds: this.selectedCompanies,
					contactGroupIds: this.selectedGroups
				}
			}).post().done(_.bind(function (data) {
				if (data.results.length > 0) {
					new PJQ.views.projects.AddParticipantsErrorModal({
						data: data.results,
						contactIds: this.selectedContacts,
						contactCompanyIds: this.selectedCompanies,
						contactGroupIds: this.selectedGroups,
						onContinue: _.bind(function () {
							callback();
						}, this)
					});
				}
				else
					callback();

			}, this)).fail(function () {
			});
		}
		else {
			this.options.onSave(this.selectedContactsAll, {
				selectedContacts: this.selectedContacts,
				selectedCompanies: this.selectedCompanies,
				selectedGroups: this.selectedGroups
			});
			this.removeModal();
		}
	}
});

PJQ.views.projects.AddParticipantsErrorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Add-Participants-Error-List'),
		minWidth: '90%',
		data: null,
		onContinue: _.noop
	},
	events: {
		'click .btn-copy-phone': 'copyPhone',
		'click .btn-continue': 'continue',
		'click .export': 'export'
	},
	afterRender: function () {
		new PJQ.views.dataTables.DataTable({
			el: this.$('.participant-errors'),
			pageLength: 999999,
			isHideSearch: true,
			data: this.options.data,
			dom: 't',
			order: [],
			columns: [
				{
					"data": "companyName",
					"title": "Company",
					"orderable": false
				},
				{
					"data": "contactName",
					"title": "Contact",
					"orderable": false
				},
				{
					"data": "phone",
					"title": "Phone",
					"orderable": false,
					"render": _.bind(function (data, type, row) {
						let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
							phoneFormatted = row.phone ? (PJQ.helpers.formatHelpers.formatPhoneNumber(row.phone) + (_.size(row.phoneExtension) === 0 ? '' : ' x' + row.phoneExtension)) : 'N/A';

						if (row.phone !== '')
							html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

						html += '<div class="flex-fill ' + (row.phone ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
						html += '</div>';
						return html;
					}, this)
				},
				{
					"data": "email",
					"title": "Email",
					"orderable": false
				},
				{
					"data": "reason",
					"title": "Reason",
					"orderable": false
				}
			]
		});

	},
	continue: function () {
		if (typeof this.options.onContinue === 'function')
			this.options.onContinue();

		this.removeModal();
	},
	export: function () {

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: PJQ.app.session.project.id
				},
				{
					endpoint: 'checkpcg'
				},
				{
					endpoint: 'export'
				}
			]),
			data: {
				contactIds: this.options.contactIds,
				contactCompanyIds: this.options.contactCompanyIds,
				contactGroupIds: this.options.contactGroupIds
			}
		}).post().success(_.bind(function (data) {
			PJQ.files.downloadFile(data.url, {isEndpoint: false});
		}, this));
	},
	copyPhone: function (e) {
		let inputId = 'h_input_' + _.uniqueId(),
			hiddenInput = $('<input>', {
				value: $(e.currentTarget).data('phone'),
				style: 'position: absolute;left:-2000px;top:-2000px',
				id: inputId
			});
		this.$el.append(hiddenInput);
		hiddenInput[0].select();
		document.execCommand("copy");
		hiddenInput.remove();
		PJQ.notifications.notify.successNotify({
			message: 'Number copied to clipboard.'
		});
	}
});

PJQ.views.projects.Attachments = PJQ.views.files.FileNavigator.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Attachments'),
		subTemplates: {
			file: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Attachment'),
			fileMenu: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Attachment-Menu')
		},
		sortBy: null,
		sortDirection: 'asc',
		isHideDrawings: false,
		enableDrawings: false,
		canAdd: false,
		canShare: false,
		isAdmin: false,
		isReadOnly: false,
		canOrder: true,
		hideHeader: false,
		foldersOnly: false
	},
	events: {
		'click .btn-upload-raw-files': 'uploadRawFiles',
		'click .btn-attach-documents': 'attachRootAttachments',
		'click .btn-add-shared-folder': 'addSharedFolderClicked',
		'click .btn-add-private-folder': 'addPrivateFolderClicked',
		'click .btn-add-to-drawings': 'addToDrawingsClicked',
		'click .btn-select-contents': 'selectFolderContentsClicked',
		'click .btn-add-selected-to-drawings': 'addSelectedToDrawings',
		'change .input-select-all': 'allChecked',
		'click .btn-download-all': 'downloadAll'
	},
	beforeFirstRender: function () {
		let prefs;
		if (this.options.project != null) {
			prefs = this.options.project.preferences;

			this.options.enableDrawings = !this.options.isHideDrawings && !this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS);
			this.options.canAdd = (this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
				&& this.options.project.hasPermission('attachments.canAdd'));
			this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
				&& this.options.project.hasPermission('attachments.isAdmin');
			this.options.canShare = this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
				&& this.options.project.hasPermission('attachments.canShare')
				&& !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SHARE_PEI);
			this.options.foldersOnly = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.RSVP_FOLDER_CHECKBOXES_ONLY) &&
				this.options.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');
		}
		else {
			prefs = PJQ.app.session.preferences;
		}

		if (prefs != null) {
			if(prefs.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ATTACHMENTS)){
				this.options.expandAllFolders = true;
			}

			// this has to read from session, it is a portal preference
			let sfOverride = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_SHARED_FOLDER_NAME_OVERRIDE);
			if(_.size(sfOverride) > 0){
				this.options.sharedFolderNameOverride = sfOverride;
			}
		}

		if (this.options.isReadOnly) {
			this.options.canAdd = false;
			this.options.canShare = false;
			this.options.isAdmin = false;
		}
		this.options.canOrder = !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT);

		this.fetchAttachments({
			isPrivate: this.options.project == null || !this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PRIVATE_ATTACHMENTS)
		});
	},
	getMenuActions: function () {
		let self = this;
		return [
			{
				name: 'Attach Folders',
				onClick: function () {
					self.attachRootAttachments();
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.canAdd && attachment.get('entryId') === -1;
				}
			},
			{
				name: 'New Folder',
				onClick: function (attachment) {
					self.addFolder(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.canAdd && attachment.get('isFolder');
				}
			},
			{
				name: 'Upload',
				onClick: function (attachment) {
					self.uploadToFolder(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.canAdd && attachment.get('entryId') > 0 && attachment.get('isFolder');
				}
			},
			{
				name: 'Download',
				onClick: function (attachment) {
					self.downloadAttachments(attachment);
				},
				isShown: _.bind(function (attachment) {
					if(this.options.foldersOnly && !attachment.get('isFolder')){
						return false;
					}

					return PJQ.app.session.project.get('isOnline') && (!attachment.get('isFolder') || _.size(attachment.getFolderAttachments()) > 0);
				}, this)
			},
			{
				name: 'View',
				onClick: function (attachment) {
					new PJQ.views.files.FileViewer({
						model: attachment
					});
				},
				isShown: function (attachment) {
					return attachment.get('name').toLowerCase().endsWith('.pdf');
				}
			},
			{
				name: 'Order',
				onClick: function (attachment) {
					self.order(attachment);
				},
				isShown: _.bind(function (attachment) {
					if(PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT)){
						return false;
					}

					if(this.options.foldersOnly && !attachment.get('isFolder')){
						return false;
					}

					return PJQ.app.session.project.get('isOnline') && (!attachment.get('isFolder') || _.size(attachment.getFolderAttachments()) > 0);
				}, this)
			},
			{
				name: 'Share',
				onClick: function (attachment) {
					self.shareAttachments(attachment);
				},
				isShown: function () {
					return self.options.canShare;
				}
			},
			{
				name: 'Export File List',
				onClick: function (attachment) {
					self.exportFileList(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && attachment.get('entryId') > 0 && attachment.get('isFolder');
				}
			},
			{
				name: 'Add to Drawings',
				onClick: function (attachment) {
					self.addToDrawings(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin
						&& !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS)
						&& attachment.get('entryId') > 0 && attachment.getDepth() > 0;
				}
			},
			{
				name: 'Select Contents',
				onClick: _.bind(function (attachment) {
					this.selectFolderContents(attachment);
				}, this),
				isShown: function (attachment) {
					return attachment.get('isFolder');
				}
			},
			{
				name: 'Cut',
				onClick: function (attachment) {
					self.cutAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.getDepth() > 0;
				}
			},
			{
				name: 'Copy',
				onClick: function (attachment) {
					self.copyAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.getDepth() > 0;
				}
			},
			{
				name: 'Paste',
				onClick: function (attachment) {
					self.paste(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.get('isFolder') && self.clipboard != null;
				}
			},
			{
				name: 'Rename',
				onClick: function (attachment) {
					self.renameAttachment(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.getDepth() > 0;
				}
			},
			{
				name: 'Properties',
				onClick: function (attachment) {
					self.attachmentProperties(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0;
				}
			},
			{
				name: 'Delete',
				isDanger: true,
				onClick: function (attachment) {
					self.deleteAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.get('folderId') > 0;
				}
			},
			{
				name: 'Detach',
				isDanger: true,
				onClick: function (attachment) {
					self.deleteAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0 &&
						attachment.get('folderId') === -1;
				}
			},
		];
	},
	selectFolderContentsClicked: function (e) {
		let $attachment = $(e.currentTarget).closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid'));
		this.selectFolderContents(attachment);
	},
	selectFolderContents: function (folder) {
		this.addSelectedAttachmentIds(_.map(folder.getFolderAttachments(true), function (att) {
			return att.cid;
		}));
		this.getAttachmentElement(folder).siblings('.attachment-files-outer').find('.input-select-attachment').prop('checked', true);
	},
	uploadRawFiles: function () {
		new PJQ.views.files.RawFileUploaderModal({
			project: this.options.project
		});
	},
	allChecked: function (e) {
		let isChecked = $(e.currentTarget).prop('checked');
		this.$('.input-select-attachment').prop('checked', isChecked);
		if (isChecked) {
			let attachmentIds = _.map(this.collection.models, function (attachment) {
				return attachment.cid;
			});
			this.addSelectedAttachmentIds(attachmentIds);
		}
		else {
			this.selectedAttachmentIds = [];
		}
	},
	addSharedFolderClicked: function () {
		this.addFolder(this.collection.getSharedFolder());
	},
	addPrivateFolderClicked: function () {
		this.addFolder(this.collection.getPrivateFolder());
	},
	attachRootAttachments: function () {
		new PJQ.views.files.FileSelector({
			foldersOnly: true,
			disabledAttachmentIds: _.map(this.collection.models, function (attachment) {
				return attachment.get('entryId');
			}),
			onSave: _.bind(function (files) {
				this.options.project.attachFiles(files, _.bind(function () {
					this.collection.fetch();
					PJQ.notifications.notify.successNotify({
						message: "Attached files successfully"
					});
				}, this));
			}, this)
		});
	},
	shareAttachments: function (attachments) {
		attachments = this.replaceVersionFolders(attachments);

		let shareDrawings = new PJQ.collections.drawings.Drawings(),
			versionIds = [];

		shareDrawings.options.allDrawings = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_SHARE_PREVENT_EXPIRATION);

		if (PJQ.helpers.objectHelpers.refinedType(attachments) === 'array') {
			_.each(_.filter(attachments, function (attachment) {
				return !attachment.get('isFolder') && attachment.get('isDrawing');
			}), function (attachment) {
				if (versionIds.indexOf(attachment.get('versionId')) === -1) {
					versionIds.push(attachment.get('versionId'));
				}
				shareDrawings.add(new PJQ.models.drawings.Drawing({
					guid: attachment.get('guid')
				}));
			});
		}
		else if (attachments.get('isDrawing')) {
			versionIds.push(attachments.get('versionId'));
			shareDrawings.add(new PJQ.models.drawings.Drawing({
				guid: attachments.get('guid')
			}));
		}

		if (_.size(shareDrawings.models) > 0) {
			let fileGuids = _.map(_.filter(attachments, function (attachment) {
					return !attachment.get('isDrawing');
				}), function (attachment) {
					return attachment.get('guid');
				}),
				sharingModal = new PJQ.views.sharing.SharingModal({
					collection: shareDrawings,
					project: this.options.project,
					onSave: _.bind(function (data) {
						shareDrawings.share(versionIds, fileGuids, data, this.options.project, _.bind(function (share) {
							PJQ.notifications.notify.successNotify({
								message: 'File share email sent'
							});
						}, this));
					}, this)
				});
			shareDrawings.share(versionIds, fileGuids, null, this.options.project, function (share) {
				let callback = _.bind(sharingModal.urlChanged, sharingModal);
				callback(share.url);
			});
		}
		else {
			let shareAtt = [],
				fnCheck = function (att) {
					if (att.get('entryId') === -1) {
						shareAtt.push(...att.getFolderAttachments());
					}
					else {
						shareAtt.push(att);
					}
				};
			if (PJQ.helpers.objectHelpers.refinedType(attachments) === 'array') {
				_.each(attachments, function (att) {
					fnCheck(att);
				});
			}
			else {
				fnCheck(attachments);
			}
			let files = new PJQ.collections.files.Files(shareAtt),
				sharingModal = new PJQ.views.sharing.SharingModal({
					project: this.options.project,
					onSave: _.bind(function (data) {
						files.share(data, this.options.project, _.bind(function (share) {
							PJQ.notifications.notify.successNotify({
								message: 'File share email sent'
							});
						}, this));
					}, this)
				});
			files.share(null, this.options.project, function (share) {
				let callback = _.bind(sharingModal.urlChanged, sharingModal);
				callback(share.url);
			});
		}
	},
	downloadAll: function () {
		this.downloadAttachments(this.collection.models);
	},
	addToDrawingsClicked: function (e) {
		let $attachment = $(e.currentTarget).closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid'));
		this.addToDrawings(attachment);
	},
	addSelectedToDrawings: function () {
		this.addToDrawings(this.collection.get(this.selectedAttachmentIds));
	},
	addToDrawings: function (files) {
		if (PJQ.helpers.objectHelpers.refinedType(files) === 'object') {
			files = [files];
		}
		PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/drawings', {
			trigger: true
		});
		let versions = new PJQ.collections.drawings.Versions(null, {
			project: this.options.project
		});
		versions.fetch({
			success: _.bind(function () {
				new PJQ.views.drawings.DrawingBatchModal({
					versions: versions,
					project: this.options.project,
					model: new PJQ.models.drawings.DrawingBatch({
						files: files,
						projectId: this.options.project.id
					})
				});
			}, this)
		});
	}
});

PJQ.views.projects.AttachmentsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'modal-project-attachments'),
		subTemplates: {},
		maxWidth: 1400,
		onSave: _.noop
	},
	events: {
		'click .btn-save': 'onSave'
	},
	afterRender: function () {
		if (PJQ.app.session.project) {
			this.attachmentsView = new PJQ.views.projects.Attachments({
				el: this.$('.modal-body'),
				expandSharedFolders: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ROOT_SHARED_FOLDERS),
				project: PJQ.app.session.project,
				isReadOnly: PJQ.app.session.project.get('status') === 'ARCHIVE'
			})
		}
	},
	onSave: function () {
		this.options.onSave(this.attachmentsView.collection.get(this.attachmentsView.selectedAttachmentIds));
		this.removeModal();
	}
});


PJQ.constants.projectMessaging = {
	views: {
		GROUPCOMP: 'groupcompany',
		GROUPCOMP_COMP: 'groupcompany-company',
		GROUPCOMP_COMP_CONT: 'groupcompany-company-contact',
		GROUPCONT: 'groupcontact',
		GROUPCONT_CONT: 'groupcontact-contact',
		MSGCONT: 'messagecontact',
		MSGCONT_CONT: 'messagecontact-contact',
		RSPCONT: 'responsecontact',
		RSPCONT_CONT: 'responsecontact-contact',
		COMP: 'company',
		COMP_CONT: 'company-contact',
		CONT: 'contact',
		CONTGROUP: 'contactgroup',
		BIDPKGS: 'bidpackages',
		BIDPKGS_CONT: 'bidpackages-contact'
	}
};

PJQ.views.projects.LocationManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-management'),
        subTemplates: {
            tier: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-tier'),
            location: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-item'),
            editLocation: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-edit')
        }
    },
    events: {
        'click .location:not(.editing)': 'locationClicked',
        'click .btn-add-location': 'addLocationClicked',
        'keyup .input-location-name': 'locationNameChanged',
        'click .btn-edit-location': 'editLocationClicked',
        'click .btn-delete-location': 'deleteLocationClicked',
        'click .btn-cancel-edit': 'endLocationEdit',
        'click .btn-save-location': 'saveLocationClicked'
    },
    beforeFirstRender: function () {
        this.options.project.fetchLocations(_.bind(function (locations) {
            this.collection = locations;
            this.render();
        }, this))
    },
    afterRender: function () {
        if (this.collection == null) {
            return;
        }

        this.$el.on('click', function () {
            $(this).find('.dropdown-menu').hide();
        });

        let $tiers = this.$('.location-tiers');
        $tiers.on('click', '.location-dropdown-toggle', (function (e) {
            $(this).next('.dropdown-menu').toggle();
            e.stopPropagation();
        }));

        this.renderTiers();
    },
    locationNameChanged: function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.saveLocationClicked(e);
        }
    },
    addLocationClicked: function (e) {
        this.renderLocationEdit($(e.currentTarget));
    },
    editLocationClicked: function (e) {
        e.stopPropagation();

        let $location = $(e.currentTarget).closest('.location'),
            id = $location.data('id'),
            location = this.collection.get(id);

        this.endLocationEdit();
        this.editLocation = location;
        if (location != null) {
            $location.addClass('editing');
            this.renderLocationEdit($location, location);
        }
    },
    renderLocationEdit: function ($location, location) {
        this.renderSubTemplate(false, this.options.subTemplates.editLocation, $location, {
            location: location
        }, _.bind(function () {
            this.$('.input-location-name').focus().select();
        }, this));
    },
    endLocationEdit: function (e) {
        if (e) {
            e.stopPropagation();

            let $add = $(e.currentTarget).closest('.btn-add-location'),
                parentId = $add.length > 0 ? $add.data('parentId') : null;
            if (parentId != null) {
                this.renderTiers();
                return;
            }
        }

        if (this.editLocation != null) {
            let $location = this.$('.location[data-id="' + this.editLocation.id + '"]');
            if ($location.length > 0) {
                $location.replaceWith(this.renderLocation(this.editLocation, this.getActiveLocations()).outerHTML());
            }
            this.editLocation = null;
        }
    },
    saveLocationClicked: function (e) {
        e.stopPropagation();

        let saveLocation = null,
            name = $(e.currentTarget).parent().find('.input-location-name').val(),
            $add = $(e.currentTarget).closest('.btn-add-location'),
            parentId = $add.length > 0 ? $add.data('parentId') : null;
        if (parentId != null) {
            saveLocation = new PJQ.models.projects.Location({
                projectId: this.options.project.id,
                name: name,
                parentId: parentId > 0 ? parentId : null
            });
            this.collection.add(saveLocation);
            this.contextLocation = saveLocation;
        } else if (_.size(name) > 0) {
            this.editLocation.set('name', name);
            saveLocation = this.editLocation;
        }

        if (saveLocation != null) {
            saveLocation.save(null, {
                success: _.bind(function () {
                    //todo: notify saved, add loading maybe
                    this.renderTiers();
                }, this)
            });
        }
    },
    locationClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.contextLocation = this.collection.get(id);
        this.renderTiers();
    },
    deleteLocationClicked: function (e) {
        e.stopPropagation();

        let id = $(e.currentTarget).closest('.location').data('id'),
            location = this.collection.get(id),
            children = this.collection.getChildren(location, true),
            fnDelete = _.bind(function () {
                location.destroy({
                    success: _.bind(function () {
                        this.collection.remove(_.union([location], children));
                        if (this.contextLocation != null && this.collection.get(this.contextLocation.id) == null) {
                            // the context location was deleted
                            // try to get the closest existing parent of it
                            let activeLocations = this.getActiveLocations().reverse(),
                                newContextLocation = null;
                            for (let i = 0; i < _.size(activeLocations); i++) {
                                if (activeLocations[i].id !== this.contextLocation.id) {
                                    newContextLocation = activeLocations[i];
                                    break;
                                }
                            }
                            this.contextLocation = newContextLocation;
                        }
                        this.renderTiers();
                    }, this)
                });
            }, this)

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this location?  All of it's child locations will also be deleted.",
            onDelete: _.bind(function () {
                fnDelete();
            }, this)
        });
    },
    getActiveLocations: function () {
        if (this.contextLocation == null) {
            return [];
        }

        let result = this.collection.getParents(this.contextLocation);
        result.push(this.contextLocation);
        return result;
    },
    renderTiers: function () {
        this.editLocation = null;

        this.$tiers = this.$('.location-tiers');
        this.$tiers.empty();

        let nextTierLocations,
            activeLocations = this.getActiveLocations(),
            ctActive = _.size(activeLocations);
        if (this.contextLocation != null) {
            for (let i = 0; i < ctActive; i++) {
                this.renderTier(i + 1, this.collection.getSiblings(activeLocations[i]), activeLocations, i > 0 ? activeLocations[i - 1] : null);
            }

            nextTierLocations = this.collection.getChildren(this.contextLocation);
        } else {
            nextTierLocations = this.collection.getRootLocations();
        }
        this.renderTier(ctActive + 1, nextTierLocations, activeLocations, ctActive > 0 ? activeLocations[ctActive - 1] : null);
    },
    renderTier: function (tierNumber, locations, activeLocations, activeParent) {
        this.renderSubTemplate(true, this.options.subTemplates.tier, this.$tiers, {
            tierNumber: tierNumber,
            locations: locations,
            activeLocations: activeLocations,
            activeParent: activeParent,
            renderLocation: _.bind(this.renderLocation, this)
        });
    },
    renderLocation: function (location, activeLocations) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.location, {
            activeIds: activeLocations ? _.map(activeLocations, function (location) {
                return location.id;
            }) : [],
            location: location
        });
    }
});

PJQ.models.projects.Location = PJQ.models.BaseModel.extend({
    idAttribute: "id",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'locations',
                value: this.id
            }
        ])
    }
});

PJQ.collections.projects.Locations = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.projects.Location,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'locations'
            }
        ]);
    },
    getRootLocations: function () {
        return _.filter(this.models, function (location) {
            return !(location.get("parentId") > 0);
        });
    },
    getChildren: function (location, recursive = false) {
        if (recursive) {
            let fnGetChildren = _.bind(function (locations, result) {
                if (result == null) {
                    result = [];
                }

                if (_.size(locations) === 0) {
                    return result;
                }

                let children = [];
                _.each(locations, function (location) {
                    children.push(...this.where({parentId: location.id}));
                }, this)
                result.push(...children);

                return fnGetChildren(children, result);
            }, this)
            return fnGetChildren([location]);
        }

        return this.where({parentId: location.id});
    },
    getSiblings: function (location) {
        let pId = location.get('parentId');
        if (pId > 0) {
            return this.where({parentId: pId});
        }
        return this.getRootLocations();
    },
    getParents: function (location) {
        let fnGetParent = _.bind(function (location, result) {
            if (result == null) {
                result = [];
            }

            let pId = location.get('parentId');
            if (!(pId > 0)) {
                return result;
            }
            let parent = this.get(pId);
            if (parent == null) {
                return result;
            }
            result.push(parent);
            return fnGetParent(parent, result);
        }, this)
        return fnGetParent(location).reverse();
    },
    getPickerArray: function () {
        let result = [],
            getChildrenNames = _.bind(function (location, parentName) {
                result.push({
                    id: location.id,
                    name: parentName
                });
                _.each(_.sortBy(this.where({parentId: location.id}), (location) => {
                    return location.get('name')
                }), function (child) {
                    let newParentName = parentName + ' > ' + child.get('name');
                    getChildrenNames(child, newParentName);
                });
            }, this)
        _.each(_.sortBy(this.where({parentId: null}), (location) => {
            return location.get('name')
        }), function (rootParent) {
            getChildrenNames(rootParent, rootParent.get('name'));
        });
        return result;
    },
    getFullName: function (location) {
        let parents = this.getParents(location),
            result = '';
        _.each(parents, function (parent) {
            result += parent.get('name') + ' > ';
        });
        result += location.get('name');
        return result;
    }
});
PJQ.views.projects.SignProjectNDAModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Sign-Project-NDA'),
		maxWidth: '800px'
	},
	events: {
		'click .btn-decline-nda': 'decline',
		'click .btn-sign-nda': 'sign',
		'change .input-nda-agree': 'agreeChanged'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));
	},
	agreeChanged: function () {
		this.$('.btn-sign-nda').prop('disabled', !this.$('.input-nda-agree').prop('checked'));
	},
	decline: function () {
		new PJQ.Loader(this.$('.modal-body'));
		PJQ.app.session.project.updateResponse(PJQ.constants.projectContacts.bidStatus.DECLINE, _.bind(function () {
			this.close();
			PJQ.notifications.notify.successNotify({
				message: 'Your response has been submitted'
			});
			PJQ.app.router.signInNavigate();
		}, this));
	},
	sign: function () {
		let isValid = true,
			$companyName = this.$('.input-nda-company-name'),
			companyName = $companyName.val();
		PJQ.helpers.inputHelpers.setInputError($companyName, true);
		if (_.size(companyName) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($companyName, false);
		}

		let $contactName = this.$('.input-nda-contact-name'),
			contactName = $contactName.val();
		PJQ.helpers.inputHelpers.setInputError($contactName, true);
		if (_.size(contactName) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($contactName, false);
		}

		let $title = this.$('.input-nda-title'),
			title = $title.val();
		PJQ.helpers.inputHelpers.setInputError($title, true);
		if (_.size(title) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($title, false);
		}

		let $email = this.$('.input-nda-email'),
			email = $email.val();
		PJQ.helpers.inputHelpers.setInputError($email, true);
		if (_.size(email) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($email, false);
		}

		let $phone = this.$('.input-nda-phone'),
			phone = $phone.val();
		PJQ.helpers.inputHelpers.setInputError($phone, true);
		if (_.size(phone) === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError($phone, false);
		}

		let $error = this.$('.nda-error');
		if (!isValid) {
			$error.html('All required fields must be filled out before signing');
			return;
		}

		let isAgreed = this.$('.input-nda-agree').prop('checked');
		if (!isAgreed) {
			$error.html('You must agree to the non-disclosure before signing');
			return;
		}
		else {
			$error.empty();
		}

		this.$('.btn-decline-nda').prop('disabled', true);
		new PJQ.Loader(this.$('.btn-sign-nda'), {
			loadingText: "Signing..."
		});
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.model.id
				},
				{
					endpoint: 'nda',
					value: this.model.nda.get('ndaId')
				},
				{
					endpoint: 'sign'
				}
			]),
			data: {
				companyName: companyName,
				contactName: contactName,
				title: title,
				email: email,
				phone: phone
			}
		}).post().done(_.bind(function () {
			this.model.isFetched = false;
			PJQ.modules.projectWall.initProjectNavigator(this.model.id, this.options.activeItem ? this.options.activeItem : "dashboard", this.options.viewOptions ? this.options.viewOptions : null);
			this.removeModal();
		}, this));
	}
});

PJQ.views.projects.EditProjectNDAModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Edit-Project-NDA'),
		maxWidth: '800px'
	},
	events: {
		'change .cb-override': 'overrideChanged',
		'click .btn-delete-nda': 'deleteClicked',
		'click .btn-cancel-nda': 'cancelClicked',
		'click .btn-save-nda': 'saveClicked'
	},
	beforeModalCreated: function () {
		if (this.options.project != null) {
			PJQ.app.session.fetchNDAs(_.bind(function (ndas) {
				this.ndas = ndas;
				this.options.project.fetchNDA(_.bind(function (nda) {
					this.model = nda;
					this.render();
				}, this));
			}, this));
		}
	},
	renderData: function () {
		return {
			model: this.model,
			project: this.options.project,
			ndas: this.ndas
		};
	},
	afterRender: function () {
		if (this.model != null && this.options.project != null) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-nda'),
				hideDisabled: true,
				defaultValue: this.model.id,
				onChange: _.bind(function (value) {
					this.useNDA(this.ndas.get(value));
					this.render();
				}, this)
			});
		}
	},
	useNDA: function (nda) {
		this.model.set({
			ndaId: nda ? nda.id : null,
			name: nda ? nda.get('name') : '',
			ndaText: nda ? nda.get('ndaText') : ''
		});
	},
	overrideChanged: function () {
		let override = this.$('.cb-override').prop('checked');
		if (override) {
			this.model.set({
				ndaId: null,
				name: ''
			});
		}
		else {
			this.useNDA(this.ndas.findWhere({isDefault: true}));
		}
		this.render();
	},
	deleteClicked: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Delete NDA",
			body: "Are you sure you want to delete this project NDA?",
			onDelete: _.bind(function () {
				if (this.model.id > 0) {
					this.model.destroy();
				}

				this.removeModal();
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
			}, this)
		});
	},
	cancelClicked: function () {
		this.removeModal();
		if (this.options.onCancel) {
			this.options.onCancel(this.model);
		}
	},
	saveClicked: function () {
		if (this.options.project != null) {
			let ndaText = this.$('.textarea-nda-text').val(),
				gNda = this.ndas.get(this.model.id);
			if (gNda == null && _.size(ndaText) === 0) {
				new PJQ.views.modals.SaveDontSave({
					header: "NDA Terms Empty",
					body: "You have not entered any NDA agreement terms.  If you save this, the NDA will be disabled for this project.  Are you sure you want to save?",
					isShowDontSaveButton: false,
					onSave: _.bind(function () {
						this.save();
					}, this)
				});
			}
			else {
				this.save();
			}
		}
		else {
			this.save();
		}
	},
	save: function () {
		let ndaText = this.$('.textarea-nda-text').val(),
			isDefault,
			name,
			saveNda;
		if (this.options.project != null) {
			name = this.model.get('name');
			isDefault = false;
			saveNda = this.ndas.get(this.model.id) != null || _.size(ndaText) > 0;
			this.options.project.set('hasNDA', saveNda, {
				silent: true
			});
		}
		else {
			name = this.$('.input-nda-name').val();
			isDefault = this.$('.cb-default').prop('checked');
			saveNda = true;
		}
		if (saveNda) {
			this.model.save({
				name: name,
				ndaText: ndaText,
				isDefault: isDefault
			}, {
				success: _.bind(function () {
					if (this.options.onSave) {
						this.options.onSave(this.model);
					}
					this.removeModal();
					PJQ.notifications.notify.successNotify({
						message: "NDA updated successfully"
					});
				}, this)
			});
		}
		else {
			if (this.options.project != null) {
				this.model.destroy();
			}
			this.removeModal();
		}
	}
});

PJQ.views.projects.UserMessages = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-User-Messages'),
		view: 'inbox'
	},
	events: {
		'click .btn-view-message': 'viewMessageClicked',
		'click .btn-delete-message': 'deleteMessageClicked',
		'click .btn-user-messages-add': 'newMessageClicked',
		'click .btn-user-messages-inbox': 'openInbox',
		'click .btn-user-messages-sent': 'openSent'
	},
	beforeFirstRender: function () {
		if (this.options.userMessageId > 0) {
			let userMessage = new PJQ.models.userMessages.UserMessage({
				userMessageId: this.options.userMessageId
			});
			userMessage.fetch({
				success: _.bind(function () {
					this.viewMessage(userMessage);
				}, this)
			});
			this.options.userMessageId = null;
		}

		if (PJQ.app.session.get('masterUserId') === this.options.project.get('masterUserId')) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: this.options.project.id
					},
					{
						endpoint: 'usermessages',
						value: 'stats'
					},
				])
			}).get().done(_.bind(function (data) {
				this.messageStats = data;
				this.render();
			}, this));
			return false;
		}
	},
	afterRender: function () {
		if (this.messageStats != null) {
			this.options.userId = PJQ.app.session.user.id;
			if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PRIVATE_MESSAGING_USER_ID_DEFAULT)) {
				this.options.userId = (PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PRIVATE_MESSAGING_USER_ID_DEFAULT) == 0 ? -1 : PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PRIVATE_MESSAGING_USER_ID_DEFAULT));
			}

			let $userFilter = this.$('select.user-messages-user-filter'),
				totalMessageCount = _.reduce(_.map(this.messageStats, function (stat) {
					return stat.messageCount
				}), function (memo, stat) {
					return memo + stat;
				}, 0);
			$userFilter.append($('<option/>', {
				value: -1,
				text: 'All (' + totalMessageCount.toString() + ')'
			}));

			let myStat = _.find(this.messageStats, function (stat) {
				return stat.userId === PJQ.app.session.user.id
			});
			if (myStat == null) {
				$userFilter.append($('<option/>', {
					value: PJQ.app.session.user.id,
					text: PJQ.app.session.user.get('contactName') + ' (0)'
				}));
			}
			_.each(this.messageStats, _.bind(function (user) {
				$userFilter.append($('<option/>', {
					value: user.userId,
					text: user.contactName + ' (' + user.messageCount.toString() + ')'
				}));
			}, this));

			new PJQ.inputs.Selectpicker({
				el: this.$('select.user-messages-user-filter'),
				isMultiple: false,
				defaultValue: this.options.userId,
				onChange: _.bind(function (value) {
					this.options.userId = value;
					this.refreshView();
				}, this)
			});
		}

		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.user-messages-data-table'),
			language: {
				emptyTable: "No messages found"
			},
			autoWidth: false,
			data: null,
			isHideSearch: true,
			order: [1, 'desc'],
			rowGroup: {
				enable: false
			},
			columns: [
				{
					"title": 'Message Info',
					"render": _.bind(function (data, type, row) {
						let rowText = '';
						if (type === 'sort' || type === 'type') {
							if (this.options.view === 'inbox')
								rowText = row.from.get('companyName') + ' ' + row.from.get('contactName') + '<br />' + row.get('userMessageType');
							else
								rowText = row.to.get('companyName') + ' ' + row.to.get('contactName') + '<br />' + row.get('userMessageType');
						}

						if (this.options.view === 'inbox')
							rowText = row.from.get('companyName') + '<br />' + row.from.get('contactName') + '<br />' + row.get('userMessageType');
						else
							rowText = row.to.get('companyName') + '<br />' + row.to.get('contactName') + '<br />' + row.get('userMessageType');

						if (row.get('viewedOn') == null && this.options.view === 'inbox') {
							return '<span class="font-weight-bold">' + rowText + '</span>';
						}
						else {
							return rowText;
						}
					}, this),
					"width": "65%"
				},
				{
					"data": {
						"_": function (row) {
							return new Date(row.get('createdOn'));
						},
						"filter": "attributes.createdOn",
						"display": _.bind(function (row) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
						}, this)
					},
					"render": _.bind(function (data, type, row) {
						if (type === 'sort' || type === 'type') {
							return new Date(row.get('createdOn'));
						}

						let rowText = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
						if (row.get('viewedOn') == null && this.options.view === 'inbox') {
							return '<span class="font-weight-bold">' + rowText + '</span>';
						}
						else {
							return rowText;
						}
					}, this),
					"title": "Last Activity",
					"width": "20%"
				},
				{
					"title": '',
					"render": function () {
						if (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
							return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-message mr-1" title="View Message"><i class="fal fa-arrow-alt-from-left"></i></button><button type="button" class="btn btn-danger btn-delete-message" title="Delete Message"><i class="fal fa-trash"></i></button></div>';
						}
						else {
							return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-message mr-1" title="View Message"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
						}
					},
					"orderable": false,
					"searchable": false,
					"className": "text-center",
					"width": "80px"
				},
				{
					"data": "from.attributes.companyName",
					"visible": false
				},
				{
					"data": "attributes.userMessageType",
					"visible": false
				}
			],
			pageLength: 10,
			onRowDoubleClick: _.bind(function (row) {
				this.viewMessage(row.data());
			}, this)
		});

		this.refreshView()
	},
	refreshView: function () {
		let $inboxBtn = this.$('.btn-user-messages-inbox'),
			$sentBtn = this.$('.btn-user-messages-sent');
		if (this.options.view === 'inbox') {
			$inboxBtn.removeClass('text-muted');
			$sentBtn.addClass('text-muted');
		}
		else if (this.options.view === 'sent') {
			$sentBtn.removeClass('text-muted');
			$inboxBtn.addClass('text-muted');
		}

		this.collection = new PJQ.collections.userMessages.UserMessages(null, {
			project: this.options.project,
			view: this.options.view,
			userId: this.options.userId
		});
		this.collection.fetch({
			success: _.bind(function () {
				this.dataTable.resetData(this.collection.models);
			}, this)
		});
	},
	openInbox: function () {
		this.options.view = 'inbox';
		this.refreshView();
	},
	openSent: function () {
		this.options.view = 'sent';
		this.refreshView();
	},
	viewMessageClicked: function (e) {
		let message = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
		if (message != null) {
			this.viewMessage(message);
		}
	},
	viewMessage: function (message) {
		if (message.get('viewedOn') == null) {
			message.updateViewed();
			this.dataTable.refresh();
		}

		new PJQ.views.projects.UserMessageModal({
			project: this.options.project,
			model: message,
			onSend: _.bind(function () {
				this.refreshView();
			}, this)
		});
	},
	newMessageClicked: function () {
		new PJQ.views.projects.UserMessageModal({
			project: this.options.project,
			onSend: _.bind(function () {
				this.openSent();
			}, this)
		});
	},
	deleteMessageClicked: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			message = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this message?",
			onDelete: _.bind(function () {
				this.collection.remove(message);
				message.destroy();
				if (row != null) {
					this.dataTable.removeRow(row);
				}
			}, this)
		});
	}
});

PJQ.views.projects.UserMessageModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-User-Message'),
		maxWidth: '550px',
		onSend: _.noop,
		userMessage: null,
		userMessageTypeId: null
	},
	events: {
		'change select.user-message-type': 'userMessageTypeChanged',
		'keyup .user-message-body': 'valueChanged',
		'keyup .user-message-reply': 'replyChanged',
		'click .btn-reply': 'replyClicked',
		'keyup .user-message-bid-amount': 'valueChanged',
		'click .user-message-close': 'onClose',
		'click .user-message-send': 'onSend',
		'click .user-message-export': 'onExport'
	},
	beforeModalCreated: function () {
		if (this.model == null) {
			this.model = new PJQ.models.userMessages.UserMessage({
				project: this.options.project
			});
		}

		this.options.project.fetchUserMessageTypes(_.bind(function () {
			if (this.model.userMessageType == null) {
				if (this.options.userMessageTypeId != null) {
					this.model.userMessageType = this.options.project.userMessageTypes.get(this.options.userMessageTypeId);
				}

				// we check here in case the previous user message set was null
				if (this.model.userMessageType == null) {
					this.model.userMessageType = this.options.project.userMessageTypes.models[0];
				}
			}

			if (this.model.id > 0) {
				this.thread = new PJQ.collections.userMessages.UserMessageThread(null, {
					message: this.model
				});
				this.thread.fetch({
					success: _.bind(function () {
						if (_.size(this.thread.models) > 0) {
							this.model = _.sortBy(this.thread.models, function (model) {
								return model.id;
							})[0];
						}
						this.listenTo(this.model, 'sync', this.render);
						this.render();
					}, this)
				})
			}
			else {
				this.render();
			}
		}, this));
	},
	beforeRender: function () {
		this.renderData = {
			userMessage: this.model,
			userMessageTypes: this.options.project.userMessageTypes,
			thread: this.thread
		};
	},
	afterRender: function () {
		if (this.model.userMessageType != null) {
			if (this.model.isNew()) {
				new PJQ.inputs.Selectpicker({
					el: this.$('select.user-message-type'),
					defaultValue: this.model.userMessageType.id,
					isMultiple: false,
					onChange: _.bind(function (newValue) {
						this.model.userMessageType = this.options.project.userMessageTypes.get(newValue);
						this.render();
					}, this)
				});
			}
		}

		if ((this.model.isNew() || _.size(this.model.attachments.models) > 0) && this.$('.user-message-files').length > 0) {
			this.uploader = new PJQ.views.files.FileUploaderGrid({
				el: this.$('.user-message-files'),
				collection: this.model.attachments,
				canUpload: this.model.isNew(),
				canDelete: this.model.isNew(),
				onSuccess: _.bind(function (file) {
					this.valueChanged();
				}, this),
				afterDelete: _.bind(function () {
					this.valueChanged();
				}, this)
			});
		}

		if (!this.model.isNew()) {
			this.replyUploader = new PJQ.views.files.FileUploaderGrid({
				el: this.$('.uploader-reply'),
				style: 'list',
				isSmall: true
			});
		}
	},
	replyChanged: function (e) {
		this.$('.btn-reply').prop('disabled', _.size($(e.currentTarget).val()) === 0);
	},
	replyClicked: function () {
		let newMessage = new PJQ.models.userMessages.UserMessage({
			project: this.model.project,
			replyToMessageId: this.model.id,
			body: this.$('.user-message-reply').val(),
			attachments: this.replyUploader.collection.models
		});
		this.thread.add(newMessage);
		newMessage.save(null, {
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	valueChanged: function () {
		let canSend = true;
		if (this.model.userMessageType.get('isShowBidAmount') && _.size(this.$('.user-message-bid-amount').val()) === 0)
			canSend = false;
		if (!this.model.userMessageType.get('isAttachmentOnly') && _.size(this.$('.user-message-body').val()) === 0)
			canSend = false;
		if (this.model.userMessageType.get('isAttachmentOnly') && this.uploader.collection.length === 0)
			canSend = false;
		if (this.model.userMessageType.get('isAttachmentRequired') && this.uploader.collection.length === 0)
			canSend = false;

		this.$('.user-message-send').prop('disabled', !canSend);
	},
	onClose: function () {
		this.removeModal();
	},
	onSend: function () {
		// Disable send button to avoid double sending message
		this.$('.user-message-send').attr('disabled', 'true');

		if (this.model.userMessageType.get('isShowBidAmount'))
			this.model.set('bidAmount', parseInt(this.$('.user-message-bid-amount').val()));

		this.model.save({
			body: this.$('.user-message-body').val(),
		}, {
			success: _.bind(function () {
				this.removeModal();
				if (typeof this.options.onSend === 'function')
					this.options.onSend();
			}, this),
			error: _.bind(function(){
				//Re-enable if the message fails for some reason
				this.$('.user-message-send').attr('disabled', false);
			}, this)
		});
	},
	onExport: function() {
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'usermessages',
				value: this.model.id
			},
			{
				endpoint: 'thread'
			},
			{
				endpoint: 'export'
			}
		]));

	}
});

PJQ.views.projects.ProcorePublishModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Procore-Project-Publish'),
        width: '800px',
        minWidth: '800px',
        onPublish: _.noop,
        settings: null
    },
    events: {
        'click .publish' : 'publish'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        this.renderData = {
            settings: this.options.settings
        };
    },
    afterRender: function () {
        this.companyInput = new PJQ.inputs.Selectpicker({
            el: this.$('.procore-company'),
            isIntChoices: true,
            isDisabled: this.options.settings.companies.length === 1,
            defaultValue: this.options.settings.companies[0].id,
            onChange: _.bind(function (value) {
                let loader = new PJQ.Loader(this.$('.modal-body'));

                new PJQ.ajax.Request({
                    endpoint: '/procore/settings/' + value
                }).get().done(_.bind(function (response) {
                    if (loader != null)
                        loader.remove();
                    this.options.settings = response;
                    this.afterCompanyChanged();
                }, this)).fail(_.bind(function (xhr, err, result) {
                }, this));
            }, this)
        });

        this.$('.procore-project-name').val(PJQ.app.session.project.get('projectName'));

        this.startDateInput = new PJQ.inputs.Datepicker({
            el: this.$('.procore-est-start'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.app.session.project.get('startDate') ? PJQ.helpers.dateHelpers.parseDateString(PJQ.app.session.project.get('startDate'), false) : null
            }
        });

        this.completeDateInput = new PJQ.inputs.Datepicker({
            el: this.$('.procore-est-complete'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.app.session.project.get('endDate') ? PJQ.helpers.dateHelpers.parseDateString(PJQ.app.session.project.get('endDate'), false) : null
            }
        });

        this.projectAttachments = new PJQ.collections.projects.ProjectAttachments(null, {
            project: PJQ.app.session.project,
            isShared: true,
            isPrivate: true
        });

        this.projectAttachments.fetch({
            success: _.bind(function (attachments) {

                new PJQ.views.projects.ProjectAttachments({
                    el: this.$('.project-attachments'),
                    collection: attachments,
                    project: PJQ.app.session.project,
                    isHideDownload: true,
                    isHideDrawings: true,
                    isHideFiles: true,
                    hideEmptyFolders: true,
                    onChange: _.bind(function(attachments) {
                        this.options.selectedAttachments = attachments;
                    },this)
                });
            }, this)
        });

        this.afterCompanyChanged();
    },
    afterCompanyChanged: function() {

        if (this.options.settings.companyOffices.length === 1 && this.options.settings.companyOffices[0].id === null)
            this.options.settings.companyOffices = [];

        if (this.options.settings.companyOffices.length === 0) {
            this.$('.procore-company-office').closest('div.form-group').hide();
            if (this.companyOfficeInput)
                this.companyOfficeInput.setValue(null);
        }
        else {
            this.$('.procore-company-office').closest('div.form-group').show();
            if (!this.companyOfficeInput)
            {
                this.companyOfficeInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-company-office'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.companyOffices.length === 1,
                    choices: this.options.settings.companyOffices,
                    defaultValue: this.options.settings.companyOffices[0].id
                });
            }
            else
            {
                this.companyOfficeInput.updateChoices(this.options.settings.companyOffices);
                this.companyOfficeInput.setValue(this.options.settings.companyOffices[0].id);
            }
        }

        if (this.options.settings.programs.length === 1 && this.options.settings.programs[0].id === null)
            this.options.settings.programs = [];

        if (this.options.settings.programs.length === 0) {
            this.$('.procore-project-program').closest('div.form-group').hide();
            if (this.projectProgramInput)
                this.projectProgramInput.setValue(null);
        }
        else {
            this.$('.procore-project-program').closest('div.form-group').show();
            if (!this.projectProgramInput)
            {
                this.projectProgramInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-program'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.programs.length === 1,
                    choices: this.options.settings.programs,
                    defaultValue: this.options.settings.programs[0].id
                });
            }
            else
            {
                this.projectProgramInput.updateChoices(this.options.settings.programs);
                this.projectProgramInput.setValue(this.options.settings.programs[0].id);
            }
        }

        if (this.options.settings.projectTemplates.length === 1 && this.options.settings.projectTemplates[0].id === null)
            this.options.settings.projectTemplates = [];

        if (this.options.settings.projectTemplates.length === 0) {
            this.$('.procore-project-template').closest('div.form-group').hide();
            if (this.projectTemplateInput)
                this.projectTemplateInput.setValue(null);
        }
        else {
            this.$('.procore-project-template').closest('div.form-group').show();
            if (!this.projectTemplateInput)
            {
                this.projectTemplateInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-template'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.projectTemplates.length === 1,
                    choices: this.options.settings.projectTemplates,
                    defaultValue: this.options.settings.projectTemplates[0].id
                });
            }
            else
            {
                this.projectTemplateInput.updateChoices(this.options.settings.projectTemplates);
                this.projectTemplateInput.setValue(this.options.settings.projectTemplates[0].id);
            }
        }

        if (this.options.settings.projectTypes.length === 1 && this.options.settings.projectTypes[0].id === null)
            this.options.settings.projectTypes = [];

        if (this.options.settings.projectTypes.length === 0) {
            this.$('.procore-project-type').closest('div.form-group').hide();
            if (this.projectTypeInput)
                this.projectTypeInput.setValue(null);
        }
        else {
            this.$('.procore-project-type').closest('div.form-group').show();
            if (!this.projectTypeInput)
            {
                this.projectTypeInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-type'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.projectTypes.length === 1,
                    choices: this.options.settings.projectTypes,
                    defaultValue: this.options.settings.projectTypes[0].id
                });
            }
            else
            {
                this.projectTypeInput.updateChoices(this.options.settings.projectTypes);
                this.projectTypeInput.setValue(this.options.settings.projectTypes[0].id);
            }
        }

        if (this.options.settings.projectStages.length === 1 && this.options.settings.projectStages[0].id === null)
            this.options.settings.projectStages = [];

        if (this.options.settings.projectStages.length === 0) {
            this.$('.procore-project-stage').closest('div.form-group').hide();
            if (this.projectStageInput)
                this.projectStageInput.setValue(null);
        }
        else {
            this.$('.procore-project-stage').closest('div.form-group').show();
            if (!this.projectStageInput)
            {
                this.projectStageInput = new PJQ.inputs.Selectpicker({
                    el: this.$('.procore-project-stage'),
                    isIntChoices: true,
                    isDisabled: this.options.settings.projectStages.length === 1,
                    choices: this.options.settings.projectStages,
                    defaultValue: this.options.settings.projectStages[0].id
                });
            }
            else
            {
                this.projectStageInput.updateChoices(this.options.settings.projectStages);
                this.projectStageInput.setValue(this.options.settings.projectStages[0].id);
            }
        }
    },
    publish: function() {
        let projectAddress = PJQ.app.session.project.get('address1');

        if (PJQ.app.session.project.get('address2')) {

            if (projectAddress)
                projectAddress += ' ';

            projectAddress += PJQ.app.session.project.get('address2');
        }

        let office_id = 0;
        if (this.companyOfficeInput && this.companyOfficeInput.getValue())
            office_id = this.companyOfficeInput.getValue();

        let project_stage_id = 0;
        if (this.projectStageInput && this.projectStageInput.getValue())
            project_stage_id = this.projectStageInput.getValue();

        let program_id = 0;
        if (this.projectProgramInput && this.projectProgramInput.getValue())
            program_id = this.projectProgramInput.getValue();

        let project_type_id = 0;
        if (this.projectTypeInput && this.projectTypeInput.getValue())
            project_type_id = this.projectTypeInput.getValue();

        let project_template_id = 0;
        if (this.projectTemplateInput && this.projectTemplateInput.getValue())
            project_template_id = this.projectTemplateInput.getValue();

        let square_feet = 0;
        if (_.size(PJQ.helpers.formatHelpers.numbersOnly(this.$('.procore-square-feet'))) > 0) {
            square_feet = parseInt(PJQ.helpers.formatHelpers.numbersOnly(this.$('.procore-square-feet')));
        }

        let attachments = [];
        if (this.options.selectedAttachments)
            _.map(this.options.selectedAttachments.models, function(attachment) { return attachment.get('entryId'); });

        let postData = {
            company_id: this.companyInput.getValue(),
            name: this.$('.procore-project-name').val().trim(),
            project_number: this.$('.procore-project-number').val().toString().trim(),
            address: projectAddress,
            city: PJQ.app.session.project.get('city').trim(),
            zip: PJQ.app.session.project.get('zip').trim(),
            state_code: PJQ.app.session.project.get('state'),
            country_code: PJQ.app.session.project.get('country'),
            description: '',
            public_notes: '',
            est_start_date: this.startDateInput.getValue() ? PJQ.helpers.dateHelpers.getDateString(this.startDateInput.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE) : '',
            est_completion_date: this.completeDateInput.getValue() ? PJQ.helpers.dateHelpers.getDateString(this.completeDateInput.getValue(), PJQ.helpers.dateHelpers.dateFormats.DATE) : '',
            square_feet: square_feet,
            phone: '',
            flagColor: '',
            office_id: office_id,
            project_stage_id: project_stage_id,
            program_id: program_id,
            project_type_id: project_type_id,
            project_template_id: project_template_id,
            documentListPublic: attachments.join(','),
            documentListPrivate: '',
            isSyncProjectContactVendors: this.$('.procore-sync-contacts').is(':checked')
        };


        new PJQ.ajax.Request({
            endpoint: '/procore/projects',
            data: postData
        }).post().done(_.bind(function (data) {
            PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id, {
                trigger: true
            });
            this.removeModal();
            new PJQ.views.BaseModal({
                header: "Procore Project",
                body: '<a href="https://api.procore.com/'+data+'/project/home" target="_blank">Click here</a> to open your Procore project in a new window.'
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong.'
            });
        }, this));



    }
});

PJQ.views.projects.dashboard = {};

PJQ.views.projects.ProjectDashboard = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Dashboard')
    },
    events: {
        'click .btn-alert-order-prints': 'orderPrints',
        'click .stack-takeoff': 'stackTakeoff',
        'click .square-takeoff': 'squareTakeoff',
        'click .e-takeoff': 'eTakeoff',
        'click .btn-update-my-info': 'updateMyInfo',
        'click .btn-submit-bid': 'submitBidMessage',
        'click .btn-feature-settings': 'viewFeatureSettings'
    },
    beforeFirstRender: function () {
        if (this.model == null) {
            this.model = PJQ.app.session.project;
        }

        if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)) {
            this.model.fetchBidPackages(_.bind(function (bp) {
                this.bidPackages = bp;
                this.render();
            }, this));
        }
    },
    renderData: function () {
        return {
            model: this.model,
            isAdmin: (PJQ.app.session.get('masterUserId') === this.model.get('masterUserId')),
            showBidPackages: this.showBidPackages()
        };
    },
    showBidPackages: function () {
        return this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)
            && this.bidPackages != null
            && _.size(_.filter(this.bidPackages.models, function (bidPackage) {
                let n = bidPackage.get('notes');
                return n != null && _.size(n.trim()) > 0;
            })) > 0;
    },
    afterRender: function () {
        if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)) {
            if (this.bidPackages == null) {
                return;
            }
        }
        let showBidPackages = this.showBidPackages(),
            device = PJQ.helpers.mobile.getDevice();
        if (device != null) {
            new PJQ.views.mobile.AppDownloadModal();
        }

        if (showBidPackages) {
            this.renderBidPackages();
        }

        this.model.fetchUserMessageTypes(_.bind(function () {
            if ((PJQ.app.session.get('masterUserId') === this.model.get('masterUserId'))) {
                new PJQ.views.projects.dashboard.ProjectStats({
                    el: this.$('.project-stats'),
                    project: this.model,
                    dashboard: this,
                    emptyCallback: _.bind(function () {
                        this.$('.project-stats-row').remove();
                    }, this)
                });

                new PJQ.views.projects.dashboard.Newsfeed({
                    el: this.$('.project-newsfeed'),
                    project: this.model,
                    dashboard: this
                });
            }
            else {
                // sub command buttons
                this.inviteHeader = new PJQ.views.projects.dashboard.ProjectInviteHeader({
                    el: this.$('.project-invite-header'),
                    project: this.model,
                    dashboard: this,
                    afterRender: _.bind(function () {
                        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'inviteHeader')) {
                            let cb = PJQ.app.portal.customization.project.inviteHeader.afterRender;
                            if (typeof cb === 'function') {
                                cb();
                            }
                        }

                        if (PJQ.app.session.get('submitBid')) {
                            this.submitBidMessage();
                        }
                    }, this)
                });

                new PJQ.views.projects.dashboard.ProjectDetails({
                    el: this.$('.project-details'),
                    model: this.model,
                    afterRender: function () {
                        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'details')) {
                            let cb = PJQ.app.portal.customization.project.details.afterRender;
                            if (typeof cb === 'function') {
                                cb();
                            }
                        }
                    }
                });

                if (this.model.user != null) {
                    new PJQ.views.projects.dashboard.ProjectContactDetails({
                        el: this.$('.project-contact-details'),
                        model: this.model.user,
                        project: this.model
                    });
                }

                if (PJQ.app.session.contact != null) {
                    new PJQ.views.projects.dashboard.ProjectMessagesSub({
                        el: this.$('.project-messages-sub'),
                        project: this.model,
                        dashboard: this
                    });
                }
            }

            if (PJQ.app.session.get('masterUserId') !== this.model.get('masterUserId')
                || this.model.hasPermission('attachments.canView')) {
                this.$('.col-attachments').removeClass('hidden');
                new PJQ.views.projects.ProjectAttachments({
                    el: this.$('.project-attachments'),
                    project: this.model,
                    isHideEmptyFolders: true
                });
            }
        }, this));
    },
    renderBidPackages: function () {
        if (this.bidPackages != null) {
            new PJQ.views.projects.dashboard.BidPackages({
                el: this.$('.bid-packages'),
                collection: this.bidPackages
            });
        }
    },
    orderPrints: function () {
        new PJQ.views.files.OrderPrintsModal({
            contact: PJQ.app.session.contact
        });
    },
    updateMyInfo: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                id: PJQ.app.session.contact.id,
                projectId: this.model.id
            })
        });
    },
    viewFeatureSettings: function() {
        new PJQ.views.featureSettings.FeatureSettingsModal({
            model: new PJQ.models.featureSettings.FeatureSetting(PJQ.app.session.project.get('featureSettings'), {project: PJQ.app.session.project}),
            project: PJQ.app.session.project
        });
    },
    stackTakeoff: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.model.id
            },
            {
                endpoint: 'contacts',
                value: PJQ.app.session.contact.id
            },
            {
                endpoint: 'stackurl'
            }
        ]);
        let request = new PJQ.ajax.Request({
            endpoint: endpoint
        });
        request.get().done(_.bind(function (data) {
            window.location.href = data;
        }, this)).fail(function () {
            //error();
        });
    },
    squareTakeoff: function () {
        new PJQ.views.projects.SquareTakeoffModal();
    },
    eTakeoff: function () {
        new PJQ.views.projects.eTakeoffModal({
            contact: PJQ.app.session.contact,
            project: PJQ.app.session.project,
            accessKey: PJQ.app.session.get('accessKey')
        });
    },
    submitBidMessage: function () {
        let messageTypeId = this.$('.btn-submit-bid').data('messageTypeId');
        if (messageTypeId > 0) {
            new PJQ.views.projects.UserMessageModal({
                project: this.model,
                userMessageTypeId: messageTypeId,
                onSend: _.bind(function () {
                    if (PJQ.app.session.project.hasPermission('privateMessaging.canView') &&
                        !(PJQ.app.session.project.get('status') === 'ARCHIVE'
                            || PJQ.app.session.project.get('status') === 'NEW'
                            || (PJQ.app.session.user === null && PJQ.app.session.contact === null)
                            || PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PRIVATE_MESSAGES))) {
                        PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id + '/privatemessaging/view/sent', {
                            trigger: true
                        });
                    }
                    PJQ.notifications.notify.successNotify({
                        message: 'Bid Submitted successfully.'
                    });
                }, this)
            });
        }
    }
});

PJQ.views.projects.dashboard.ProjectDetails = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Details-Dashboard')
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {

    }
});

PJQ.views.projects.dashboard.ProjectContactDetails = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Contact-Details-Dashboard')
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {

    }
});

PJQ.views.projects.dashboard.ProjectProposals = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Proposals')
    },
    events: {
        // 'click .group-status-close': 'onClose'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {

    }
});

// Newsfeed
PJQ.views.projects.dashboard.Newsfeed = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Newsfeed'),
        subTemplates: {
            newsfeedItems: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Newsfeed-Items')
        },
        pageNumber: 1,
        pageSize: 10
    },
    events: {
        'click .btn-project-newsfeed-refresh': 'refreshNewsfeed',
        'click .btn-project-newsfeed-view-message-participants': 'viewMessageParticipants',
        'click .btn-project-newsfeed-view-attachments': 'viewAttachments',
        'click .btn-project-newsfeed-copy-message': 'copyMessage',
        'click .btn-project-newsfeed-delete-message': 'deleteMessage'
    },
    beforeFirstRender: function () {

    },
    beforeRender: function () {

    },
    afterRender: function () {
        this.getNewsfeed(this.options.pageNumber);
    },
    refreshNewsfeed: function () {
        this.options.pageNumber = 1;
        this.$('.project-newsfeed-items').html('');
        this.getNewsfeed(this.options.pageNumber);
    },
    getNewsfeed: function (pageNumber) {
        let loader = new PJQ.Loader(this.$('.project-newsfeed-items'));
        this.data = [];
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'newsfeed'
                },
            ], [
                {
                    parameter: 'pageNumber',
                    value: pageNumber
                },
                {
                    parameter: 'pageSize',
                    value: 9999
                }
            ])
        }).get().done(_.bind(function (data) {
            this.data = data;
            loader.remove();
            this.renderSubTemplate(true, this.options.subTemplates.newsfeedItems, this.$('.project-newsfeed-items'), {
                items: data,
                isAdmin: (PJQ.app.session.get('masterUserId') === this.options.project.get('masterUserId'))
            });
        }, this));
    },
    viewAttachments: function (e) {
        let projectMessageId = parseInt(this.$(e.currentTarget).data('projectMessageId'));
        _.each(this.data, _.bind(function (item) {
            if (item.auditAction === 'ProjectMessage' && item.projectMessage && item.projectMessage.projectMessageId === projectMessageId) {
                new PJQ.views.projects.dashboard.ViewMessageAttachmentsModal({
                    attachments: item.attachments
                });
            }
        }, this));
    },
    viewMessageParticipants: function (e) {
        let projectMessageId = parseInt(this.$(e.currentTarget).data('projectMessageId'));
        PJQ.app.router.navigate('projects/' + this.options.project.id + (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW) ? '/messagingnew/' : '/messaging/') + projectMessageId, {
            trigger: true
        });
    },
    copyMessage: function (e) {
        let projectMessageId = parseInt(this.$(e.currentTarget).data('projectMessageId'));
        PJQ.app.router.navigate('projects/' + this.options.project.id + (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW) ? '/messagingnew/' : '/messaging/') + projectMessageId + '/copy', {
            trigger: true
        });
    },
    deleteMessage: function (e) {
        let auditLogId = parseInt(this.$(e.currentTarget).data('auditLogId'));
        new PJQ.views.BaseModal({
            header: 'Confirm Delete',
            body: '<div class="text-dark fs-14">Are you sure you want to delete this message and recipient responses?</div>',
            okButtonText: 'Yes',
            onOk: _.bind(function () {
                if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_WALL_MESSAGING_NEW)) {
                    let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'projects',
                            value: PJQ.app.session.project.id
                        },
                        {
                            endpoint: 'projectmessages',
                            value: parseInt(this.$(e.currentTarget).data('projectMessageId'))
                        }
                    ]);
                    new PJQ.ajax.Request({
                        endpoint: endpoint
                    }).delete().done(_.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Message deleted successfully.'
                        });
                        this.refreshNewsfeed();
                    }, this)).fail(function () {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Something went wrong!'
                        });
                    });

                } else {
                    selectedCommentId = auditLogId;
                    DeleteProjectMessageByCommentId(_.bind(function () {
                        this.refreshNewsfeed();
                    }, this));
                }
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "No"
        });
    }
});

// Admin Project Stats
PJQ.views.projects.dashboard.ProjectStats = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Stats'),
        subTemplates: {
            statItem: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Stats-Item')
        },
        emptyCallback: null
    },
    events: {},
    beforeFirstRender: function () {

    },
    beforeRender: function () {

    },
    afterRender: function () {
        this.getProjectStats();
    },
    getProjectStats: function () {
        let loader = new PJQ.Loader(this.$('.project-stats-items'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'stats'
                },
            ])
        }).get().done(_.bind(function (data) {
            loader.remove();

            if (data == null || _.size(data.projectStats) === 0) {
                if (typeof this.options.emptyCallback === 'function') {
                    this.options.emptyCallback();
                    return;
                }
            }

            _.each(data.projectStats, _.bind(function (stats) {
                let labels = [],
                    graphSet = {
                        data: [],
                        backgroundColor: []
                    };
                _.each(stats.datasets, function (dataset) {
                    labels.push(PJQ.helpers.formatHelpers.upperCaseFirstLetterEachWord(dataset.label));
                    graphSet.data.push(dataset.count);
                    graphSet.backgroundColor.push(dataset.color);
                });

                this.renderSubTemplate(true, this.options.subTemplates.statItem, this.$('.project-stats-items'), {
                    stats: stats
                }, _.bind(function ($chart) {
                    new PJQ.charts.Chart($chart.find('.project-stat-chart'), {
                        type: 'doughnut',
                        height: 150,
                        width: 150,
                        showTotal: true,
                        total: stats.total,
                        data: {
                            labels: labels,
                            datasets: [
                                graphSet
                            ]
                        },
                        options: {
                            cutoutPercentage: 70,
                            legend: {
                                display: false
                            }
                        },
                        onClick: _.bind(function (clickedSegments) {
                            if (_.size(clickedSegments) > 0) {
                                let segment = clickedSegments[0],
                                    stat = stats.datasets[segment._index];
                                PJQ.app.router.navigate('projects/' + this.options.project.id + '/' + stat.route, {
                                    trigger: true
                                });
                            }
                        }, this)
                    });
                }, this));
            }, this));

        }, this));
    }
});

PJQ.views.projects.dashboard.ProjectInviteHeader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Invite-Header'),
    },
    events: {
        'click .send-user-message': 'sendUserMessage'
    },
    beforeFirstRender: function () {
        if (this.options.project != null) {
            this.options.project.getCompanyLogoUrl(_.bind(function () {
                this.render();
            }, this));
            return false;
        }
    },
    beforeRender: function () {
        this.renderData = {
            options: this.options,
            hideBidsDue: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_HIDE_BIDS_DUE)
        }
    },
    afterRender: function () {
        if (PJQ.app.session.contact != null) {
            let projectResponseButtons = [];
            _.each(this.options.project.getProjectStatusList(), _.bind(function (status, index) {
                let colorClass = 'info';
                if (index === 0)
                    colorClass = 'success';
                else if (index === 1)
                    colorClass = 'danger';

                if (status[1]) {
                    projectResponseButtons.push({label: status[0], value: status[0], colorClass: colorClass});
                }
            }, this));

            _.each(this.options.project.userMessageTypes.models, _.bind(function (type) {
                if (type.get('isAlwaysVisible')) {
                    this.$('.user-messages').removeClass('hidden');
                }
            }, this));
        }
    },
    sendUserMessage: function (e) {
        new PJQ.views.projects.UserMessageModal({
            project: this.options.project,
            userMessageTypeId: this.$(e.currentTarget).data('userMessageTypeId'),
            onSend: _.bind(function () {
                this.refresh();
            }, this)
        });
    }
});

// Sub Project Messages
PJQ.views.projects.dashboard.ProjectMessagesSub = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Messages-Sub'),
        subTemplates: {
            messageItems: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Messages-Sub-Items')
        }
    },
    events: {
        'click .project-message>.card-header': 'stopPropagationIfSelected',
        'click .project-message .btn-download-attachment': 'downloadAttachment',
        'shown.bs.collapse .project-message .collapse': 'messageShown'
    },
    beforeFirstRender: function () {
        this.options.project.fetchProjectMessageResponses(_.bind(function (responses) {
            this.model = responses;
            this.render();
        }, this));
    },
    afterRender: function () {
        if (this.model && this.model.isFetched) {
            let projectStatuses = this.options.project.getProjectStatusList();
            this.renderSubTemplate(true, this.options.subTemplates.messageItems, this.$('.project-message-items'), {
                model: this.model,
                projectStatuses: projectStatuses
            }, _.bind(function () {
                this.projectResponseButtons = [];
                _.each(projectStatuses, _.bind(function (status, index) {
                    let colorClass = 'info';
                    if (index === 0) {
                        colorClass = 'success';
                    } else if (index === 1) {
                        colorClass = 'danger';
                    }
                    if (status[1]) {
                        this.projectResponseButtons.push({
                            label: status[0],
                            value: status[0],
                            colorClass: colorClass
                        });
                    }
                }, this));

                this.messageResponseButtons = [];
                _.each(this.options.project.getMessageStatusList(), _.bind(function (status, index) {
                    let colorClass = 'info';
                    if (index === 0)
                        colorClass = 'success';
                    else if (index === 1)
                        colorClass = 'danger';

                    if (status[1]) {
                        this.messageResponseButtons.push({
                            label: status[0],
                            value: status[0],
                            colorClass: colorClass
                        });
                    }
                }, this));
                if (_.size(this.model.messages.models) > 0) {
                    _.each(this.model.messages.models, function (model) {
                        this.renderMessageResponseButton(model);
                    }, this);

                    // try to open the message matching the key they came in with
                    let contextMessage = this.model.getContextMessage();
                    contextMessage = this.setContextMessage(contextMessage);
                    if (contextMessage != null) {
                        this.$('#project-messages-sub-' + contextMessage.get('accessKey')).collapse('show');

                        let urlStatus = PJQ.app.session.get('bidStatus');
                        if (_.size(urlStatus) > 0) {
                            PJQ.app.session.set('bidStatus', null);
                            // make sure the status in the url was a valid status
                            let actualStatus = _.find(_.union(PJQ.app.session.project.getProjectStatusList(), [['YES', true], ['NO', true]]), function (status) {
                                return status[0].toUpperCase() === urlStatus.toUpperCase();
                            });
                            if (actualStatus != null) {
                                this.handleResponse(contextMessage, actualStatus[0]);
                                this.render();
                            }
                        }
                    }
                } else {
                    this.renderContextMessageResponseButton();
                }

                this.$('#projectMessagesSubAccordion').on('shown.bs.collapse', function () {
                    $(this).parent().find(".card-header[aria-expanded='true'] .fa-chevron-down").removeClass("fa-chevron-down").addClass("fa-chevron-right");
                    $(this).parent().find(".card-header[aria-expanded='false'] .fa-chevron-right").removeClass("fa-chevron-right").addClass("fa-chevron-down");
                });
            }, this));
        } else {
            new PJQ.Loader(this.$('.project-message-items'));
        }
    },
    setContextMessage: function (selectedMessage) {
        let contextMessage = null;
        if (selectedMessage != null && selectedMessage.canChangeStatus()) {
            contextMessage = selectedMessage;
        }

        if (contextMessage == null) {
            let noResponseMessages = this.model.messages.getChangeableMessages();
            if (_.size(noResponseMessages) > 0) {
                contextMessage = _.max(noResponseMessages, function (item) {
                    return PJQ.helpers.dateHelpers.getDateDiff(new Date(), new Date(item.get('createdOn')));
                });
            }
        }

        if (contextMessage == null) {
            if (_.size(this.model.messages) > 0) {
                contextMessage = _.max(this.model.messages.models, function (item) {
                    return PJQ.helpers.dateHelpers.getDateDiff(new Date(), new Date(item.get('createdOn')));
                });
            }
        }

        this.renderContextMessageResponseButton(contextMessage);

        return contextMessage;
    },
    getMessageElement: function (message) {
        return $('div.card[data-access-key="' + message.get('accessKey') + '"]');
    },
    messageShown: function (e) {
        let accessKey = $(e.currentTarget).data('accessKey').toString(),
            selectedMessage = this.model.messages.findWhere({accessKey: accessKey.toUpperCase()});
        this.setContextMessage(selectedMessage);
    },
    handleResponse: function (message, response) {
        // if they have more than one group, collect responses per group
        let messageType = message.get('type');

        // 2023-08-14 do not check the message type anymore, since bid reminders get sent with no message type but have response buttons in them
        //if (messageType === 'PROJECT' || messageType === 'MESSAGE') {
        message.set('status', response);
        //}

        if (messageType != 'MESSAGE' && this.model.contactGroups.models.length > 1) {
            new PJQ.views.projects.dashboard.GetGroupResponsesSubModal({
                contactGroups: this.model.contactGroups,
                accessKey: message.get('accessKey'),
                onSave: _.bind(function (result) {
                    // todo: update project contact accordingly so that other views can process the change
                    if (message.responseButton)
                        message.responseButton.setValue(result.response);

                    if (this.contextResponseControl)
                        this.contextResponseControl.setValue(result.response);

                    PJQ.notifications.notify.successNotify({
                        message: 'Your response of ' + result.response + ' has been recorded.'
                    });
                    this.checkDeclinedResponseQuestion(result.response, message.get('accessKey'));
                }, this)
            });
        } else {
            // just save the overall response
            let contactGroups = new PJQ.collections.projectMessages.ProjectContactGroups(),
                contactGroup = new PJQ.models.projectMessages.ProjectContactGroup();

            contactGroup.set('groupStatus', response);
            contactGroups.add(contactGroup);
            contactGroups.accessKey = message.get('accessKey');

            contactGroups.save({
                success: _.bind(function (result) {
                    if (this.contextResponseControl != null) {
                        this.contextResponseControl.setValue(result.response);
                    }

                    PJQ.notifications.notify.successNotify({
                        message: 'Your response of ' + result.response + ' has been recorded.'
                    });

                    if (messageType != 'MESSAGE')
                        this.checkDeclinedResponseQuestion(result.response, message.get('accessKey'));
                }, this)
            });
        }
    },
    checkDeclinedResponseQuestion: function(response, accessKey) {
        if (!PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_MESSAGE_DECLINE_QUESTION))
            return;

        PJQ.app.session.project.getProjectStatuses(_.bind(function(statuses) {
            if (response === statuses[1].name) {
                let declineQuestionSettings = new PJQ.models.projectParticipants.ProjectMessageDeclineQuestionSettings(null, {
                    project: PJQ.app.session.project
                });

                declineQuestionSettings.fetch({
                    success: _.bind(function() {

                        let projectLocation = '';
                        if (PJQ.app.session.project.get('city'))
                            projectLocation = PJQ.app.session.project.get('city');
                        if (PJQ.app.session.project.get('state'))
                            projectLocation += (PJQ.app.session.project.get('city') ? ', ' : '') + PJQ.app.session.project.get('state');
                        if (PJQ.app.session.project.get('zip'))
                            projectLocation += (_.size(projectLocation)>0 ? ' ' : '') + PJQ.app.session.project.get('zip');

                        if (_.size(projectLocation) == 0)
                            projectLocation = "N/A";

                        let recipientGroups = _.map(this.model.contactGroups.models, function(contactGroup) {
                            return contactGroup.get('groupName');
                        });

                        let companyName =  _.size(PJQ.app.session.project.user.get('companyName')) > 0 ? PJQ.app.session.project.user.get('companyName') : PJQ.app.session.project.user.get('contactName');

                        let questions = _.map(declineQuestionSettings.get('questions'), _.bind(function(question) {
                            question = question.replace(/\[Project.Location\]/g, projectLocation);
                            question = question.replace(/\[ProjectMessage.RecipientGroupListComma\]/g, recipientGroups.join(', '));
                            question = question.replace(/\[Sender.CompanyName\]/g, companyName);

                            return question;

                        }, this));

                        new PJQ.views.projects.dashboard.ProjectMessageDeclineQuestionModal({
                            questions: questions,
                            accessKey: accessKey,
                            response: response
                        });

                    }, this)
                });
            }
        }, this));
    },
    renderMessageResponseButton: function (message) {
        if (message.canChangeStatus()) {
            message.responseButton = new PJQ.inputs.ButtonGroup({
                el: this.getMessageElement(message).find('.message-responses'),
                colorInactiveButtons: true,
                buttonClasses: 'font-weight-bold',
                separateButtons: true,
                buttons: message.get('type') === 'PROJECT' ? this.projectResponseButtons : this.messageResponseButtons,
                defaultValue: (_.size(message.get('status')) > 0 && message.get('status') !== 'PENDING') ? message.get('status') : null,
                onChange: _.bind(function (value) {
                    if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_CONTACT_UPDATE_REQ) && PJQ.app.session.contact.get('updatedOn') == null) {
                        new PJQ.views.contacts.BaseEditContactModal({
                            alert: "You must update your contact information before Responding.",
                            onSave: _.bind(function () {
                                PJQ.app.session.contact.set('updatedOn', new Date());
                                this.contextResponseControl.setValue(value);
                                this.handleResponse(message, value);
                            }, this),
                            model: new PJQ.models.projectContacts.ProjectContact({
                                id: PJQ.app.session.contact.id,
                                projectId: PJQ.app.session.project.id
                            })
                        });
                    } else {
                        this.contextResponseControl.setValue(value);
                        this.handleResponse(message, value);
                    }
                }, this)
            });
        }
    },
    renderContextMessageResponseButton: function (message) {
        if (this.contextResponseControl != null) {
            this.contextResponseControl.remove();
        }
        if (message != null && message.canChangeStatus()) {
            this.contextResponseControl = new PJQ.inputs.ButtonGroup({
                el: this.options.dashboard.inviteHeader.$('.responses-control'),
                colorInactiveButtons: true,
                buttonClasses: 'font-weight-bold',
                separateButtons: true,
                buttons: message.get('type') === 'PROJECT' ? this.projectResponseButtons : this.messageResponseButtons,
                defaultValue: (_.size(message.get('status')) > 0 && message.get('status') !== 'PENDING') ? message.get('status') : null,
                onChange: _.bind(function (value) {
                    if (message.responseButton != null) {
                        message.responseButton.setValue(value, true);
                    }
                }, this)
            });
        } else if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SUB_RESPONSE) && message && message.canChangeStatus()) {
            this.contextResponseControl = new PJQ.inputs.ButtonGroup({
                el: this.options.dashboard.inviteHeader.$('.responses-control'),
                colorInactiveButtons: true,
                buttonClasses: 'font-weight-bold',
                separateButtons: true,
                buttons: this.projectResponseButtons,
                defaultValue: (_.size(this.options.project.get('bidResponse')) > 0 && this.options.project.get('bidResponse') !== 'PENDING') ? this.options.project.get('bidResponse') : null,
                onChange: _.bind(function (value) {
                    this.options.project.updateResponse(value, _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Your response of ' + value + ' has been recorded.'
                        });
                        this.checkDeclinedResponseQuestion(value, message.get('accessKey'));
                    }, this));
                }, this)
            });
        } else {
            this.options.dashboard.inviteHeader.$('.response-header').addClass('hidden');
        }
    },
    stopPropagationIfSelected: function (e) {
        if ($(e.currentTarget).attr('aria-expanded') === 'true')
            e.stopPropagation();
    },
    downloadAttachment: function (e) {
        let accessKey = $(e.currentTarget).closest('.collapse').data('accessKey').toString(),
            cid = $(e.currentTarget).data('cid'),
            message = this.model.messages.findWhere({accessKey: accessKey.toUpperCase()});

        let attachment = message.attachments.get(cid);
        this.options.project.downloadAttachments(attachment);
    }
});

PJQ.views.projects.dashboard.GetGroupResponsesSubModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Contact-Group-Status-Sub'),
        minWidth: '50%',
        onSave: _.noop,
        contactGroups: null
    },
    events: {
        'click .group-status-close': 'onClose',
        'click .group-status-save': 'onSave'
    },
    beforeRender: function () {
        this.renderData = {
            groups: this.options.contactGroups.models
        };
    },
    afterRender: function () {
        this.projectResponseButtons = [];
        _.each(PJQ.app.session.project.getProjectStatusList(), _.bind(function (status, index) {
            let colorClass = 'info';
            if (index === 0) {
                colorClass = 'success';
            } else if (index === 1) {
                colorClass = 'danger';
            }
            if (status[1]) {
                this.projectResponseButtons.push({
                    label: status[0],
                    value: status[0],
                    colorClass: colorClass
                });
            }
        }, this));

        this.globalResponse = new PJQ.inputs.ButtonGroup({
            el: this.$('.global-response'),
            colorInactiveButtons: true,
            buttons: this.projectResponseButtons,
            defaultValue: null,
            onChange: _.bind(function (value) {
                _.each(this.options.contactGroups.models, _.bind(function (group) {
                    group.groupResponse.setValue(value);
                    group.set('groupStatus', value);
                    this.setSaveButton();
                }, this));
            }, this)
        });

        _.each(this.options.contactGroups.models, _.bind(function (group) {
            group.groupResponse = new PJQ.inputs.ButtonGroup({
                el: this.getGroupElement(group).find('.group-response'),
                colorInactiveButtons: true,
                buttons: this.projectResponseButtons,
                defaultValue: null,
                onChange: _.bind(function (value) {
                    group.set('groupStatus', value);
                    this.setSaveButton();
                }, this)
            });
        }, this));
    },
    getGroupElement: function (group) {
        return $('div.group-response-container[data-group-id="' + group.get('groupId') + '"]');
    },
    setSaveButton: function () {
        this.$('.group-status-save').attr('disabled', false);
        _.each(this.options.contactGroups.models, _.bind(function (group) {
            if (_.size(group.groupResponse.getValue()) === 0)
                this.$('.group-status-save').attr('disabled', true);
        }, this));

    },
    onClose: function () {
        this.removeModal();
    },
    onSave: function () {
        this.options.contactGroups.accessKey = this.options.accessKey;
        this.options.contactGroups.save({
            success: _.bind(function (result) {

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(result);

                this.removeModal();

            }, this)
        });
    }
});

PJQ.views.projects.DownloadTermsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Download-Terms'),
        maxWidth: '600px',
        minHeight: '500px',
        onAccept: null
    },
    events: {
        'click .terms-accept': 'onAcceptClicked',
    },
    renderData: function () {
        return {
            project: this.options.project
        };
    },
    onAcceptClicked: function () {
        this.options.project.set('downloadTermsAgreed', true);
        if (typeof this.options.onAccept === 'function') {
            this.options.onAccept();
        }

        if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_TERMS_SIGNATURE_REQ)) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.options.project.id
                    },
                    {
                        endpoint: 'downloadterms'
                    },
                    {
                        endpoint: 'sign'
                    }
                ]),
                data: {
                    companyName: this.$('.input-terms-company-name').val(),
                    contactName: this.$('.input-terms-contact-name').val(),
                    title: this.$('.input-terms-title').val(),
                    email: this.$('.input-terms-email').val()
                },
            }).put();
        }
        this.removeModal();
    }
});

PJQ.views.projects.ProjectMessageResponseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Message-Response'),
        maxWidth: '600px',
        minHeight: '500px',
        onResponse: null
    },
    afterRender: function () {
        let projectResponseButtons = [];
        _.each(this.options.project.getProjectStatusList(), _.bind(function (status, index) {
            let colorClass = 'info';
            if (index === 0)
                colorClass = 'success';
            else if (index === 1)
                colorClass = 'danger';

            if (status[1]) {
                projectResponseButtons.push({label: status[0], value: status[0], colorClass: colorClass});
            }
        }, this));
        this.contextResponseControl = new PJQ.inputs.ButtonGroup({
            el: this.$('.responses-control'),
            colorInactiveButtons: true,
            buttonClasses: 'font-weight-bold',
            separateButtons: true,
            buttons: projectResponseButtons,
            defaultValue: (_.size(this.options.project.get('bidResponse')) > 0 && this.options.project.get('bidResponse') !== 'PENDING') ? this.options.project.get('bidResponse') : null,
            onChange: _.bind(function (value) {
                this.options.project.updateResponse(value, _.bind(function () {
                    if (typeof this.options.onResponse === 'function') {
                        this.options.onResponse(value);
                    }
                    this.removeModal();
                }, this));
            }, this)
        });
    }
});

PJQ.views.projects.SquareTakeoffModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Square-Takeoff'),
        maxWidth: '600px'
    },
    events: {
        'click .square-video': 'watchVideo',
        'click .square-login': 'login',
        'click .square-register': 'register'
    },
    watchVideo: function () {
        window.open('https://www.squaretakeoff.com/ref?id=6-video&url=https://squaretakeoff.com/pantera', '_blank');
    },
    login: function () {
        window.open('https://www.squaretakeoff.com/ref?id=5-login&url=https://app.squaretakeoff.com', '_blank');
    },
    register: function () {
        window.open('https://www.squaretakeoff.com/ref?id=7-register&url=https://squaretakeoff.com/sign-up', '_blank');
    }
});

PJQ.views.projects.eTakeoffModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-eTakeoff'),
        maxWidth: '600px'
    },
    events: {
        'click .etakeoff-download': 'download',
        'click .etakeoff-launch': 'launch'
    },
    download: function () {
        window.open('http://etakeoff.com/product/download/?partner_name=Pantera&gc_name=' + (this.options.contact ? encodeURIComponent(this.options.contact.get('companyName')) : ''), '_blank');
    },
    launch: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'accesskey',
                value: this.options.accessKey
            },
            {
                endpoint: 'etakeoff'
            }
        ]));
    }
});

// Project Attachments
PJQ.views.projects.ProjectAttachments = PJQ.views.projects.Attachments.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Dashboard-Attachments'),
        subTemplates: {
            attachment: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Dashboard-Attachment')
        },
        folderColors: [
            '#b7a1e0',
            '#80bdff'
        ],
        isHideDrawings: false,
        isHideDownload: false,
        isHideFiles: false,
        isHideEmptyFolders: false,
        onChange: _.noop,
        selectedAttachments: null,
        preventSelectAll: false,
        foldersOnly: false,
        canOrder: false
    },
    events: {
        'change .input-select-attachment': 'attachmentChecked',
        'click .attachment .pretty': 'stopPropagation',
        'click .attachment': 'attachmentClicked',
        'click .btn-order-selected': 'orderPrints',
        'click .btn-download-attachment': 'downloadAttachment',
        'click .btn-download-selected': 'downloadSelected',
        'click .btn-download-all': 'downloadAll',
        'click .btn-download-all-flattened': 'downloadAllFlattened',
        'click .btn-download-all-combined': 'downloadAllCombined',
        'click .btn-view-attachment': 'viewAttachment'
    },
    beforeFirstRender: function () {
        let prefs = this.options.project.preferences;
        if (prefs && prefs.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ATTACHMENTS)) {
            this.options.expandAllFolders = true;
        }

        this.options.enableDrawings = !this.options.isHideDrawings && !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS);

        this.options.foldersOnly = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.RSVP_FOLDER_CHECKBOXES_ONLY) &&
            this.options.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');

        this.selectedAttachments = this.options.selectedAttachments !== null ? this.options.selectedAttachments : new PJQ.collections.projects.ProjectAttachments(null, {
            project: this.options.project
        });

        let sfOverride = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_SHARED_FOLDER_NAME_OVERRIDE);
        if (_.size(sfOverride) > 0) {
            this.options.sharedFolderNameOverride = sfOverride;
        }

        if (this.collection == null) {
            this.fetchAttachments({isPrivate: false});
        }

        this.options.canOrder = !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT);
    },
    renderData: function () {
        return {
            project: this.options.project,
            collection: this.collection,
            isHideDownload: this.options.isHideDownload,
            isHideFiles: this.options.isHideFiles,
            canOrder: this.options.canOrder,
            versions: this.versions,
            enableDrawings: this.options.enableDrawings,
            isFetched: this.isFetched(),
            isDeferred: this.options.isDeferred
        };
    },
    afterRender: function () {
        if (this.isFetched()) {
            this.renderAttachments();
            if (!this.options.isHideDownload)
                new PJQ.menus.ContextMenu({
                    el: this.$('.attachments-container'),
                    selector: '.attachment',
                    actions: [
                        {
                            name: 'Download',
                            onClick: _.bind(function (attachment) {
                                this.downloadAttachments(attachment);
                            }, this)
                        }
                    ],
                    fetchElementData: _.bind(function (element) {
                        return this.collection.get($(element).data('cid'));
                    }, this),
                    onOpen: _.bind(function (attachment) {
                        this.getAttachmentElement(attachment).addClass('context-attachment');
                    }, this),
                    onClose: _.bind(function () {
                        this.$('.context-attachment').removeClass('context-attachment');
                    }, this)
                });
        }
    },
    renderAttachments: function () {
        let $container = this.$('.attachments-container');
        _.each(_.sortBy(this.collection.getRootSharedAttachments(), function (attachment) {
            return attachment.get("entryId") < 0 ? attachment.get("entryId") : (attachment.get('isFolder') ? 0 : 1);
        }), function (attachment) {
            if (!this.options.isDeferred && ((this.options.isHideFiles && !attachment.get('isFolder')) || (this.options.isHideEmptyFolders && attachment.get('isFolder') && _.size(attachment.getFolderAttachments(true)) === 0))) {
                return;
            }
            this.renderAttachment($container, attachment);
        }, this);
        if (!this.options.preventSelectAll && this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJ_DASHBOARD_SELECT_ALL_ATTACHMENTS)) {
            _.each(this.collection.getRootSharedAttachments(), function (attachment) {
                let $checkbox = this.getAttachmentElement(attachment).find('.input-select-attachment');
                $checkbox.prop('checked', true);
                $checkbox.trigger('change');
            }, this);
        }
    },
    renderAttachment: function ($container, attachment) {
        if (!this.options.isDeferred && this.options.isHideEmptyFolders && attachment.get('isFolder') && _.size(attachment.getFolderAttachments(true)) === 0) {
            return;
        }

        this.renderSubTemplate(true, this.options.subTemplates.attachment, $container, {
            model: attachment,
            isDeferred: this.options.isDeferred,
            foldersOnly: this.options.foldersOnly,
            folderColor: this.options.folderColors[attachment.getDepth() % _.size(this.options.folderColors)],
            isHideFiles: this.options.isHideFiles,
            isExpanded: this.expandedFolders.indexOf(attachment.cid) !== -1,
            isSelected: this.selectedAttachments.get(attachment.cid) != null,
            options: this.options
        }, _.bind(function ($folder) {
            if (_.find(this.selectedAttachments.models, function (item) {
                return item.get('entryId') === attachment.get('entryId');
            }) != null)
                $folder.find('.input-select-attachment').prop('checked', true);
            else if (attachment.get('isFolder') && _.find(this.selectedAttachments.models, function (item) {
                return item.get('entryId') === attachment.get('folderId');
            }) != null) {
                $folder.find('.input-select-attachment').prop('checked', true);
            } else if (attachment.get('isFolder') && _.filter(attachment.getFolderAttachments(false, true), _.bind(function (item) {
                return _.find(this.selectedAttachments.models, function (selectedAttachment) {
                    return item.get('entryId') === selectedAttachment.get('entryId');
                }) === undefined;
            }, this)).length === 0 && _.size(attachment.getFolderAttachments(false, true)) > 0 && _.size(this.selectedAttachments.models) > 0) {
                $folder.find('.input-select-attachment').prop('checked', true);
            }

            if (attachment.get('isFolder')) {
                _.each(this.sortAttachments(_.filter(attachment.getFolderAttachments(), function (attachment) {
                    return attachment.get('isFolder');
                })), function (folderAttachment) {
                    this.renderAttachment($folder.find('.attachment-files').first(), folderAttachment);
                }, this);

                _.each(this.sortAttachments(_.filter(attachment.getFolderAttachments(), function (attachment) {
                    return !attachment.get('isFolder');
                })), function (folderAttachment) {
                    this.renderAttachment($folder.find('.attachment-files').first(), folderAttachment);
                }, this);
            }
        }, this));
    },
    sortAttachments: function (attachments) {
        return attachments.sort(function (a, b) {
            let aso = a.get('sortOrder'),
                bso = b.get('sortOrder');
            return PJQ.helpers.sortHelpers.sortAlphaNum(aso != null ? aso.toString() : a.get('name'), bso != null ? bso.toString() : b.get('name'));
        });
    },
    attachmentClicked: function (e) {
        let $attachment = $(e.currentTarget),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.get('isFolder')) {
            this.expandFolder($attachment);

            let $attachments = $attachment.siblings('.attachment-files-outer');
            if (!$attachments.is(':visible')) {
                $attachment.css({
                    background: 'rgb(218, 218, 218)'
                });
            } else {
                $attachment.css({
                    background: ''
                });
            }
        } else {
            $attachment.find('.input-select-attachment').trigger('click');
        }
    },
    attachmentChecked: function (e) {
        let $checkbox = $(e.currentTarget),
            $attachment = $checkbox.closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid')),
            isChecked = $checkbox.prop('checked');

        if (attachment.get('isFolder')) {
            let folderAttachments = attachment.getFolderAttachments(true, this.options.isHideFiles);

            // if we're operating at folder level add this folder to selection
            if (this.options.isHideFiles) {
                if (isChecked) {
                    this.addSelectedAttachments([attachment]);
                } else {

                    // if we are not included, and the parent was, we need to remove it and include all our siblings.
                    let parentFolder = attachment.getParentFolder();
                    if (this.selectedAttachments.contains(parentFolder)) {
                        _.each(parentFolder.getFolderAttachments(false, true), _.bind(function (folder) {
                            this.selectedAttachments.add(folder);
                        }, this));
                    }
                    this.removeSelectedAttachments([attachment]);
                }

                // we are either adding this parent (thus including all children), or removing this parent.  Either way the children do not need to be included.
                this.removeSelectedChildAttachmentsRecursive(attachment);

            } else {
                let allAtt = _.union(folderAttachments, [attachment]);
                if (isChecked) {
                    this.addSelectedAttachments(allAtt);
                } else {
                    this.removeSelectedAttachments(allAtt);
                }
            }

            let $folderAttachments = $checkbox.closest('.attachment').siblings('.attachment-files-outer');
            $folderAttachments.find('.input-select-attachment').prop('checked', isChecked);
        } else if (!this.options.isHideFiles) {
            if (isChecked) {
                this.addSelectedAttachments([attachment]);
            } else {
                this.removeSelectedAttachments([attachment]);
            }
        }

        this.setParentCheckbox(attachment);

        this.renderSelectedButton();
    },
    addSelectedAttachments: function (attachments) {
        this.selectedAttachments.add(attachments);

        if (typeof this.options.onChange === 'function')
            this.options.onChange(this.selectedAttachments);

        $('.print-alert').removeClass('hidden');
    },
    removeSelectedAttachments: function (attachments) {
        this.selectedAttachments.remove(attachments);

        if (this.options.isHideFiles) {
            _.each(attachments, _.bind(function (attachment) {
                this.removeSelectedParentFolderRecursive(attachment);
            }, this));
        }

        if (typeof this.options.onChange === 'function')
            this.options.onChange(this.selectedAttachments);
    },
    removeSelectedChildAttachmentsRecursive: function (folder) {
        let attachments = folder.getFolderAttachments();
        _.each(attachments, _.bind(function (attachment) {
            if (attachment.get('isFolder')) {
                this.removeSelectedAttachments(attachment);
                this.removeSelectedChildAttachmentsRecursive(attachment);
            }
        }, this));
    },
    removeSelectedParentFolderRecursive: function (attachment) {
        if (typeof attachment.getParentFolder !== 'function')
            return;

        let folder = attachment.getParentFolder();
        if (folder != null && folder.id > 0) {
            this.selectedAttachments.remove(folder);
            this.removeSelectedParentFolderRecursive(folder);
        }
    },
    renderSelectedButton: function () {
        let selectedCount = _.size(_.filter(this.selectedAttachments.models, function (att) {
            return !this.options.isHideEmptyFolders || !att.get('isFolder');
        }, this));
        this.$('.btn-download-selected').prop('disabled', !(selectedCount > 0));

        if (!this.options.isDeferred) {
            this.$('.ct-selected-attachments').text(selectedCount);
        }
    },
    setParentCheckbox: function (attachment) {
        let folder = attachment.getParentFolder();
        if (folder != null && folder.id > 0) {
            let hasUnselectedAttachments = this.folderHasUnselectedAttachments(folder);
            this.getAttachmentElement(folder).find('.input-select-attachment').prop('checked', !hasUnselectedAttachments);

            //set the checkbox for this folder's parent
            //recursive until there are no more parent folders
            this.setParentCheckbox(folder);
        }
    },
    folderHasUnselectedAttachments: function (folder) {
        let folderAttachments = folder.getFolderAttachments();
        return _.find(folderAttachments, function (folderAttachment) {
            if (folderAttachment.get('isFolder')) {
                if (!this.options.isHideFiles)
                    return this.folderHasUnselectedAttachments(folderAttachment);
                else
                    return this.selectedAttachments.get(folderAttachment.id) == null;
            } else {
                return this.selectedAttachments.get(folderAttachment.id) == null && !this.options.isHideFiles;
            }
        }, this) != null;
    },
    getAttachmentElement: function (attachment) {
        return this.$(".attachment[data-cid='" + attachment.cid + "']");
    },
    downloadAttachment: function (e) {
        e.stopPropagation();
        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        this.options.project.checkDownloadRequirements(_.bind(function () {
            this.downloadAttachments(attachment);
        }, this));
    },
    downloadSelected: function () {
        if (_.size(this.selectedAttachments) > 0) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                this.downloadAttachments(this.selectedAttachments);
            }, this));
        }
    },
    downloadAllCombined: function () {
        this.downloadAll({
            raster: true,
            merge: true
        })
    },
    downloadAllFlattened: function () {
        this.downloadAll({
            raster: true
        });
    },
    downloadAll: function (opts = null) {
        if (_.size(this.collection.models) > 0) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                this.downloadAttachments(this.collection, opts);
            }, this));
        }
    },
    viewAttachment: function (e) {
        e.stopPropagation();

        let $attachment = $(e.currentTarget).closest('.attachment'),
            attachment = this.collection.get($attachment.data('cid'));
        if (attachment.isImage()) {
            PJQ.app.view.renderPhotoViewer({
                model: attachment
            });
        } else if (attachment.canRender()) {
            new PJQ.views.files.FileViewer({
                model: attachment
            });
        }
    },
    orderPrints: function () {
        let callback = _.bind(function () {
            let selectedAttachments = this.selectedAttachments.where({isFolder: false});
            new PJQ.views.files.OrderPrintsModal({
                contact: PJQ.app.session.contact,
                files: selectedAttachments
            });
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();
    }
});

PJQ.views.projects.dashboard.BidPackages = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'bid-packages')
    },
    events: {},
    renderData: function () {
        return {
            collection: this.collection
        }
    },
    beforeFirstRender: function () {

    },
    afterRender: function () {

    }
});

PJQ.views.projects.dashboard.ViewMessageAttachmentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'modal-view-message-attachments'),
        minWidth: '25%',
        attachments: []
    },
    events: {
        'click .btn-download': 'downloadFile',
        'click .btn-download-all': 'downloadAll'
    },
    renderData: function () {
        return {
            attachments: this.options.attachments
        }
    },
    downloadFile: function (e) {
        let url = this.$(e.currentTarget).data('url');
        PJQ.files.downloadFile(url, {
            isEndpoint: false
        });
    },
    downloadAll: function () {
        let entryIds = _.map(this.options.attachments, function (attachment) {
            return attachment.entryId
        });
        PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'downloadentryidlist'
            }
        ]), {entryList: entryIds});
    }

});

PJQ.views.projects.dashboard.ProjectMessageDeclineQuestionModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'modal-project-message-decline-question'),
        minWidth: '40%'
    },
    events: {
        'click .submit-response': 'submitResponse',
        'change input[type="radio"]': 'responseChanged'
    },
    renderData: function () {
        return {
            questions: this.options.questions,
            response: this.options.response
        }
    },
    responseChanged: function(e) {
        this.$('.submit-response').prop('disabled', false);

        if ($(e.currentTarget).prop('id') === 'question-other') {
            this.$('.other-reason').removeClass('hidden');
            this.$('.other-reason').focus();
        }
        else
            this.$('.other-reason').addClass('hidden');

    },
    submitResponse: function() {
        let $question = this.$('input[type="radio"]:checked'), response = '';

        if ($question.prop('id') === 'question-other') {
            response = 'Other';

            if (_.size(this.$('.other-reason').val()) > 0)
                response += ": " + this.$('.other-reason').val();
        }
        else
            response = this.options.questions[$question.prop('id').substring($question.prop('id').indexOf('-')+1)];

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'projectmessages'
                },
                {
                    endpoint: 'accesskey',
                    value: this.options.accessKey
                },
                {
                    endpoint: 'response'
                },
                {
                    endpoint: 'reason'
                }
            ]),
            data: {
                reason: response
            }
        }).post().done(_.bind(function (data) {
            PJQ.notifications.notify.successNotify({
                message: 'Response recorded successfully.'
            });
            this.removeModal();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Unable to record response.'
            });
        });

    }
});

PJQ.views.projects.ProjectDetails = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Details'),
        subTemplates: {
            field: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Details-Core-Field')
        },
        layout: {
            columns: [
                {
                    sortOrder: 10,
                    fields: [
                        {
                            field: "projectName",
                            classes: "col-12",
                            sortOrder: 10
                        },
                        {
                            field: "address1",
                            classes: "col-12",
                            sortOrder: 20
                        },
                        {
                            field: "address2",
                            classes: "col-12",
                            sortOrder: 30
                        },
                        {
                            field: "location",
                            classes: "col-12",
                            sortOrder: 40
                        }
                    ]
                },
                {
                    sortOrder: 20,
                    fields: [
                        {
                            field: "bidsDue",
                            classes: "col-12",
                            sortOrder: 10
                        },
                        {
                            field: "user1",
                            classes: "col-12",
                            sortOrder: 20
                        },
                        {
                            field: "user2",
                            classes: "col-12",
                            sortOrder: 30
                        }
                    ]
                },
                {
                    field: "notes",
                    classes: "col-12",
                    sortOrder: 40
                },
                {
                    field: "startDate",
                    sortOrder: 50
                },
                {
                    field: "finishDate",
                    sortOrder: 60
                }
            ]
        }
    },
    events: {
        'click .btn-project-edit-cancel': 'cancelEdit',
        'click .btn-project-save': 'save',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-link-erp': 'linkERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-project-export': 'exportPDF',
        'change .input-project-nda': 'ndaRequiredChanged',
        'click .btn-edit-project-nda': 'editProjectNDA',
        'change .input-details-admin-only': 'detailsAdminOnlyChanged'
    },
    beforeFirstRender: function () {
        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_STATUS_ID) &&
            (_.size(_.filter(this.options.layout.columns, function (column) {
                return column.field === "projectStatusId"
            })) === 0)) {
            this.options.layout.columns.push({
                field: "projectStatusId",
                sortOrder: 70
            });
        }

        this.options.canEdit = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
            && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_HOME_READONLY)
            && PJQ.app.session.project.get('status') !== 'ARCHIVE' && PJQ.app.session.project.hasPermission('base.canEdit');

        this.mergePortalLayout();
        if (this.options.canEdit) {
            if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'details')) {
                let defs = PJQ.app.portal.customization.project.details.defaults;
                if (defs != null) {
                    this.portalDefaults = defs;
                    this.triggerPortalDefaults();
                }
            }
        }

        this.options.startEndHide = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.START_END_HIDE);

        this.listenTo(this.model, 'sync', this.render);
        this.listenTo(this.model, 'change', _.bind(function (e) {
            this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', false);
            this.$('.btn-project-export').prop('disabled', true);
        }, this));

        PJQ.app.session.fetchProjectStatuses(_.bind(function (statuses) {
            this.projectStatuses = statuses;

            PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
                this.erpIntegration = erp;
                if (this.erpIntegration != null) {
                    this.model.fetchERPObject(_.bind(function () {
                        this.render();
                    }, this));
                } else {
                    this.render();
                }
            }, this));

        }, this));
        return false;
    },
    renderERP: function () {
        if (this.erpIntegration == null || this.model == null) {
            return;
        }

        let pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT),
            linkSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.LINK_PROJECT),
            unlinkSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PROJECT);
        PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: pushSupported,
            unlinkSupported: unlinkSupported,
            linkSupported: linkSupported,
            canPush: this.options.canEdit,
            disablePushReason: null,
            status: this.model.erpSyncStatus()
        });
    },
    pushERP: function () {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT)) {
            return;
        }

        this.save((success) => {
            if (!success) {
                return;
            }

            this.erpIntegration.pushProject(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Project pushed to ERP'
                });
                this.render();
            });
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            return;
        }

        this.erpIntegration.undoPush(this.model, () => {
            PJQ.notifications.notify.successNotify({
                message: 'Project removed from ERP approval'
            });
            this.render();
        });
    },
    linkERP: function () {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.LINK_PROJECT)) {
            return;
        }

        new PJQ.integrations.models.LinkERPProjectModal({
            project: PJQ.app.session.project,
            onSave: _.bind(function (erpProject) {
                if (erpProject.isERPSynced()) {
                    this.render();
                }
            }, this)
        });
    },
    unlinkERP: function () {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PROJECT)) {
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Project from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.project-details'));
                this.erpIntegration.unlinkProject(this.model, () => {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Project unlinked from ERP'
                    });
                    this.render();
                });
            }
        });
    },
    mergePortalLayout: function () {
        let layout = null;
        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'details')) {
            layout = PJQ.app.portal.customization.project.details.layout;
        }

        let findPortalLayoutField = _.bind(function (searchField) {
            let result = null;
            _.each(layout.columns, function (column) {
                if (_.size(column.fields) > 0) {
                    result = result || _.find(column.fields, function (field) {
                        return field.field === searchField.field;
                    });
                } else if (column.field != null && column.field === searchField.field) {
                    result = column;
                }
            }, this);
            return result;
        }, this);

        if (layout != null) {
            _.each(this.options.layout.columns, function (column) {
                if (_.size(column.fields) > 0) {
                    let col = _.defaults({fields: []}, column);
                    _.each(column.fields, function (field) {
                        if (findPortalLayoutField(field) == null) {
                            col.fields.push(field);
                        }
                    });
                    if (_.size(col.fields) > 0) {
                        layout.columns.push(col);
                    }
                } else if (column.field != null) {
                    if (findPortalLayoutField(column) == null) {
                        layout.columns.push(column);
                    }
                }
            });
        } else {
            layout = this.options.layout;
        }

        //add custom field columns to template that were not defined in the custom portal details layout
        let nextSort = _.max(layout.columns, function (column) {
            if (_.size(column.fields) > 0) {
                return _.max(column.fields, function (field) {
                    return field.sortOrder != null ? field.sortOrder : 0;
                });
            }
            return column.sortOrder != null ? column.sortOrder : 0;
        }).sortOrder;
        _.each(this.model.customFields.models, function (customField) {
            let cfId = 'cf_' + customField.id.toString(),
                cf = {
                    field: cfId,
                    sortOrder: nextSort
                };
            if (findPortalLayoutField(cf) == null) {
                layout.columns.push(cf);
                nextSort += 10;
            }
        });
        this.options.layout = layout;
    },
    renderData: function () {
        return {
            model: this.model,
            subTemplates: this.options.subTemplates,
            layout: this.options.layout,
            layoutOptions: {
                notesHide: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_NOTES_HIDDEN),
                isNotesRequired: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_NOTES_REQUIRED),
                isUser2Required: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_USER_2_REQUIRED),
                isCityRequired: this.isCityRequired(),
                isStateRequired: this.isStateRequired(),
                isZipRequired: this.isZipRequired(),
                isBidDueDateRequired: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_BID_DUE_DATE_REQUIRED),
                notesLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_NOTES_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_NOTES_LABEL) : 'Notes',
                responseDueLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : 'Response Due',
                startDateLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) : 'Start Date',
                finishDateLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) : 'Finish Date',
                user1Label: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : 'Project Contact',
                user2Label: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : 'Project Contact 2',
                user2Hide: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_HIDE),
                startEndHide: this.options.startEndHide
            },
            erpIntegration: this.erpIntegration,
            defaultNDAChecked: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_NDA_CHECKED_DEFAULT),
            isEdit: this.options.canEdit,
            canExport: this.options.canEdit && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_DETAILS_EXPORT)
        };
    },
    triggerPortalDefaults: function (changedId = null) {
        if (this.portalDefaults == null) {
            return;
        }

        _.each(this.portalDefaults, function (def, id) {
            if ((def.reference != null && changedId == null) || (changedId != null && changedId !== def.reference && changedId !== def.timeReference) || (id === 'bidsDue' && this.model.get('responseDueDate') === 'ASAP')) {
                return;
            }

            let refValue = null,
                timeRefValue = null;
            if (def.reference != null) {
                if (def.reference.indexOf('cf_') !== -1) {
                    let refCfId = parseInt(def.reference.replace('cf_', '')),
                        refCf = this.model.customFields.get(refCfId),
                        refFieldValue = _.findWhere(this.model.get('customFields'), {id: refCfId});
                    if (refFieldValue != null) {
                        if (refCf.get('fieldType').toLowerCase() === 'choice') {
                            let selChoice = refCf.choices.get(refFieldValue.value);
                            if (selChoice != null) {
                                refValue = selChoice.get('choiceName');
                            }
                        } else {
                            refValue = refFieldValue.value;
                        }
                    }
                } else {
                    refValue = this.model.get(def.reference);
                }
            }

            if (def.timeReference != null) {
                if (def.timeReference.indexOf('cf_') !== -1) {
                    let timeRefCfId = parseInt(def.timeReference.replace('cf_', '')),
                        timeRefCf = this.model.customFields.get(timeRefCfId),
                        timeRefFieldValue = _.findWhere(this.model.get('customFields'), {id: timeRefCfId});
                    if (timeRefFieldValue != null) {
                        timeRefValue = timeRefFieldValue.value;
                    }

                    if (timeRefCf.get('fieldType').toLowerCase() === 'choice') {
                        let selChoice = timeRefCf.choices.get(timeRefFieldValue.value);
                        if (selChoice != null) {
                            timeRefValue = selChoice.get('choiceName');
                        }
                    } else {
                        timeRefValue = timeRefFieldValue.value;
                    }
                } else {
                    timeRefValue = this.model.get(def.reference);
                }
            }

            let newValue = undefined;
            if (def.match != null) {
                let match = def.match[refValue == null ? 'null' : refValue];
                if (typeof match === 'undefined') {
                    if (refValue != null && _.size(refValue.toString()) > 0) {
                        match = def.match["_notEmpty"];
                    } else {
                        match = def.match["_empty"];
                    }
                }

                if (match != null) {
                    if (match.from === 'today') {
                        if (def.offset != null && def.offset !== 0) {
                            newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), def.offset);
                        } else {
                            newValue = new Date();
                        }
                    } else if (typeof match.value !== 'undefined') {
                        newValue = match.value;
                    }
                }
            } else {
                switch (def.type) {
                    case 'DATE':
                    case 'DATETIME':
                        if (def.offset != null) {
                            if (def.reference != null && refValue == null) {
                                newValue = null;
                            } else {
                                if (def.defaultTime != null) {
                                    let dt = new Date(PJQ.helpers.dateHelpers.getDateString(refValue ? new Date(refValue) : new Date(), PJQ.helpers.dateHelpers.dateFormats.DATE, true) + ' ' + (timeRefValue ? timeRefValue : def.defaultTime));
                                    newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(dt, def.offset, def.weekdaysOnly === true);
                                } else {
                                    newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(refValue ? new Date(refValue + (timeRefValue ? (' ' + timeRefValue) : '')) : new Date(), def.offset, def.weekdaysOnly === true);
                                }

                                if (def.minOffset != null && newValue.getTime() < (new Date()).getTime()) {
                                    newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), def.minOffset, def.weekdaysOnly === true);
                                }
                            }
                        } else if (typeof def.value !== 'undefined') {
                            newValue = def.value;
                        }
                        break;
                    case 'TEXT':
                        newValue = refValue;
                        break;
                }
            }

            if (typeof newValue == 'undefined')
                return;

            if (def.type === 'DATE' && newValue != null && id.toLowerCase() !== 'startdate' && id.toLowerCase() !== 'enddate') {
                newValue = PJQ.helpers.dateHelpers.getDateString(newValue, PJQ.helpers.dateHelpers.dateFormats.DATE);
            }

            if (id.indexOf('cf_') !== -1) {
                let cfId = parseInt(id.replace('cf_', '')),
                    fieldValue = _.findWhere(this.model.get('customFields'), {id: cfId});

                if (fieldValue.value != null && def.reference == null) {
                    return;
                }

                fieldValue.value = newValue;
                if (this.projectCustomFieldsForm) {
                    this.projectCustomFieldsForm.setValue(cfId, newValue);
                }
            } else {
                this.model.set(id, newValue);
                if (id.toLowerCase() === 'bidsdue' && this.dueDatePicker != null) {
                    this.dueDatePicker.setValue(newValue);
                } else if (id.toLowerCase() === 'startdate' && this.startDatePicker != null) {
                    this.startDatePicker.setValue(newValue);
                } else if (id.toLowerCase() === 'enddate' && this.endDatePicker != null) {
                    this.endDatePicker.setValue(newValue);
                } else if (this.coreBinder != null) {
                    this.coreBinder.setValue(id, newValue);
                }
            }
        }, this);
    },
    afterRender: function () {
        if (this.projectStatuses == null) {
            return;
        }

        this.renderERP();

        this.projectCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
            el: this.$el,
            shouldRenderTemplate: false,
            collection: this.model.customFields,
            fieldValues: this.model.get('customFields'),
            isEdit: this.options.canEdit,
            onChange: _.bind(function (fieldId, value) {
                this.triggerPortalDefaults('cf_' + fieldId.toString());
                this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', false);
                this.$('.btn-project-export').prop('disabled', true);
            }, this)
        });

        this.coreBinder = new PJQ.Binder(this.$('.project-details-form'), this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK) && this.options.canEdit) {
            new PJQ.inputs.Selectpicker({
                el: this.$('select.project-status'),
                onChange: _.bind(function (value) {
                    this.model.set('status', value);
                }, this)
            });
        }

        let statePicker = new PJQ.inputs.StatePicker({
            el: this.$('select.state'),
            country: this.model.get('country') ?? null,
            defaultValue: this.model.get('state') ?? null,
            size: 20,
            onChange: (value) => {
                this.model.set('state', value);
            }
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('select.country'),
            defaultValue: this.model.get('country') ?? null,
            statePicker: statePicker,
            zipInput: this.$('.zip'),
            enableInternational: this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
            size: 20,
            onChange: (value) => {
                this.model.set('country', value);
            }
        });

        if (this.model.get('responseDueDate') === 'ASAP') {
            this.$('.response-due-asap').prop('checked', true);
            this.$('.input-response-due').prop('disabled', true);
        }

        this.$('.response-due-asap').on('click', _.bind(function () {
            if (this.$('.response-due-asap').prop('checked')) {
                this.model.set('bidsDue', null);
                this.model.set('responseDueDate', 'ASAP');
                this.$('.input-response-due').val('').prop('disabled', true);
            } else {
                this.model.set('responseDueDate', '');
                this.$('.input-response-due').prop('disabled', false);
                this.triggerPortalDefaults('bidsdue');
            }
        }, this));

        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-response-due'),
            datepickerOptions: {
                defaultDate: this.model.get('bidsDue') ? this.model.get('bidsDue') : null
            },
            onChange: _.bind(function (newTime) {
                this.model.set('bidsDue', newTime);
                this.model.set('responseDueDate', PJQ.helpers.dateHelpers.getDateString(this.model.get('bidsDue'), PJQ.helpers.dateHelpers.dateFormats.DATE, false));
                this.triggerPortalDefaults('bidsdue');
            }, this),
            onShow: _.bind(function (context) {
                if (!$(context.datetimepicker).data('DateTimePicker').date() && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME) && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME_AMPM)) {
                    let tempDate = new Date(),
                        timeParts = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME).toString().split(':'),
                        hours = parseInt(timeParts[0]), minutes = parseInt(timeParts[1]);
                    if (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME_AMPM) === 'PM' && hours !== 12 || hours === 12 && PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME_AMPM) === 'AM')
                        hours += 12;
                    $(context.datetimepicker).data('DateTimePicker').date(new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), hours, minutes, 0, 0));
                }
            }, this)
        });

        if (!this.options.startEndHide) {
            this.startDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-project-start'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('startDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false) : null
                },
                onChange: _.bind(function (newTime) {
                    this.model.set('startDate', newTime);
                }, this)
            });

            this.endDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-project-end'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('endDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false) : null
                },
                onChange: _.bind(function (newTime) {
                    this.model.set('endDate', newTime);
                }, this)
            });
        }

        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_STATUS_ID)) {
            this.projectStatusIdSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.project-status-id'),
                isIntChoices: true,
                defaultValue: this.model.get('projectStatusId') ? this.model.get('projectStatusId') : PJQ.app.session.projectStatuses.getDefault().id,
                onChange: _.bind(function (value) {
                    this.model.set('projectStatusId', value)
                }, this)
            });
        }

        this.userInput = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.project-contact'),
            context: PJQ.constants.contacts.contexts.USERS,
            selectedContact: this.model.user,
            isSingleChoice: true,
            emptyNotice: "No User Selected",
            isReadOnly: !this.options.canEdit,
            onAdd: _.bind(function (contacts) {
                this.model.set('user', contacts);
            }, this),
            onDelete: _.bind(function () {
                this.model.set('user', null);
            }, this)
        });

        this.user2Input = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.project-contact2'),
            context: PJQ.constants.contacts.contexts.USERS,
            selectedContact: this.model.user2,
            isSingleChoice: true,
            emptyNotice: "No User Selected",
            isReadOnly: !this.options.canEdit,
            onAdd: _.bind(function (contacts) {
                this.model.set('user2', contacts);
            }, this),
            onDelete: _.bind(function () {
                this.model.set('user2', null);
            }, this)
        });

        // show a read-only version of scopes when if they are enabled and a sub is viewing the page.
        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCOPES) && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
            new PJQ.views.projects.ProjectScopes({
                el: this.$('.project-scopes')
            });
        }
    },
    ndaRequiredChanged: function () {
        let hasNDA = this.$('.input-project-nda').prop('checked');
        if (hasNDA) {
            this.editProjectNDA();
        } else {
            this.model.set('hasNDA', false, {
                silent: true
            });
            this.renderNDARequired();
            new PJQ.models.projects.ProjectNDA({
                ndaId: -1,
                project: this.model
            }).destroy({
                success: function () {
                    PJQ.notifications.notify.successNotify({
                        message: "NDA has been disabled for this project"
                    });
                }
            });
        }
    },
    renderNDARequired: function () {
        let hasNDA = this.model.get('hasNDA');
        this.$('.input-project-nda').prop('checked', hasNDA);
        if (hasNDA) {
            this.$('.btn-edit-project-nda').removeClass('hidden');
        } else {
            this.$('.btn-edit-project-nda').addClass('hidden');
        }
    },
    editProjectNDA: function () {
        new PJQ.views.projects.EditProjectNDAModal({
            project: this.model,
            onSave: _.bind(function () {
                this.renderNDARequired();
            }, this),
            onCancel: _.bind(function () {
                this.renderNDARequired();
            }, this)
        });
    },
    detailsAdminOnlyChanged: function () {
        let isDetailsAdminOnly = this.$('.input-details-admin-only').prop('checked');
        this.model.set('isDetailsAdminOnly', isDetailsAdminOnly);
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.id
                }
            ], [
                {
                    parameter: 'isDetailsAdminOnly',
                    value: isDetailsAdminOnly
                }
            ])
        }).patch().done(_.bind(function () {
            let alertMessage;
            if (isDetailsAdminOnly) {
                alertMessage = "Project details are now hidden from non admins";
            } else {
                alertMessage = "Project details are now visible to non admins";
            }
            PJQ.notifications.notify.successNotify({
                message: alertMessage
            });
        }, this));
    },
    exportPDF: function () {
        // old export
        // PanteraScript.PanteraScriptService.GenerateExportNew(PJQ.app.session.id, 'project', 'pdf', parseInt(PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DETAILS_EXPORT)), '', function(response) {
        // 	let rr = jQuery.parseJSON(response);
        // 	PJQ.files.downloadFile(rr.DownloadURL, {
        // 		isEndpoint: false
        // 	});
        // }, null);

        // New JSReport Export
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.get('projectId')
                },
                {
                    endpoint: 'details'
                },
                {
                    endpoint: 'export'
                }
            ], [
                {
                    parameter: 'timeZone',
                    value: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
            ]),
            data: {}
        }).post().done(function (response) {
            PJQ.files.handleDownload(response);
        });
    },
    cancelEdit: function () {
        if (this.model.get('status') === 'NEW') {
            PJQ.app.router.navigate('projects', {
                trigger: true,
                replace: true
            });
        } else {
            this.model.fetch();
            this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', true);
            this.$('.btn-project-export').prop('disabled', false);
        }
    },
    save: function (callback = null) {
        let errors = false;

        PJQ.helpers.inputHelpers.setInputError(this.$('.project-name'), true);
        if (this.model.get('projectName').trim().length === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.project-name'), false);
            errors = true;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-response-due'), true);
        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_BID_DUE_DATE_REQUIRED) && this.model.get('bidsDue') === null && !this.$('.response-due-asap').prop('checked')) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-response-due'), false);
            errors = true;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.city'), true);
        if (this.isCityRequired() && this.model.get('city').trim().length === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.city'), false);
            errors = true;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('select.state'), true);
        if (this.isStateRequired() && this.model.get('state').trim().length === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('select.state'), false);
            errors = true;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.zip'), true);
        if (this.isZipRequired() && this.model.get('zip').trim().length === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.zip'), false);
            errors = true;
        }

        if (!this.userInput.validate()) {
            errors = true;
        }

        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_USER_2_REQUIRED)) {
            if (!this.user2Input.validate()) {
                errors = true;
            }
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-start'), true);
        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.REQUIRE_PROJECT_START_FINISH) && !this.model.get('startDate')) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-start'), false);
            errors = true;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-end'), true);
        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.REQUIRE_PROJECT_START_FINISH) && !this.model.get('endDate')) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-end'), false);
            errors = true;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.project-notes'), true);
        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_NOTES_REQUIRED) && this.model.get('notes').trim().length === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.project-notes'), false);
            errors = true;
        }

        if (!this.projectCustomFieldsForm.validate())
            errors = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.project-status-id'), true);
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_STATUS_NON_DEFAULT_REQUIRED)) {
            _.each(PJQ.app.session.projectStatuses.models, _.bind(function (item) {
                if (item.get('projectStatusId') === this.model.get('projectStatusId') && item.get('isDefault')) {
                    PJQ.helpers.inputHelpers.setInputError(this.$('.project-status-id'), false);
                    errors = true;
                }
            }, this));
        }


        if (errors) {
            PJQ.notifications.notify.errorNotify({
                message: 'One or more fields are not filled out correctly.  Please review the form.'
            });
            return false;
        }

        this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', true);
        this.$('.btn-project-export').prop('disabled', false);

        let wasNew = this.model.get('status') === 'NEW';
        this.model.save(null, {
            notify: true,
            success: _.bind(function () {
                if (wasNew) {
                    PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id + "/dashboard", {
                        trigger: true
                    });
                }
                this.renderERP();

                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)
        });
    },
    isCityRequired: function () {
        let prefs = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) : '' +
        PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) : '';

        return prefs != null && prefs.indexOf('[Project.City]') !== -1;
    },
    isStateRequired: function () {
        let prefs = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) : '' +
        PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) : '';

        return prefs != null && prefs.indexOf('[Project.State]') !== -1;
    },
    isZipRequired: function () {
        return PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_ZIP_REQUIRED);
    }
});

PJQ.views.projects.ProjectMapModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Map'),
        width: '800px',
        minWidth: '800px'
    },
    events: {
        'click .map-recenter': 'mapRecenter'
    },
    beforeModalCreated: function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
    },
    beforeRender: function () {
        this.renderData = {};
    },
    mapRecenter: function () {
        this.map.setCenter(this.myLatLng);
    },
    afterRender: function () {
        let address = this.options.project.get('address1') + ' ' + this.options.project.get('city') + ', ' + this.options.project.get('state') + ' ' + this.options.project.get('zip'),
            markerTitle = this.options.project.get('projectName'),
            geocoder = new google.maps.Geocoder();

        this.map = new google.maps.Map(document.getElementById('map_canvas'), {
            mapId: 'map_' + _.uniqueId(),
            zoom: 4,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        address = address.trim();
        geocoder.geocode({
            'address': address
        }, _.bind(function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                this.map.setCenter(results[0].geometry.location);
                this.myLatLng = results[0].geometry.location;
                let marker = new google.maps.Marker({
                    map: this.map,
                    title: markerTitle,
                    position: results[0].geometry.location
                });
            } else {
                alert("Unable to find Project Location for the following reason: " + status);
            }
        }, this));

        this.map.getStreetView().setVisible(false);
        this.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
        this.map.setZoom(15);
        this.map.setCenter(this.myLatLng);
    },
});


PJQ.views.projects.ProjectScopes = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Scopes')
    },
    events: {},
    beforeFirstRender: function () {

        this.collection = new PJQ.collections.projects.Scopes(null, {
            project: PJQ.app.session.project
        });
        this.listenTo(this.collection, 'sync', this.render);
        this.collection.fetch();
    },
    beforeRender: function () {
        this.renderData = {
            scopes: this.collection.models
        };
    },
    afterRender: function () {
    }
});

PJQ.views.projects.ProjectMessaging = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Messages'),
        selectedContacts: [],
        selectedContactGroups: [],
        selectedProjectMessageContactBroadcasts: [],
        filter: {
            status: [],
            groups: [],
            isPrintOrder: false,
            isDownloaded: false,
            isVisited: false,
            isSelected: false,
            vendorSector: '',
            laborStatus: [],
            minorityStatus: []
        },
        hasCompanyLevelCustomFields: false,
        hasContactLevelCustomFields: false
    },
    events: {
        'keyup .input-pm-search': 'searchChanged',
        'click .btn-pm-search': 'search',
        'click .project-messages-filter': 'filterDialog',
        'click .project-messages-clear-filter': 'clearFilterClick',
        'click .btn-project-message-settings': 'settings',
        'change .project-message-enable-declined': 'enableDeclinedChanged',
        'click .btn-add-participants-from-project': 'addParticipantsFromProject',
        'click .btn-quick-add': 'quickAdd',
        'click .btn-add-participant-new': 'addNewContact',
        'click .btn-detailed-search': 'detailedSearch',
        'click .btn-detailed-search-new': 'detailedSearch',
        'click .btn-simple-search': 'simpleSearch',
        'click .btn-quick-search': 'quickSearch',
        'click .project-message-delete-contacts': 'deleteParticipantsFromProject',
        'click .btn-send-message': 'sendMessage',
        'click .btn-message-template-send': 'sendMessage',
        'click .project-message-set-responses': 'setResponses',
        'click .project-message-order-prints': 'orderPrints',
        'click .export-view': 'exportView',
        'click .manage-bid-packages': 'manageBidPackages',
        'click .import-bid-packages': 'importBidPackages',
        'click .btn-radius-package-add': 'addByBidPackageRadius'
    },
    renderData: function () {
        return {
            project: this.options.project,
            showGroupCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY),
            showGroupContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT),
            showCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY),
            showContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT),
            showBidPackagesView: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES)
        };
    },
    afterRender: function () {
        this.options.selectedContacts = [];
        this.options.selectedContactGroups = [];
        this.options.isTradesViewSelectAll = false;

        this.options.filter = {
            status: [],
            groups: [],
            isPrintOrder: false,
            isDownloaded: false,
            isVisited: false,
            isSelected: false,
            publicPrivate: '',
            vendorSector: '',
            laborStatus: [],
            minorityStatus: []
        };
        this.updateContactStats();

        if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISABLE_QUICKADD))
            this.$('.btn-quick-add').hide();

        this.options.isTradesViewSelectAll = false;
        this.options.settings = new PJQ.models.projectParticipants.ProjectMessageViewSettings();
        this.options.bidFormSettings = new PJQ.models.bidForms.Settings();
        PJQ.app.session.project.fetchBidFormSettings(_.bind(function(bidFormSettings) {
            this.options.bidFormSettings = bidFormSettings;
            this.options.canViewBidAmount = !this.options.bidFormSettings.get('isSealBids') || this.options.bidFormSettings.isSealedBidContact(PJQ.app.session.user.get('id'));
            this.options.settings.fetch({
                success: _.bind(function () {
                    // scan to make sure we haven't deleted a column that is referenced by groupBy or orderBy
                    _.each(this.options.settings.get('settings'), _.bind(function (setting) {
                        if (_.size(setting.columns) === 0) {
                            if (setting.columnsDefault.indexOf(setting.orderBy) === -1) {
                                setting.orderBy = setting.columnsDefault[0];
                            }
                        } else if (setting.columns.indexOf(setting.orderBy) === -1) {
                            setting.orderBy = setting.columns[0];
                        }
                    }, this));

                    let defaultView = this.options.viewProjectMessageId ? 'messagecontact' : this.options.settings.get('defaultView');
                    this.viewSelectPicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.project-message-view'),
                        defaultValue: defaultView,
                        onChange: _.bind(function (value) {

                            let callback = _.bind(function () {
                                this.options.selectedContacts = [];
                                this.options.selectedContactGroups = [];
                                this.options.isTradesViewSelectAll = false;

                                this.options.filter = {
                                    status: [],
                                    groups: [],
                                    isPrintOrder: false,
                                    isDownloaded: false,
                                    isVisited: false,
                                    isSelected: false,
                                    vendorSector: '',
                                    publicPrivate: '',
                                    laborStatus: [],
                                    minorityStatus: []
                                };

                                this.renderContactStats();
                                this.renderView(value);
                            }, this);

                            if (_.size(this.options.selectedContacts) === 0)
                                callback();
                            else {
                                new PJQ.views.modals.YesNo({
                                    header: "Selected Participants",
                                    body: "Selected participants will be cleared when switching views.  Do you want to continue?",
                                    onYes: _.bind(function () {
                                        callback();
                                    }, this),
                                    onNo: _.bind(function () {
                                        this.viewSelectPicker.setValue(this.currentView);
                                    }, this)
                                });
                            }
                        }, this)
                    });

                    this.renderView(defaultView);

                    if (this.options.copyProjectMessageId) {
                        this.copyProjectMessage(this.options.copyProjectMessageId);
                        this.options.copyProjectMessageId = null;
                    }

                }, this)
            });
        } , this));

    },
    getSearchFor: function() {
        let searchFor = this.$('.input-pm-search').val().trim();

        if (searchFor.length <= 15 && PJQ.helpers.formatHelpers.numbersOnly(searchFor).length == 10)
            searchFor = PJQ.helpers.formatHelpers.numbersOnly(searchFor);

        return searchFor;
    },
    getViewData: function (view, callback, overrides) {
        let searchFor = this.getSearchFor(),
            statusFilter = [...this.options.filter.status],
            groupIdList = this.options.filter.groups.join(',');


        if (overrides) {
            if (overrides.isPerGroup)
                statusFilter.push('PER_GROUP');
        }

        if (this.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.filter.publicPrivate)
            statusFilter.push(this.options.filter.publicPrivate);

        _.each(this.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        let viewSettings = this.options.settings.getSettings(view),
            filterCustomField = null,
            filterCustomFieldValue = null;
        if (searchFor.indexOf("::") !== -1 && (view === PJQ.constants.projectMessaging.views.CONT || view === PJQ.constants.projectMessaging.views.COMP)) {
            let filterData = searchFor.split('::'),
                filterCustomFieldName = filterData[0].trim();

            filterCustomFieldValue = filterData[1].trim();

            if (_.size(filterCustomFieldName) > 0 && _.size(filterCustomFieldValue) > 0) {
                filterCustomField = _.find(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    return customField.get('fieldName').toLowerCase() === filterCustomFieldName.toLowerCase();
                }, this));
                if (filterCustomField == null) {
                    filterCustomField = _.find(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                        return customField.get('fieldName').toLowerCase() === filterCustomFieldName.toLowerCase();
                    }, this));
                }

                if (filterCustomField != null) {
                    searchFor = "";
                }
            }
        }

        let data = new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: this.options.project,
            view: view,
            searchFor: searchFor,
            statusFilter: statusFilter.join(','),
            groupIdList: groupIdList,
            withCustomFields: viewSettings.hasCustomFields
        });
        data.fetch({
            success: _.bind(function () {
                if (this.options.filter.isSelected) {
                    data.reset(_.filter(data.models, _.bind(function (row) {
                        return this.options.selectedContacts.indexOf(row.get('contactId')) !== -1;
                    }, this)));
                }

                if (filterCustomField != null) {
                    let filterCfValueLower = filterCustomFieldValue.toLowerCase(),
                        filterCustomFieldChoiceIds = _.map(_.filter(filterCustomField.choices.models, function (cfChoice) {
                            return cfChoice.get('choiceName').trim().toLowerCase().indexOf(filterCfValueLower) !== -1;
                        }), function (cfChoice) {
                            return cfChoice.id;
                        });
                    data.reset(_.filter(data.models, _.bind(function (row) {
                        let checkCf = function (cf) {
                            let result = false;
                            if (cf.id === filterCustomField.id && cf.value != null) {
                                if (filterCustomField.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE) {
                                    result = typeof cf.value.indexOf === 'function' && _.size(_.intersection(cf.value, filterCustomFieldChoiceIds)) > 0;
                                } else {
                                    result = cf.value != null && cf.value.toString().trim().toLowerCase().indexOf(filterCfValueLower) !== -1;
                                }
                            }
                            return result;
                        };
                        return null != _.find(row.get('companyCustomFieldValues'), checkCf) || null != _.find(row.get('contactCustomFieldValues'), checkCf);
                    }, this)));
                }

                callback(data);
            }, this)
        });
    },
    renderView: function (view) {
        if (view != null) {
            this.currentView = view;
        }

        // set response option only valid while NOT in Messages view
        if (this.currentView === PJQ.constants.projectMessaging.views.MSGCONT) {
            this.$('.project-message-set-responses').css('display', 'none');
        } else {
            this.$('.project-message-set-responses').css('display', '');
        }

        let loader = new PJQ.Loader(this.$el);
        this.getViewData(this.currentView, _.bind(function (data) {
            loader.remove();
            loader = null;
            this.renderViewData(this.currentView, data.models);
        }, this));
    },
    renderViewData: function (view, data) {
        if (this.dataTable)
            this.dataTable.cleanup();

        let dataTableOptions = {
            el: this.$('.project-message-grid'),
            data: data,
            view: view,
            projectMessagingView: this,
            userSettings: this.options.settings,
            settings: this.options.settings.getSettings(view),
            afterDataTableRender: _.bind(function (dataTable) {
                if (dataTable) {
                    this.$('.datatable-paging-copy').empty();
                    this.$('.dt-paging', dataTable.el).first().appendTo(this.$('.datatable-paging-copy'));
                }
            }, this)
        };

        this.dataTable = this.getDataTableInstance(dataTableOptions);
    },
    getDataTableInstance: function (options) {
        let dataTable = null;
        switch (options.view) {
            case PJQ.constants.projectMessaging.views.GROUPCOMP:
            case PJQ.constants.projectMessaging.views.GROUPCONT:
                dataTable = new PJQ.views.projects.ProjectMessagingTradesDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
            case PJQ.constants.projectMessaging.views.COMP:
                dataTable = new PJQ.views.projects.ProjectMessagingCompanyDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
            case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
            case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
            case PJQ.constants.projectMessaging.views.MSGCONT_CONT:
            case PJQ.constants.projectMessaging.views.COMP_CONT:
            case PJQ.constants.projectMessaging.views.CONT:
            case PJQ.constants.projectMessaging.views.BIDPKGS_CONT:
                dataTable = new PJQ.views.projects.ProjectMessagingContactDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.MSGCONT:
                dataTable = new PJQ.views.projects.ProjectMessagingMessagesDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.RSPCONT:
                options.order = [];
                dataTable = new PJQ.views.projects.ProjectMessagingResponsesDataTable(options);
                break;
            case PJQ.constants.projectMessaging.views.BIDPKGS:
                dataTable = new PJQ.views.projects.ProjectMessagingBidPackagesDataTable(options);
                break;
        }

        return dataTable;
    },
    manageBidPackages: function () {
        new PJQ.views.bidPackages.ManageBidPackagesModal({
            project: PJQ.app.session.project,
            onClose: _.bind(function () {
                this.renderView(this.dataTable.options.view);
            }, this)
        });
    },
    importBidPackages: function () {
        new PJQ.views.bidPackages.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (submittals) {
                this.renderView(this.dataTable.options.view);
            }, this)
        });
    },
    updateContactStats: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'participants'
            },
            {
                endpoint: 'stats'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint
        }).get().done(_.bind(function (data) {
            this.stats = data;
            this.renderContactStats();
        }, this));
    },
    renderContactStats: function () {
        this.$('.count-total-contacts').html(this.stats.totalCount.toString());
        this.$('.count-selected-contacts').html(_.size(this.options.selectedContacts));
        this.$('.count-unsent-contacts').html(this.stats.unsentCount ? this.stats.unsentCount.toString() : "0");
        this.$('.participant-stats').removeClass('hidden');
        let $buttons = this.$('.project-message-sel-part-header,.project-message-set-responses,.project-message-delete-contacts,.project-message-order-prints,.project-message-resend-messages');
        if (_.size(this.options.selectedContacts) > 0) {
            $buttons.removeClass('hidden');
        } else {
            $buttons.addClass('hidden');
        }
    },
    addByBidPackageRadius: function () {
        new PJQ.views.bidPackages.BidPackageRadiusModal({
            project: this.options.project,
            onSave: _.bind(function (contacts) {
                if (_.size(contacts) > 0) {
                    this.addSelectedContacts(contacts);
                    this.stats.unsentCount += _.size(contacts);
                    this.renderContactStats();
                    this.renderView();
                }
            }, this)
        });
    },
    addSelectedContacts: function (contactIds) {
        this.options.selectedContacts = _.uniq(_.union(contactIds, this.options.selectedContacts));
        this.renderContactStats();
    },
    removeSelectedContacts: function (contactIds) {
        _.each(contactIds, _.bind(function (contactId) {
            this.options.selectedContacts = _.filter(this.options.selectedContacts, function (contact) {
                return contact !== contactId;
            });
        }, this));
        this.renderContactStats();
    },
    clearSelectedContacts: function () {
        this.options.selectedContacts = [];
        this.$('.trade-select-all-contacts, .select-all-contacts, .select-all-companies, .select-company, .select-contact').prop('checked', false);
        this.renderContactStats();
    },
    addSelectedContactGroups: function (contactGroups) {
        this.options.selectedContactGroups = _.uniq(_.union(contactGroups, this.options.selectedContactGroups), false, function (x) {
            return x.contactId + '|' + x.groupId;
        });
    },
    removeSelectedContactGroups: function (contactGroups) {
        _.each(contactGroups, _.bind(function (contactGroup) {
            this.options.selectedContactGroups = _.filter(this.options.selectedContactGroups, function (selectedContactGroup) {
                return !(selectedContactGroup.contactId === contactGroup.contactId && selectedContactGroup.groupId === contactGroup.groupId);
            });
        }, this));
    },
    isContactSelected: function (contactId) {
        return this.options.selectedContacts.indexOf(contactId) !== -1;
    },
    enableDeclinedChanged: function () {
        // enable or disable all select-company and select-contact whose rows have a Disabled status.
        // process the Parent view
        this.enableDeclinedHelper(this.dataTable, this.isEnableDeclined());
    },
    enableDeclinedHelper: function (dataTable, isEnableDeclined) {

        // process each row of this view
        dataTable.dataTable.rows().invalidate().draw();

        // process each child view of this view recursively

    },
    isEnableDeclined: function () {
        return this.$('.project-message-enable-declined').prop('checked');
    },
    searchChanged: function (e) {
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search: function () {
        this.renderView(this.dataTable.options.view);
    },
    filterDialog: function () {
        let filterInfo = new PJQ.models.projectParticipants.FilterInfo(null, {
            project: this.options.project,
            view: this.dataTable.options.view.toLowerCase(),
            searchFor: this.getSearchFor()
        });
        filterInfo.fetch({
            success: _.bind(function () {
                new PJQ.views.projects.FilterProjectParticipantsModal({
                    filterInfo: filterInfo,
                    filter: this.options.filter,
                    projectMessagingView: this,
                    onFilter: _.bind(function () {
                        this.renderView(this.dataTable.options.view);
                    }, this)
                });
            }, this)
        });
    },
    clearFilterClick: function () {
        if (this.options.selectedContacts.length > 0) {
            new PJQ.views.modals.YesNo({
                header: "Participants Selected",
                body: "Clearing the filter will also clear selected contacts.  Do you still want to continue?",
                onYes: _.bind(function () {
                    this.options.selectedContacts = [];
                    this.options.selectedContactGroups = [];
                    this.options.selectedProjectMessageContactBroadcasts = [];
                    this.renderContactStats();
                    this.clearFilter();
                }, this)
            });
        } else
            this.clearFilter();
    },
    clearFilter: function () {
        this.$('.input-pm-search').val('');
        this.$('.select-all-companies, .select-all-contacts, .trade-select-all-contacts').prop('checked', false);
        this.options.isTradesViewSelectAll = false;
        this.options.filter = {
            status: [],
            groups: [],
            isPrintOrder: false,
            isDownloaded: false,
            isVisited: false,
            isSelected: false,
            vendorSector: '',
            publicPrivate: '',
            laborStatus: [],
            minorityStatus: []
        };
        this.renderView(this.dataTable.options.view);
    },
    settings: function () {
        new PJQ.views.projects.ProjectMessagingSettingsModal({
            projectMessagingView: this,
            onSave: _.bind(function () {
                this.renderView(this.dataTable.options.view);
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    deleteContacts: function (contacts, isRemoveFromAB) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'contacts'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                contacts: contacts,
                isRemoveFromAB: isRemoveFromAB
            }
        }).delete().done(_.bind(function () {
            this.removeSelectedContacts(contacts);
            this.updateContactStats();
            PJQ.notifications.notify.successNotify({
                message: 'Contact' + (contacts.length > 1 ? 's' : '') + ' removed successfully.'
            });
            this.renderView();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    deleteContactGroups: function (contactGroups, isRemoveFromAB) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'contactgroups'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                contactGroups: contactGroups,
                isRemoveFromAB: isRemoveFromAB
            }
        }).delete().done(_.bind(function () {
            this.options.selectedContacts = [];
            this.options.selectedContactGroups = [];
            this.updateContactStats();
            PJQ.notifications.notify.successNotify({
                message: 'Contact(s) removed successfully.'
            });
            this.renderView();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    deleteParticipantsFromProject: function () {
        let removeFrom = _.size(this.options.selectedContactGroups) > 0 ? 'selected trades' : 'project';

        if (_.size(this.options.selectedContacts) === 0 && _.size(this.options.selectedContactGroups) === 0) {
            new PJQ.views.BaseModal({
                header: "No Participants Selected",
                body: "Please select one or more participants before using this feature."
            });
            return;
        }

        new PJQ.views.projects.DeleteProjectParticipants({
            title: "Remove Participant" + (_.size(this.options.selectedContacts) > 1 ? 's' : ''),
            body: "Are you sure you want to remove the selected participant" + (_.size(this.options.selectedContacts) > 1 ? 's' : '') + " from the " + removeFrom + '?',
            onDelete: _.bind(function (isRemoveFromAB) {
                if (_.size(this.options.selectedContactGroups) > 0)
                    this.deleteContactGroups(this.options.selectedContactGroups, isRemoveFromAB);
                else
                    this.deleteContacts(this.options.selectedContacts, isRemoveFromAB);
            }, this)
        });
    },
    sendMessage: function (sender, contacts) {
        let defaultTemplateKey = null;
        if (sender && $(sender.currentTarget).data('templateKey')) {
            defaultTemplateKey = $(sender.currentTarget).data('templateKey');
        }
        PJQ.app.session.fetchProjectMessageEmailTemplates(_.bind(function () {
            let replyToContacts = [],
                fnContinue = _.bind(function () {
                this.inviteModal = new PJQ.views.projectInvites.ProjectInviteModal({
                    project: PJQ.app.session.project,
                    emailTemplates: PJQ.app.session.emailTemplates.projectMessage.models,
                    projectMessagingView: this,
                    replyToContacts: replyToContacts,
                    defaultTemplateKey: defaultTemplateKey,
                    onSend: _.bind(function () {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            $('.send-message-templates').show();
                            $('.btn-send-message').hide();
                        }
                        this.$('.send-message-label').html('New Message');
                        this.options.project.set('isOnline', true);
                        this.options.selectedContacts = [];
                        this.options.selectedContactGroups = [];
                        this.options.selectedProjectMessageContactBroadcasts = [];
                        this.options.projectMessageSettings = null;
                        PJQ.app.session.project.inviteSettings = null;
                        this.renderContactStats();
                        this.renderView();
                    }, this),
                    onAddFromThisProject: _.bind(function (inviteSettings) {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            $('.send-message-templates').hide();
                            $('.btn-send-message').show();
                        }
                        $('div.project-messages span.send-message-label').html('Resume Message');
                    }, this),
                    onViewSelected: _.bind(function (inviteSettings) {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            $('.send-message-templates').hide();
                            $('.btn-send-message').show();
                        }
                        $('div.project-messages span.send-message-label').html('Resume Message');
                        this.viewSelectPicker.setValue(PJQ.constants.projectMessaging.views.CONT);
                        this.options.filter = {
                            status: [],
                            groups: [],
                            isPrintOrder: false,
                            isDownloaded: false,
                            isVisited: false,
                            isSelected: true,
                            vendorSector: '',
                            publicPrivate: '',
                            laborStatus: [],
                            minorityStatus: []
                        };
                        this.renderView(PJQ.constants.projectMessaging.views.CONT);
                    }, this),
                    onCancel: _.bind(function () {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_MESSAGING_SHOW_TEMPLATES)) {
                            this.$('.send-message-templates').show();
                            this.$('.btn-send-message').hide();
                        }
                        $('div.project-messages span.send-message-label').html('New Message');
                        PJQ.app.session.project.inviteSettings = null;
                    }, this),
                    isShowQuickAdd: !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISABLE_QUICKADD),
                    isShowAttachments: true
                });

                if (contacts != null) {
                    this.inviteModal.addSelectedContacts(contacts);
                }
            }, this);

            if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_ENABLE_REPLYTO_OVERRIDE)) {
                if (PJQ.app.session.project.get('user'))
                    replyToContacts.push(PJQ.app.session.project.get('user'));

                if (PJQ.app.session.project.get('user2') && _.size(_.filter(replyToContacts, function (user) {
                    return user.id == PJQ.app.session.project.get('user2').id
                })) == 0)
                    replyToContacts.push(PJQ.app.session.project.get('user2'));

                PJQ.app.session.project.fetchProjectContacts(_.bind(function () {
                    _.each(PJQ.app.session.project.projectContacts.models, _.bind(function (projectContact) {
                        if (projectContact.get('id') < 0 && _.size(_.filter(replyToContacts, function (user) {
                            return user.id == projectContact.get('id')
                        })) == 0) {
                            replyToContacts.push(projectContact.attributes);
                        }
                    }, this));
                    fnContinue();
                }, this));
            } else {
                fnContinue();
            }
        }, this));
    },
    quickAdd: function () {
        new PJQ.views.projects.QuickAddParticipantsModal({
            project: this.options.project,
            onSave: _.bind(function (contact) {
                this.addSelectedContacts([contact.id]);
                this.stats.unsentCount++;
                this.renderContactStats();
                this.renderView();
            }, this)
        });
    },
    addNewContact: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectParticipants.ProjectParticipant({
                projectId: PJQ.app.session.project.id,
                masterUserId: PJQ.app.session.get('masterUserId'),
                isForceSaveExistingEmail: false,
                country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US'
            }),
            showNotes: true,
            showActive: true,
            deleteLabel: 'Remove from Project',
            onSave: _.bind(function (model, isNew) {
                this.addSelectedContacts([model.get('contactId')]);
                this.stats.unsentCount++;
                this.stats.totalCount++;
                this.renderContactStats();
                this.renderView();
            }, this)
        });
    },
    detailedSearch: function (e) {
        $('form[name="modal-add-participants"]').remove();
        let options = {
            onSave: _.bind(function (selectedContacts) {
                this.addSelectedContacts(selectedContacts);
                this.stats.unsentCount += _.size(selectedContacts);
                this.renderContactStats();
                this.renderView();
            }, this)
        };

        if ($(e.currentTarget).hasClass('btn-detailed-search-new') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
            options.isWrapForm = false;
            options.wrapFormName = null;
            options.isUseNewAddressBook = true;
        }

        new PJQ.views.projects.AddParticipantsDetailedModal(options);
    },
    simpleSearch: function () {
        let showUnionStatus = true;
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS)) {
            showUnionStatus = !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS);
        }
        new PJQ.views.projectParticipants.AddParticipantsModal({
            model: this.options.project,
            isDirectoryEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY),
            isUnionStatusEnabled: showUnionStatus,
            isReturnContactIds: true,
            onSave: _.bind(function (selectedContacts, sendMessage = false) {
                if (sendMessage && _.size(selectedContacts) > 0) {
                    this.sendMessage(null, selectedContacts);
                } else {
                    this.addSelectedContacts(selectedContacts);
                    this.stats.unsentCount += _.size(selectedContacts);
                    this.renderContactStats();
                    this.renderView();
                }
            }, this)
        });
    },
    quickSearch: function () {
        new PJQ.views.contacts.SelectContactsModal({
            disableBlacklisted: true,
            disableBadEmail: true,
            isSingleChoice: false,
            onSave: _.bind(function (selectedContacts) {
                if (_.size(selectedContacts) === 0) {
                    PJQ.notifications.notify.successNotify({
                        message: 'No participants were added'
                    });
                    return;
                }

                this.options.project.addParticipantsById(selectedContacts, _.bind(function () {
                    this.addSelectedContacts(_.map(selectedContacts, function (selectedContact) {
                        return selectedContact.get('contactId');
                    }));
                    this.stats.unsentCount += _.size(selectedContacts);
                    this.renderContactStats();
                    this.renderView();
                }, this));
            }, this)
        });
    },
    addParticipantsFromProject: function () {
        let statuses = this.options.project.getProjectStatusList();
        statuses.unshift(['PENDING', true]);
        new PJQ.views.projectParticipants.AddParticipantsFromProjectModal({
            model: this.options.project,
            isBidFormsEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS),
            projectResponses: statuses,
            isReturnContactIds: true,
            onSave: _.bind(function (selectedContacts) {
                this.addSelectedContacts(selectedContacts);
                this.stats.unsentCount += _.size(selectedContacts);
                this.renderContactStats();
                this.renderView();
            }, this)
        });
    },
    copyProjectMessage: function (projectMessageId) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'projectmessages',
                value: projectMessageId
            },
            {
                endpoint: 'copy'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
        }).get().done(_.bind(function (data) {
            data.messageType = data.templateKey;
            data.privateFolders = new PJQ.collections.files.Files(data.privateFolders);
            data.attachments = new PJQ.collections.files.Files(data.attachments);
            data.responseDue = data.responseDue ? PJQ.helpers.dateHelpers.getDateString(new Date(data.responseDue), PJQ.helpers.dateHelpers.dateFormats.DATE) : '';
            PJQ.app.session.project.inviteSettings = data;
            this.sendMessage();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong.'
            });
        });

    },
    deleteProjectMessage: function (projectMessageId, callback) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'projectmessages',
                value: projectMessageId
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint
        }).delete().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Message deleted successfully.'
            });
            if (typeof callback === 'function')
                callback();

        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    orderPrints: function () {
        let callback = _.bind(function () {
            let contacts = new PJQ.collections.contacts.ContactInfoList(null, {
                contactIds: this.options.selectedContacts
            });
            contacts.fetch({
                success: _.bind(function () {
                    new PJQ.views.files.OrderPrintsModal({
                        recipients: contacts.models,
                        onOrderPlaced: _.bind(function () {
                            this.clearSelectedContacts();
                        }, this)
                    });
                }, this)
            });
        }, this);

        if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
            new PJQ.views.modals.YesNo({
                header: "Document(s) Processing",
                body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
                onYes: _.bind(function () {
                    callback();
                }, this)
            });
        } else
            callback();

    },
    setResponses: function () {
        if (_.size(this.options.selectedContacts) === 0) {
            new PJQ.views.BaseModal({
                header: "No Participants Selected",
                body: "Please select one or more participants before using this feature."
            });
            return;
        }

        let statuses = this.options.project.getProjectStatusList();
        statuses.unshift(['PENDING', true]);
        new PJQ.views.projects.SetProjectParticipantsStatusModal({
            projectResponses: statuses,
            projectMessagingView: this,
            onSave: _.bind(function (status, companyComment, contactComment) {
                let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.options.project.id
                    },
                    {
                        endpoint: 'participants'
                    },
                    {
                        endpoint: 'status'
                    }
                ]);

                let loader = new PJQ.Loader(this.$el);
                new PJQ.ajax.Request({
                    endpoint: endpoint,
                    data: {
                        ids: this.options.selectedContacts,
                        status: status,
                        companyComment: companyComment,
                        contactComment: contactComment
                    }
                }).post().done(_.bind(function () {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Contact' + (this.options.selectedContacts.length > 1 ? 's' : '') + ' updated successfully.'
                    });
                    this.renderView();
                }, this)).fail(function () {
                    loader.remove();
                    PJQ.notifications.notify.errorNotify({
                        message: 'Something went wrong!'
                    });
                });
            }, this)
        });
    },
    exportView: function () {
        let statusFilter = [...this.options.filter.status];

        if (this.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.filter.publicPrivate)
            statusFilter.push(this.options.filter.publicPrivate);

        _.each(this.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        statusFilter = statusFilter.join(',');

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'participants'
            },
            {
                endpoint: 'views',
                value: this.currentView
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'statusFilter',
                value: statusFilter
            },
            {
                parameter: 'groupIdList',
                value: this.options.filter.groups.join(',')
            },
            {
                parameter: 'searchFor',
                value: this.getSearchFor()
            },
            {
                parameter: 'withCustomFields',
                value: true
            }
        ]));

    }
});

// Modals
PJQ.views.projects.GradeProjectContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Grade-Project-Contact'),
        width: '300px',
        onGrade: _.noop,
        row: null
    },
    events: {
        'click button.grade': 'gradeChanged',
        'click button.clear-grade': 'onClear'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        this.renderData = {
            companyName: this.options.row.data().get('companyName')
        };
    },
    afterRender: function () {
        if (this.options.row.data().get('grade') > 0)
            this.$('button[data-stars="1"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 1)
            this.$('button[data-stars="2"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 2)
            this.$('button[data-stars="3"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 3)
            this.$('button[data-stars="4"] i').removeClass('text-muted').addClass('text-gold');
        if (this.options.row.data().get('grade') > 4)
            this.$('button[data-stars="5"] i').removeClass('text-muted').addClass('text-gold');
    },
    gradeChanged: function (e) {
        this.options.row.data().set('grade', parseInt(this.$(e.currentTarget).data('stars')));
        this.$('button.grade').removeClass('text-gold').addClass('text-muted');
        this.afterRender();
        this.onGrade();
    },
    onGrade: function () {
        if (typeof this.options.onGrade === 'function')
            this.options.onGrade(this.options.row.data().get('grade'));
        this.removeModal();
    },
    onClear: function () {
        this.$('button.grade').removeClass('text-gold').addClass('text-muted');
        this.options.row.data().set('grade', 0);
        this.onGrade();
    }
});

PJQ.views.projects.ProjectParticipantCommentModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Participant-Comment'),
        minWidth: '400px',
        onComment: _.noop,
        project: null,
        comments: [],
        participant: null,
        isCompanyComments: false
    },
    events: {
        'keyup .project-contact-comment': 'commentChanged',
        'click .project-contact-comment-save': 'commentAdded',
        'click .project-comment-delete': 'commentDeleted'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        this.renderData = {
            companyName: this.options.participant.attributes.companyName,
            contactName: this.options.participant.attributes.contactName,
            comments: this.options.comments
        };
    },
    afterRender: function () {
    },
    commentDeleted: function (sender) {
        this.selectedCard = this.$(sender.currentTarget).closest('div.card');
        new PJQ.views.BaseModal({
            header: "Delete Comment",
            body: "Are you sure you want to delete this comment?",
            isShowCancelButton: true,
            onOk: _.bind(function () {
                let comment = new PJQ.models.projectParticipants.ProjectContactComment(null, {
                        project: this.options.project,
                        contactId: this.options.isCompanyComments ? this.options.participant.attributes.contactCompanyId : this.options.participant.attributes.contactId
                    }),
                    projectContactCommentId = parseInt(this.selectedCard.data('projectContactCommentId')),
                    parentContainer = this.selectedCard.parent(),
                    isLastCard = this.selectedCard.hasClass('last-comment');

                this.selectedCard.remove();

                // if no comments left, return the 'empty comment' comment back to the caller
                if ($('div.card', parentContainer).length === 0) {
                    comment.set('comment', 'No Comments Added');
                    if (typeof this.options.onComment === 'function')
                        this.options.onComment(comment);

                    this.$('.comments-header, .comments-list').hide();

                } else if (isLastCard) {
                    // if this was the newest comment, return the next newest comment back to the caller and mark the next newest comment
                    comment.set('comment', this.$('div.card').last().find('.comment-body').text().trim());

                    if (typeof this.options.onComment === 'function')
                        this.options.onComment(comment);

                    this.$('div.card').last().addClass('last-comment');
                }

                comment.set('projectContactCommentId', projectContactCommentId);
                comment.destroy();
            }, this)
        });

    },
    commentChanged: function () {
        this.$('.project-contact-comment-save').prop('disabled', _.size(this.$('.project-contact-comment').val()) === 0);
    },
    commentAdded: function () {
        this.onComment();
    },
    onComment: function () {
        let comment = new PJQ.models.projectParticipants.ProjectContactComment(null, {
            project: this.options.project,
            contactId: this.options.isCompanyComments ? this.options.participant.attributes.contactCompanyId : this.options.participant.attributes.contactId,
            isCompanyComments: this.options.isCompanyComments
        });
        comment.set('comment', this.$('.project-contact-comment').val());
        comment.save(null, {
            success: _.bind(function () {
                if (typeof this.options.onComment === 'function')
                    this.options.onComment(comment);
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.FilterProjectParticipantsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Filter-Project-Participants'),
        width: '600px',
        filterInfo: null,
        filter: null,
        onFilter: _.noop
    },
    events: {
        'click button.filter': 'filter'
    },
    beforeModalCreated: function () {
        this.options.fieldSettingsEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
        if (this.options.fieldSettingsEnabled && this.coreFieldSettings == null) {
            PJQ.app.session.fetchContactFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                this.coreFieldSettings = settings;
                this.render();
            }, this));
        }
    },
    beforeRender: function () {
        this.renderData = {
            filterInfo: this.options.filterInfo,
            filter: this.options.filter,
            view: this.options.projectMessagingView.dataTable.options.view,
            checkFieldVisible: _.bind(this.checkFieldVisible, this)
        };
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let result;
            switch (fieldName) {
                case 'sector':
                    result = !prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_SECTOR);
                    break;
                case 'laborStatus':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
                    break;
                case 'classifications':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_MINORITY_STATUS) === false;
                    break;
                default:
                    result = true;
            }
            return result;
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisibleContact') || fieldSettings.get('isVisibleAdmin');
            }
        }
        return true;
    },
    afterRender: function () {
        _.each(this.options.filter.status, _.bind(function (status) {
            this.$('input.filter-status[data-status="' + status + '"]').prop('checked', true);
        }, this));

        this.$('input.filter-print-order').prop('checked', this.options.filter.isPrintOrder);
        this.$('input.filter-download').prop('checked', this.options.filter.isDownloaded);
        this.$('input.filter-visited').prop('checked', this.options.filter.isVisited);
        this.$('input.filter-selected').prop('checked', this.options.filter.isSelected);

        this.sectorSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-sector'),
            defaultValue: this.options.filter.vendorSector
        });

        this.publicPrivateSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-public-private'),
            defaultValue: this.options.filter.publicPrivate
        });

        this.laborStatusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-labor-status'),
            isMultiple: true,
            noneSelectedText: 'All Labor Statuses',
            defaultValue: this.options.filter.laborStatus
        });

        this.minorityStatusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.filter-minority-status'),
            isMultiple: true,
            noneSelectedText: 'All Certifications',
            defaultValue: this.options.filter.minorityStatus
        });

        this.groupSelector = new PJQ.views.groups.GroupSelector({
            el: this.$('.filter-groups'),
            isShowNoGroup: true,
            isShowGroupCount: true,
            groups: this.options.filterInfo.get('groups'),
            selectedGroupIds: this.options.filter.groups,
            onGroupSelected: _.bind(function () {
                //this.selectedGroups = this.groupSelector.getGroupsData().new;
            }, this)
        });

    },
    filter: function () {

        this.options.projectMessagingView.options.filter.status = [];

        _.each(this.$('input.filter-status'), _.bind(function (input) {
            if ($(input).prop('checked'))
                this.options.projectMessagingView.options.filter.status.push($(input).data('status'));
        }, this));

        this.options.projectMessagingView.options.filter.isPrintOrder = this.$('input.filter-print-order').prop('checked');
        this.options.projectMessagingView.options.filter.isDownloaded = this.$('input.filter-download').prop('checked');
        this.options.projectMessagingView.options.filter.isVisited = this.$('input.filter-visited').prop('checked');
        this.options.projectMessagingView.options.filter.isSelected = this.$('input.filter-selected').prop('checked');
        this.options.projectMessagingView.options.filter.vendorSector = this.$('select.filter-sector').val();
        this.options.projectMessagingView.options.filter.publicPrivate = this.publicPrivateSelectPicker.getValue();
        this.options.projectMessagingView.options.filter.laborStatus = this.laborStatusSelectPicker.getValue();
        this.options.projectMessagingView.options.filter.minorityStatus = this.minorityStatusSelectPicker.getValue();

        this.options.projectMessagingView.options.filter.groups = [];

        let groupsData = this.groupSelector.getGroupsData();
        _.each(groupsData.selected, _.bind(function (group) {
            this.options.projectMessagingView.options.filter.groups.push(group.id);
        }, this));

        if (typeof this.options.onFilter === 'function')
            this.options.onFilter();

        this.removeModal();
    }
});

PJQ.views.projects.ProjectMessagingSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Messaging-Settings'),
        width: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
    },
    beforeRender: function () {
        // copy settings for our UI; we only update global settings object on save.
        this.options.settings = [];
        this.options.defaultView = this.options.projectMessagingView.options.settings.get('defaultView');
        _.each(this.options.projectMessagingView.options.settings.attributes.settings, _.bind(function (setting) {
            let dbInstance = this.options.projectMessagingView.getDataTableInstance({
                    view: setting.view,
                    settings: this.options.projectMessagingView.options.settings.getSettings(setting.view)
                }),
                columns = [];
            if (dbInstance != null) {
                columns = dbInstance.getColumns(true);
            }
            selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));


            this.options.settings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });

        }, this));

        this.renderData = {
            showGroupCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY),
            showGroupContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT),
            showCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY),
            showContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT),
            showBidPackagesView: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES)
        };
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view-default'),
            defaultValue: this.options.defaultView,
            onChange: _.bind(function (value) {
                this.options.defaultView = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view'),
            defaultValue: this.options.projectMessagingView.dataTable.options.view,
            onChange: _.bind(function (value) {
                this.selectView(value);
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)

        });

        this.selectView(this.options.projectMessagingView.dataTable.options.view);
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.settings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.$('div.rows-per-page').show();
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
        } else
            this.$('div.rows-per-page').hide();

        if (view === PJQ.constants.projectMessaging.views.GROUPCOMP || view === PJQ.constants.projectMessaging.views.GROUPCONT || view === PJQ.constants.projectMessaging.views.MSGCONT || view === PJQ.constants.projectMessaging.views.RSPCONT || view === PJQ.constants.projectMessaging.views.BIDPKGS)
            this.$('div.select-columns').hide();
        else {
            this.$('div.select-columns').show();

            if (this.dataTable) {
                this.dataTable.undelegateEvents();
                $(this.dataTable.el).empty();
            }

            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$('div.select-columns-datatable'),
                data: this.currentView.columns,
                isHideSearch: true,
                order: [],
                columns: [
                    {"data": "title", "title": "Column", "orderable": false},
                    {
                        "data": "visible",
                        "title": "Show",
                        "orderable": false,
                        "searchable": false,
                        "render": _.bind(function (data) {
                            return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                        }, this),
                        "width": '10%'
                    }
                ],
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'

            });
        }
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        //update global settings from local
        this.options.projectMessagingView.options.settings.set('defaultView', this.options.defaultView);

        _.each(this.options.settings, _.bind(function (settingTemp) {
            _.each(this.options.projectMessagingView.options.settings.get('settings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        } else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        //save settings to database
        this.options.projectMessagingView.options.settings.save(null, {
            success: _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave();

                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.ManageProjectParticipantTradesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Participant-Trades'),
        minWidth: '900px',
        onSave: _.noop
    },
    events: {
        'click .manage-trades-save': 'onSave',
        'change .select-trade': 'tradeSelectChanged',
        'change .select-all-trades': 'tradeSelectAllChanged'
    },
    beforeRender: function () {
        this.renderData = {};
    },
    afterRender: function () {
        this.groups = new PJQ.collections.projectParticipants.ProjectParticipantGroups(null, {
            contactId: this.options.contactId
        });

        this.groups.fetch({
            success: _.bind(function () {
                this.dataTable = new PJQ.views.dataTables.DataTable({
                    el: this.$('.project-participant-trades'),
                    pageLength: 999999,
                    isHideSearch: true,
                    data: this.groups.models,
                    dom: 't',
                    order: [],
                    columns: [
                        {
                            "data": "attributes.isSelected",
                            "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-trades" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>',
                            "orderable": false,
                            "searchable": false,
                            "render": _.bind(function (data) {
                                return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-trade"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                            }, this),
                            "width": '10%'
                        },
                        {
                            "data": "attributes.groupName",
                            "title": "Trade",
                            "orderable": false
                        }
                    ]
                });
            }, this)
        });
    },
    tradeSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow(tr);

        row.data().set('isSelected', $(e.currentTarget).prop('checked'));
    },
    tradeSelectAllChanged: function (e) {
        _.each(this.$el.find('input.select-trade'), _.bind(function (input) {
            let tr = $(input).closest('tr'),
                row = this.dataTable.getRow(tr);

            row.data().set('isSelected', $(e.currentTarget).prop('checked'));
            $(input).prop('checked', $(e.currentTarget).prop('checked'));
        }, this));

    },
    onSave: function () {
        this.groups.save({
            success: _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.groups);

                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.SetProjectParticipantsStatusModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Set-Project-Participants-Status'),
        minWidth: '500px',
        onSave: _.noop,
        projectResponses: [],
        projectMessagingView: null
    },
    events: {
        'click .set-responses': 'onSave',
        'click .comment-type>div': 'commentTypeClicked'
    },
    beforeRender: function () {
        this.renderData = {
            projectResponses: this.options.projectResponses
        };
    },
    afterRender: function () {

        let isContactComment = false;
        _.each(this.options.projectMessagingView.options.settings.get('settings'), _.bind(function (setting) {
            _.each(setting.columns, _.bind(function (column) {
                if (column === 'commentsContact')
                    isContactComment = true;
            }, this));
        }, this));

        if (isContactComment)
            this.$('.comment-type>div[data-filter="contact-comment"]').click();

        this.projectStatus = new PJQ.inputs.Selectpicker({
            el: this.$('.project-status'),
            defaultValue: this.options.projectResponses[0][0]
        });
    },
    commentTypeClicked: function (e) {
        let $target = $(e.currentTarget),
            filter = $target.data('filter');
        this.$('.comment-type>div').removeClass('selected');
        $target.addClass('selected');

        this.$('.comments>textarea').hide();
        this.$('.' + $target.data('filter')).show();
    },
    onSave: function () {
        new PJQ.views.modals.YesNo({
            header: "Set Status",
            body: "Are you sure you want to set the Project Status for " + _.size(this.options.projectMessagingView.options.selectedContacts) + " participants?",
            onYes: _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.projectStatus.getValue(), this.$('.company-comment').val(), this.$('.contact-comment').val());

                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.projects.DeleteProjectParticipants = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Delete-Project-Participants'),
        minWidth: '500px',
        onDelete: _.noop,
        title: '',
        body: ''
    },
    events: {
        'click .btn-remove': 'onDelete'
    },
    beforeModalCreated: function () {
        this.canDeleteContact = PJQ.app.session.hasPermission('contacts.canDelete');
    },
    renderData: function () {
        return {
            title: this.options.title,
            body: this.options.body,
            canDeleteContact: this.canDeleteContact
        };
    },
    onDelete: function () {
        if (typeof this.options.onDelete === 'function')
            this.options.onDelete(this.canDeleteContact && this.$('.delete-ab').prop('checked'));

        this.removeModal();
    }
});

PJQ.views.projects.ProjectMessagingDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No data to display"
        },
        subTemplates: {
            commentsTooltip: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'tooltip-comments'),
            addCommentTooltip: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'tooltip-add-comment'),
        },
        isHideSearch: true,
        dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>',
        enableColumnResize: false
    },
    onColumnResizeEnd: function (c, columns) {
        let totalWidth = 0,
            colWidths = {};
        _.each(columns, function (col) {
            let colWidth = parseInt(col.width.replace('px', ''));
            totalWidth += colWidth;
            colWidths[col.idx] = colWidth;
        });

        let colPercents = {},
            totalPercent = 0;
        _.each(colWidths, function (col, idx) {
            let percent = (col / totalWidth) * 100;
            if (percent < 2) {
                percent = 2;
            } else {
                percent = Math.floor(percent);
            }
            totalPercent += percent;
            colPercents[idx] = percent;
        });

        let newColumns = [];
        _.each(this.options.settings.columns, function (col, idx) {
            let data,
                colTp = typeof col;
            if (colTp === 'string') {
                data = col;
            } else if (colTp === 'object' && typeof colTp.data === 'string') {
                data = colTp.data;
            } else {
                data = "";
            }
            newColumns.push({
                data: data,
                width: colPercents[idx].toString() + '%'
            });
        })
        this.options.settings.columns = newColumns;
    },
    beforeDataTableRender: function () {
        this.options.scrollRows = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DATA_TABLE_FIXED_HEADER);

        this.options.projectStatusList = PJQ.app.session.project.getProjectStatusList();
        this.options.childDataTables = [];

        this.options.contextMenuOptions = {
            actions: this.getContextMenuItems(),
            isHideNoActions: true
        };

        if (this.options.settings) {
            // enable paging for grids that have a setting for it / are not subgrids
            if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
                this.options.pageLength = this.options.settings.rowsPerPage;
            else
                this.options.pageLength = 2147483646;

            this.setCustomOrder();

            let fixedColumnsLeft = 0;
            switch (this.options.settings.view) {
                case PJQ.constants.projectMessaging.views.GROUPCONT:
                case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
                case PJQ.constants.projectMessaging.views.GROUPCOMP:
                case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
                case PJQ.constants.projectMessaging.views.MSGCONT:
                case PJQ.constants.projectMessaging.views.MSGCONT_CONT:
                case PJQ.constants.projectMessaging.views.RSPCONT:
                case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
                case PJQ.constants.projectMessaging.views.BIDPKGS_CONT:
                    fixedColumnsLeft = 1;
                    break;
                case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
                case PJQ.constants.projectMessaging.views.CONT:
                case PJQ.constants.projectMessaging.views.COMP:
                case PJQ.constants.projectMessaging.views.COMP_CONT:
                    fixedColumnsLeft = 2;
                    break;
            }
            if (fixedColumnsLeft > 0) {
                this.options.colReorder = {
                    fixedColumnsLeft: fixedColumnsLeft,
                    realtime: false
                };
            }
        }

        this.options.createdRow = _.bind(this.createdRow, this);

        if (typeof this.options.beforeDataTableRender === 'function') {
            this.options.beforeDataTableRender();
        }
    },
    setCustomOrder: function () {
        if (!this.options.settings)
            return;

        if (this.options.settings.orderBy !== 'sortOrder') {
            if (_.size(this.options.settings.columns) === 0) {
                this.options.settings.orderBy = this.options.settings.columnsDefault[0];
            } else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
                this.options.settings.orderBy = this.options.settings.columns[0];
            }
        }
        _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
            if (column.columnData === this.options.settings.orderBy) {
                this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
            }
        }, this));

        if (this.options.settings.view !== PJQ.constants.projectMessaging.views.GROUPCONT &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.GROUPCOMP &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.BIDPKGS &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.MSGCONT &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.RSPCONT) {
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === 'companyName' && this.options.settings.orderBy !== 'companyName') {
                    this.options.order.push([index, 'asc']);
                }
            }, this));
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === 'contactName' && this.options.settings.orderBy !== 'contactName') {
                    this.options.order.push([index, 'asc']);
                }
            }, this));
            if (this.dataTable) {
                this.dataTable.order(this.options.order).draw();
            }
        }
    },
    columnOrderChanged: function (columns) {
        if (this.options.userSettings != null) {
            /* #311 - error when drag-drop sorting columns.
            let settings = this.options.userSettings.get('settings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.view) {
                    settings[i].columns = columns;
                }
            }
            this.options.userSettings.set('settings', settings);

             */
            this.options.userSettings.save();
        }
    },
    orderByChanged: function (columns) {
        this.setCustomOrder();
        if (this.options.userSettings != null) {
            let settings = this.options.userSettings.get('settings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.settings.view) {
                    settings[i].orderBy = this.options.settings.orderBy;
                    settings[i].orderAscending = this.options.settings.orderAscending;
                }
            }
            this.options.userSettings.set('settings', settings);
            this.options.userSettings.save();
        }
    },
    afterDataTableRender: function () {
        this.afterDataTableRenderChild();
    },
    afterDataTableRenderChild: function () {
    },
    getRowChildTable: function (childOpts) {
    },
    getRowChildData: function (row) {
    },
    setRowStyle: function (row, status, isBlacklisted) {
    },
    getContextMenuItems: function () {

    },
    statusChanged: function (statuses) {
    },
    getCustomFieldColumn: function (customField, isCompany) {
        return {
            "columnData": (isCompany ? 'companyCustomField' : 'contactCustomField') + '_' + customField.get('id'),
            "title": customField.get('fieldName'),
            "render": function (data, type, row) {
                let rowField;
                if (isCompany) {
                    rowField = row.getCompanyCustomField(customField.get('id'));
                } else {
                    rowField = row.getContactCustomField(customField.get('id'));
                }

                let fieldValue = null;
                if (rowField != null) {
                    fieldValue = rowField.value;
                }
                switch (customField.get('fieldType')) {
                    case PJQ.constants.customFields.fieldTypes.TEXT:
                        if (fieldValue && type !== 'sort' && type !== 'type') {
                            if (PJQ.helpers.urlHelpers.isURL(fieldValue))
                                fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
                        }
                        break
                    case PJQ.constants.customFields.fieldTypes.DATE:
                        if (fieldValue) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                        if (fieldValue) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.BOOL:
                        if (fieldValue != null)
                            fieldValue = fieldValue ? 'Yes' : 'No';
                        else
                            fieldValue = '';
                        break;
                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                        if (fieldValue) {
                            let choices = [];

                            // convert single choice value into array so that the logic below can work for both types.
                            if (typeof fieldValue === 'number')
                                fieldValue = [fieldValue];

                            _.each(customField.choices.models, _.bind(function (choice) {
                                if (_.find(fieldValue, function (value) {
                                    return value === choice.get('id');
                                }))
                                    choices.push(choice.get('choiceName'));
                            }, this));

                            fieldValue = choices.join((', '));
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.MONEY:
                        if (type === 'sort' || type === 'type') {
                            if (fieldValue && fieldValue !== '$')
                                fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                            else
                                fieldValue = 0;

                        } else
                            fieldValue = PJQ.helpers.formatHelpers.formatCurrency(fieldValue);
                        break;
                    case PJQ.constants.customFields.fieldTypes.PHONE:
                        if (type !== 'sort' && type !== 'type') {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (fieldValue ? PJQ.helpers.formatHelpers.formatPhoneNumber(fieldValue) : 'N/A'),
                                phoneWrapped = (fieldValue ? PJQ.helpers.formatHelpers.formatPhoneNumber(fieldValue, true) : 'N/A');

                            if (fieldValue !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (fieldValue ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';

                            fieldValue = html;
                        }
                        break;
                }
                return fieldValue;
            },
            "customFieldId": customField.get('id')
        };
    },
    gradeContactCompany: function (sender) {
        let $target = $(sender.currentTarget),
            contactCompanyId = $target.data('contactCompanyId'),
            tr = $target.closest('tr'),
            parentTR = $target.closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr);

        new PJQ.views.projects.GradeProjectContactModal({
            contactCompanyId: contactCompanyId,
            row: row,
            onGrade: _.bind(function (grade) {
                let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'participants',
                        value: row.data().get('contactCompanyId')

                    },
                    {
                        endpoint: 'grade',
                        value: row.data().get('grade')

                    }
                ]);
                new PJQ.ajax.Request({
                    endpoint: endpoint
                }).post().done(_.bind(function (data) {
                    row.data().set('gradeAverage', data);
                    row.invalidate().draw();

                    if (this.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
                        // update child table for this company
                        _.each(this.options.childDataTables, _.bind(function (childDT) {
                            if (typeof childDT.statusChanged === 'function') {
                                if (row.data().get('contactCompanyId') !== childDT.$el.data('id'))
                                    return;

                                _.each(childDT.dataTable.data(), _.bind(function (item) {
                                    item.set('gradeAverage', data);
                                    item.set('grade', row.data().get('grade'));
                                }, this));

                                childDT.dataTable.rows().invalidate().draw();
                            }
                        }, this));

                    } else if (this.options.view === PJQ.constants.projectMessaging.views.COMP_CONT || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT) {
                        // update all other rows in this table for the same company
                        _.each(this.dataTable.data(), _.bind(function (item) {
                            item.set('gradeAverage', data);
                            item.set('grade', row.data().get('grade'));
                        }, this));
                        this.dataTable.rows().invalidate().draw();

                        // update parent table / company row
                        let rowParent = this.options.parentDataTable.getRow(parentTR);
                        rowParent.data().set('gradeAverage', data);
                        rowParent.data().set('grade', row.data().get('grade'));
                        rowParent.invalidate().draw();
                    }

                    PJQ.notifications.notify.successNotify({
                        message: 'Grade recorded successfully'
                    });
                }, this)).fail(function () {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Unable to record Grade.  Please contact customer service.'
                    });
                });
            }, this)
        });
    },
    childRowToggle: function (sender) {
        let $target = $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
            let childClass = 'subgrid-' + id.toString(),
                $childTable = $('<div data-id="' + id + '" />', {
                    class: childClass + ' p-2'
                });
            row.child($childTable).show();

            let childData = this.getRowChildData(row);
            if (childData != null) {
                childData.fetch({
                    success: _.bind(function () {
                        if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCONT) {
                            let selectedContactGroups = [], groupId = parseInt(childData.options.groupIdList);
                            _.each(childData.models, _.bind(function (contact) {
                                _.each(this.options.projectMessagingView.options.selectedContactGroups, _.bind(function (contactGroup) {
                                    if (contactGroup.contactId === contact.get('contactId'))
                                        selectedContactGroups.push({
                                            contactId: contact.get('contactId'),
                                            groupId: groupId
                                        });
                                }, this));
                            }, this));
                            this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
                        }

                        if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                            let selectedContactGroups = [], groupId = parseInt(childData.options.groupIdList),
                                isEnableDeclined = this.options.projectMessagingView.isEnableDeclined();

                            _.each(childData.models, _.bind(function (company) {

                                let selectedContacts = company.attributes.selectableContacts;
                                if (isEnableDeclined)
                                    $.merge(selectedContacts, company.attributes.declinedContacts);

                                _.each(selectedContacts, _.bind(function (contact) {
                                    _.each(this.options.projectMessagingView.options.selectedContactGroups, _.bind(function (contactGroup) {

                                        // iterate through selectable contacts and add em if their ids match the list
                                        if (contactGroup.contactId === contact)
                                            selectedContactGroups.push({contactId: contact, groupId: groupId});
                                    }, this));

                                }, this));

                            }, this));

                            this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
                        }

                        let childTable = this.getRowChildTable({
                            el: $childTable,
                            data: childData.models,
                            parentDataTable: this,
                            parentId: id,
                            projectMessagingView: this.options.projectMessagingView
                        });
                        this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                            return childDt.options.parentId !== id;
                        }, this));
                        this.options.childDataTables.push(childTable);
                        tr.addClass('shown');
                    }, this)
                });
            }
        }
    },
    childRowToggleAll: function (sender) {
        let $target = $(sender.currentTarget);

        this.dataTable.rows().eq(0).each(_.bind(function (index) {
            let row = this.dataTable.row(index), id = row.data().get('groupId');

            if ($target.hasClass('fa-plus-circle') && !row.child.isShown()) {
                let childClass = 'subgrid-' + id.toString(),
                    $childTable = $('<div data-id="' + id + '" />', {
                        class: childClass
                    });
                row.child($childTable).show();

                let childData = this.getRowChildData(row);
                if (childData != null) {
                    childData.fetch({
                        success: _.bind(function () {
                            let childTable = this.getRowChildTable({
                                el: $childTable,
                                data: childData.models,
                                parentDataTable: this,
                                parentId: id,
                                projectMessagingView: this.options.projectMessagingView
                            });
                            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                                return childDt.options.parentId !== id;
                            }, this));
                            this.options.childDataTables.push(childTable);
                            $(row.node()).addClass('shown');
                        }, this)
                    });
                }
            } else if ($target.hasClass('fa-minus-circle') && row.child.isShown()) {
                row.child.hide();
                $(row.node()).removeClass('shown');
            }

        }, this));

        if ($target.hasClass('fa-plus-circle'))
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
        else
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
    },
    onStatusChanged: function (e) {
        let $target = $(e.currentTarget),
            status = $target.val().toUpperCase(),
            row = this.getRow($target.closest('tr')),
            TR = $target.closest('tr'),
            parentTR = $target.closest('tr').parent().closest('tr').prev(),
            data = row.data(), callback = _.bind(function () {
                data.updateStatus(status, _.bind(function (statuses) {

                    data.set('status', status);

                    if (this.options.parentDataTable != null) {

                        if (this.options.view !== PJQ.constants.projectMessaging.views.CONTGROUP ||
                            (this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT &&
                                this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.GROUPCONT_CONT) ||
                            parseInt(this.options.parentDataTable.dataTable.rows(0).row().data().collection.options.groupIdList) === row.data().get('groupId')) {

                            this.options.parentDataTable.statusChanged(statuses, parentTR, this.options.view);
                        }
                    }

                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        if (typeof childDT.statusChanged === 'function') {
                            let data = row.data();
                            if ((data.collection.options.view === PJQ.constants.projectMessaging.views.COMP) && data.get('contactCompanyId') !== childDT.$el.data('id'))
                                return;

                            if ((data.collection.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.GROUPCONT_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.COMP_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.RSPCONT_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.BIDPKGS_CONT)
                                && data.get('contactId') !== childDT.$el.data('id'))
                                return;

                            childDT.statusChanged(statuses, null, this.options.view);
                        }
                    }, this));

                    this.setRowStyle(TR, data.attributes.status, data.attributes.isBlacklisted || data.attributes.isCompanyBlacklisted);

                    PJQ.notifications.notify.successNotify({
                        message: 'Status updated'
                    });
                }, this));
            }, this);

        let groupListArray = data.get('groupListDisplay') != null ? data.get('groupListDisplay').split(',') : [];
        if (groupListArray.length > 1 && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RSVP_DISABLE_PER_GROUP) && this.options.view !== PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT && this.options.view !== PJQ.constants.projectMessaging.views.GROUPCONT_CONT && this.options.view !== PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
            new PJQ.views.modals.YesNo({
                header: "Confirm Status Change",
                body: "Are you sure you want to change the status for all Trades for this Participant?",
                onYes: _.bind(function () {
                    callback();
                }, this),
                onNo: _.bind(function () {
                    $target.val(data.get('status'));
                }, this)
            });
        } else {
            callback();
        }
    },
    mouseoverComments: function (e) {
        let $target = $(e.currentTarget),
            row = this.getRow($target.closest('tr')),
            participant = row.data(),
            isCompanyComments = $target.hasClass('comment-company');
        if (_.size(isCompanyComments ? participant.get('lastCompanyComment') : participant.get('lastContactComment')) > 0) {
            this.commentHoverContactId = isCompanyComments ? null : participant.id;
            this.commentHoverContactCompanyId = isCompanyComments ? participant.id : null;
            let fnShowComments = _.bind(function (comments) {
                let tooltip = new PJQ.Tooltip($target, {
                    template: this.options.subTemplates.commentsTooltip,
                    container: this.$el,
                    trigger: 'hover',
                    renderData: function () {
                        return {
                            comments
                        };
                    }
                });
                tooltip.show();
            }, this);
            if (!isCompanyComments && participant.comments && participant.comments.isFetched) {
                fnShowComments(participant.comments);
            } else if (isCompanyComments && participant.companyComments && participant.companyComments.isFetched) {
                fnShowComments(participant.companyComments);
            } else {
                setTimeout(_.bind(function () {
                    if ((isCompanyComments && this.commentHoverContactCompanyId === participant.id)
                        || !isCompanyComments && this.commentHoverContactId === participant.id) {
                        let comments = new PJQ.collections.projectParticipants.ProjectParticipantComments(null, {
                            participant: participant,
                            project: PJQ.app.session.project,
                            isCompanyComments: isCompanyComments
                        });
                        comments.fetch({
                            success: _.bind(function () {
                                if (isCompanyComments) {
                                    participant.companyComments = comments;
                                } else {
                                    participant.comments = comments;
                                }
                                fnShowComments(comments);
                            }, this)
                        });
                    }
                }, this), 1000);
            }
        }
    },
    mouseleaveComments: function () {
        this.commentHoverContactId = null;
        this.commentHoverContactCompanyId = null;
    },
    addComment: function (e) {
        let $target = $(e.currentTarget),
            row = this.getRow($target.closest('tr')),
            participant = row.data(),
            isCompanyComments = $target.hasClass('btn-add-comment-company'),
            contextId = isCompanyComments ? participant.attributes.contactCompanyId : participant.attributes.contactId,
            tooltip = new PJQ.Tooltip($target, {
                template: this.options.subTemplates.addCommentTooltip,
                container: this.$el,
                trigger: 'click',
                title: '',
                onShow: _.bind(function () {
                    setTimeout(_.bind(function () {
                        this.$el.find('.comment-text-tooltip').focus();
                    }, this), 300);
                }, this),
                afterRender: _.bind(function (tp) {
                    this.$el.off('keypress', '.comment-text-tooltip[data-contact-id="'+contextId+'"]');
                    this.$el.on('keypress', '.comment-text-tooltip[data-contact-id="'+contextId+'"]', function (e) {
                        if (e.which === 13) {
                            $(this).siblings('.btn-add-comment-tooltip[data-contact-id="'+contextId+'"]').trigger('click');
                            e.preventDefault();
                        }
                    });

                    this.$el.off('click', '.btn-add-comment-tooltip[data-contact-id="'+contextId+'"]');
                    this.$el.on('click', '.btn-add-comment-tooltip[data-contact-id="'+contextId+'"]', _.bind(function (e) {
                        let $comment = $(e.currentTarget).parent().find('.comment-text-tooltip[data-contact-id="'+contextId+'"]'),
                            commentText = $comment.val();
                        if (_.size(commentText) > 0) {
                            let comment = new PJQ.models.projectParticipants.ProjectContactComment({
                                comment: commentText
                            }, {
                                project: PJQ.app.session.project,
                                contactId: contextId,
                                isCompanyComments: isCompanyComments
                            });
                            comment.save(null, {
                                success: _.bind(function () {
                                    tp.remove();

                                    let parentTR = $target.closest('tr').parent().closest('tr').prev(),
                                        rowParent = this.options.parentDataTable != null ? this.options.parentDataTable.getRow(parentTR) : null;
                                    this.onComment(row, rowParent, comment, isCompanyComments);
                                }, this)
                            });
                        }
                    }, this));
                }, this),
                renderData: function () {
                    return {
                        participant : participant,
                        contactId: contextId
                    };
                }
            });
        tooltip.show();
    },
    manageComments: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr')),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            participant = row.data(),
            isCompanyComments = $(e.currentTarget).hasClass('btn-comment-company') || $(e.currentTarget).hasClass('btn-comment-contact-company'),
            comments = new PJQ.collections.projectParticipants.ProjectParticipantComments(null, {
                participant: participant,
                project: PJQ.app.session.project,
                isCompanyComments: isCompanyComments
            });
        comments.fetch({
            success: _.bind(function () {
                new PJQ.views.projects.ProjectParticipantCommentModal({
                    participant: participant,
                    comments: comments.models,
                    project: PJQ.app.session.project,
                    isCompanyComments: isCompanyComments,
                    onComment: _.bind(function (comment) {
                        let rowParent = this.options.parentDataTable != null ? this.options.parentDataTable.getRow(parentTR) : null;
                        this.onComment(row, rowParent, comment, isCompanyComments);
                    }, this)
                });
            }, this)
        });
    },
    onComment: function (row, rowParent, comment, isCompanyComments) {
        row.data().set(isCompanyComments ? 'lastCompanyComment' : 'lastContactComment', {
            comment: comment.get('comment')
        });
        row.invalidate().draw(false);

        if (isCompanyComments) {
            // if this is a contact child view, update the company parent in case it has a company comment column also
            if (this.options.view === PJQ.constants.projectMessaging.views.COMP_CONT || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT) {
                // update parent table / company row
                if (rowParent != null) {
                    rowParent.data().set('lastCompanyComment', {
                        comment: comment.get('comment')
                    });
                    rowParent.invalidate().draw(false);
                }
            } else if (this.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
                // if this is a company view, update the contact child view in case it has a company comment column also
                _.each(this.options.childDataTables, _.bind(function (childDT) {
                    if (typeof childDT.statusChanged === 'function') {
                        if (row.data().get('contactCompanyId') !== childDT.$el.data('id'))
                            return;

                        _.each(childDT.dataTable.data(), _.bind(function (item) {
                            item.set('lastCompanyComment', {
                                comment: comment.get('comment')
                            });
                        }, this));
                        childDT.dataTable.rows().invalidate().draw(false);

                    }
                }, this));
            }
        }
    },
    getColumns: function () {
    },
    cleanup: function () {
        this.undelegateEvents();
        $(this.el).empty();
    },
    getIsRootView: function () {
        return (this.options.view.indexOf('-') === -1);
    },
    createdRow: function (row, data, dataIndex) {
    }
});

PJQ.views.projects.ProjectMessagingTradesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.trade-toggle-row': 'childRowToggle',
        'click i.trade-toggle-all-rows': 'childRowToggleAll',
        'change .trade-select-all-contacts': 'selectAll'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = ['groupName', 'groupStatus', 'groupCount'];

        this.totalParticipants = 0;
        this.selectColumnHeader = '';
        this.selectColumnWidth = '50px';
        _.each(this.options.data, _.bind(function (row) {
            this.totalParticipants += row.attributes.totalParticipants;
        }, this));
        if (this.totalParticipants < 1000) {
            this.selectColumnHeader = '<i class="fal fa-plus-circle toggle-all-rows trade-toggle-all-rows mr-1"></i>';
            this.selectColumnWidth = '80px';
        }
        this.selectColumnHeader = '<div class="pretty p-default p-icon p-smooth fs-18 m-0 mr-2"><input type="checkbox" class="trade-select-all-contacts" ' + (this.options.projectMessagingView && this.options.projectMessagingView.options.isTradesViewSelectAll ? 'checked="checked"' : '') + ' /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>' + this.selectColumnHeader;

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "width": this.selectColumnWidth,
                "columnData": "groupMembers",
                "data": null,
                "title": this.selectColumnHeader,
                "className": "dt-center",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle expand-item trade-toggle-row" data-id="' + row.get('groupId') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            let cName,
                cNameTp = typeof columnName;
            if (cNameTp === 'string') {
                cName = columnName;
            } else if (cNameTp === 'object' && typeof cNameTp.data === 'string') {
                cName = cNameTp.data;
            } else {
                return;
            }
            switch (cName) {
                case 'groupName':
                    columns.push({
                        "columnData": "groupName",
                        "data": {
                            "_": "attributes.sortOrder",
                            "sort": "attributes.sortOrder",
                            "filter": "attributes.groupName",
                            "display": "attributes.groupName"
                        },
                        "title": "Trade",
                    });
                    break;
                case 'groupStatus':
                    columns.push({
                        "columnData": "groupStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';

                            let innerHtml = '';
                            _.each(row.get('statuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    textColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + textColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Status",
                        "orderable": false,
                        "width": "60%"
                    });
                    break;
                case 'groupCount':
                    columns.push({
                        "columnData": "groupCount",
                        "data": "attributes.totalParticipants",
                        "title": (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? "Companies" : "Contacts"),
                        "width": "40px",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }
        }, this));

        return columns;
    },
    getChildTableType: function () {
        if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
            return PJQ.constants.projectMessaging.views.GROUPCOMP_COMP;
        } else if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCONT) {
            return PJQ.constants.projectMessaging.views.GROUPCONT_CONT;
        }
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? new PJQ.views.projects.ProjectMessagingCompanyDataTable(childOpts) : new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? PJQ.constants.projectMessaging.views.COMP : PJQ.constants.projectMessaging.views.CONT,
            groupIdList: row.data().get('groupId').toString(),
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            isPerGroup: true,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    },
    selectAll: function (e) {
        let loader = new PJQ.Loader($('.nav-body'));
        let isSelected = $(e.currentTarget).prop('checked');
        this.options.projectMessagingView.options.isTradesViewSelectAll = isSelected;
        this.options.projectMessagingView.options.selectedContacts = [];
        if (isSelected) {
            // get company/contact list for project, iterate through it and add any that aren't declined (unless enabledeclined is true)
            this.options.projectMessagingView.getViewData(this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? 'company' : 'contact', _.bind(function (data) {
                let enableDeclined = this.options.projectMessagingView.isEnableDeclined();
                _.each(data.models, _.bind(function (model) {

                    if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                        _.each(model.get('selectableContacts'), _.bind(function (id) {
                            this.options.projectMessagingView.options.selectedContacts.push(id);
                        }, this));

                        if ((enableDeclined) && _.size(model.get('declinedContacts')) > 0) {
                            _.each(model.get('declinedContacts'), _.bind(function (id) {
                                this.options.projectMessagingView.options.selectedContacts.push(id);
                            }, this));

                        }
                    } else {
                        let isDeclined = (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === model.get('status').toString().toLowerCase());
                        if ((enableDeclined || !isDeclined) && !model.attributes.isBlacklisted && !model.attributes.isCompanyBlacklisted)
                            this.options.projectMessagingView.options.selectedContacts.push(model.id);
                    }

                }, this));

                this.options.projectMessagingView.options.selectedContacts = _.uniq(this.options.projectMessagingView.options.selectedContacts);
                this.options.projectMessagingView.renderContactStats();
                this.options.projectMessagingView.renderView();
                loader.remove();
            }, this), {isPerGroup: true});
        } else {
            // clear any visible checkboxes in sub-grids
            this.$('.select-company,.select-contact').prop('checked', false);
            loader.remove();
        }

        this.options.projectMessagingView.renderContactStats();
    }
});

PJQ.views.projects.ProjectMessagingBidPackagesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.trade-toggle-row': 'childRowToggle',
        'click i.trade-toggle-all-rows': 'childRowToggleAll',
        'change .trade-select-all-contacts': 'selectAll',
        'change select.bid-package-count': 'onBidPackageCountChanged',
        'blur .bid-package-notes': 'onBidPackageNotesChanged'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = ['name', 'bidPackageStatus', 'participantsCount'];

        this.totalParticipants = 0;
        this.selectColumnHeader = '';
        this.selectColumnWidth = '15px';
        _.each(this.options.data, _.bind(function (row) {
            this.totalParticipants += row.attributes.totalParticipants;
        }, this));
        if (this.totalParticipants < 1000) {
            this.selectColumnHeader = '<i class="fal fa-plus-circle toggle-all-rows trade-toggle-all-rows mr-1"></i>';
            this.selectColumnWidth = '2.8em';
        }
        this.selectColumnHeader += '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="trade-select-all-contacts" ' + (this.options.projectMessagingView && this.options.projectMessagingView.options.isTradesViewSelectAll ? 'checked="checked"' : '') + ' /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>';

        let enableCount = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT);
        if (!includeAllColumns) {
            if (enableCount) {
                includeColumns = ['name', 'bidPackageCount', 'bidPackageStatus', 'participantsCount'];
            } else {
                includeColumns = this.options.settings.columnsDefault;
            }

            columns.push({
                "width": this.selectColumnWidth,
                "columnData": "groupMembers",
                "data": null,
                "title": this.selectColumnHeader,
                "className": "dt-center",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle expand-item trade-toggle-row" data-id="' + row.get('groupId') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'name':
                    columns.push({
                        "columnData": "sortOrder",
                        "width": "30%",
                        "data": {
                            "_": "attributes.sortOrder",
                            "sort": "attributes.sortOrder",
                            "filter": "attributes.bidPackageName",
                            "display": "attributes.bidPackageName"
                        },
                        "render": function (d, type, row) {
                            let note = row.get('notes') ? row.get('notes') : '';
                            if (row.get('bidPackageId') > 0) {
                                return '<div><div class="wd-100 ' + (enableCount ? 'ht-90p' : '') + '"><div class="mb-1 fs-16">' + row.get("bidPackageName") + '</div>' + (enableCount ? '<div class="form-group mb-2 ht-75p"><textarea class="form-control wd-100 ht-100 resize-vert bid-package-notes" data-cid="' + row.cid + '">' + note + '</textarea></div></div></div>' : '');
                            } else {
                                return '<span>' + row.get('bidPackageName') + '</span>'
                            }
                        },
                        "title": "Bid Package",
                    });
                    break;
                case 'bidPackageCount':
                    columns.push({
                        "columnData": "count",
                        "data": "attributes.count",
                        "width": "10%",
                        "render": function (data, type, row) {
                            let count = row.get('count');
                            if (row.get('bidPackageId') > 0) {
                                let html = `<select class="form-control bid-package-count" style="min-width:40px;">`
                                for (let i = 0; i <= 10; i++) {
                                    if (parseInt(count) === i) {
                                        html += `<option value="` + i + `" selected>` + i + `</option>`
                                    } else {
                                        html += `<option value="` + i + `">` + i + `</option>`
                                    }
                                }
                                if (count && count.toLowerCase() === 'designated') {
                                    html += `<option value="designated" selected>Designated</option>`
                                } else {
                                    html += `<option value="designated">Designated</option>`
                                }
                                html += `</select>`

                                return html;
                            } else {
                                return '<div></div>';
                            }
                        },
                        "title": "Count"
                    });
                    break;
                case 'bidPackageStatus':
                    columns.push({
                        "columnData": "bidPackageStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';
                            else if (_.size(row.get('statuses')) === 0) {
                                return 'N/A';
                            }

                            let innerHtml = '';
                            _.each(row.get('statuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    textColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + textColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Status",
                        "orderable": false,
                        "width": "50%"
                    });
                    break;
                case 'participantsCount':
                    columns.push({
                        "columnData": "participantCount",
                        "data": "attributes.totalParticipants",
                        "title": "Contacts",
                        "width": "40px",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }
        }, this));
        return columns;
    },
    getChildTableType: function () {
        return PJQ.constants.projectMessaging.views.BIDPKGS_CONT;
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    onBidPackageCountChanged: function (e) {
        let $target = $(e.currentTarget),
            count = $target.val().toLowerCase(),
            row = this.getRow($target.closest('tr')),
            data = row.data();

        data.set('count', count);
        this.updateBidPackageNotesCount(data.get('bidPackageId'), data.get('notes'), count);
    },
    onBidPackageNotesChanged: function (e) {
        let $target = $(e.currentTarget),
            notes = $target.val(),
            row = this.getRow($target.closest('tr')),
            data = row.data();

        data.set('notes', notes);
        this.updateBidPackageNotesCount(data.get('bidPackageId'), notes, data.get('count'));
    },
    updateBidPackageNotesCount: function (bidPackageId, notes, count) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'bidpackages',
                    value: bidPackageId
                },
            ]),
            data: {
                notes: notes,
                count: count
            }
        }).put().done(_.bind(function (response) {
            PJQ.notifications.notify.successNotify({
                message: 'Bid Package Successfully Updated'
            });
        }, this));
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? PJQ.constants.projectMessaging.views.COMP : PJQ.constants.projectMessaging.views.CONT,
            groupIdList: '',
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            isPerGroup: false,
            withCustomFields: this.getChildTableSettings().hasCustomFields,
            bidPackageId: row.data().get('bidPackageId') > 0 ? row.data().get('bidPackageId') : -1
        });
    },
    selectAll: function (e) {
        let loader = new PJQ.Loader($('.nav-body'));
        let isSelected = $(e.currentTarget).prop('checked');
        this.options.projectMessagingView.options.isTradesViewSelectAll = isSelected;
        this.options.projectMessagingView.options.selectedContacts = [];
        if (isSelected) {
            // get company/contact list for project, iterate through it and add any that aren't declined (unless enabledeclined is true)
            this.options.projectMessagingView.getViewData('contact', _.bind(function (data) {
                let enableDeclined = this.options.projectMessagingView.isEnableDeclined();
                _.each(data.models, _.bind(function (model) {


                    let isDeclined = (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === model.get('status').toString().toLowerCase());
                    if ((enableDeclined || !isDeclined) && !model.attributes.isBlacklisted && !model.attributes.isCompanyBlacklisted)
                        this.options.projectMessagingView.options.selectedContacts.push(model.id);


                }, this));

                this.options.projectMessagingView.options.selectedContacts = _.uniq(this.options.projectMessagingView.options.selectedContacts);
                this.options.projectMessagingView.renderContactStats();
                this.options.projectMessagingView.renderView();
                loader.remove();
            }, this), {isPerGroup: true});
        } else {
            // clear any visible checkboxes in sub-grids
            this.$('.select-company,.select-contact').prop('checked', false);
            loader.remove();
        }

        this.options.projectMessagingView.renderContactStats();
    }
});

PJQ.views.projects.ProjectMessagingMessagesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.message-toggle-row': 'childRowToggle',
        'click .btn-show-message': 'showRowFullMessage',
        'click .btn-view-attachments': 'viewAttachments'
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Resend Message',
                iconClass: 'fal fa-paper-plane',
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.YesNo({
                        header: "Resend Message",
                        body: "Are you sure you want to resend this message to all participants?",
                        onYes: _.bind(function () {
                            let enableDeclined = this.options.projectMessagingView.isEnableDeclined();
                            new PJQ.ajax.Request({
                                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'projects',
                                        value: PJQ.app.session.project.id
                                    },
                                    {
                                        endpoint: 'projectmessages',
                                        value: row.data().attributes.projectMessageId
                                    },
                                    {
                                        endpoint: 'resend'
                                    }
                                ], [
                                    {
                                        parameter: 'resendAll',
                                        value: true
                                    },
                                    {
                                        parameter: 'enableDeclined',
                                        value: enableDeclined
                                    }
                                ])
                            }).post().done(_.bind(function (data) {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Message is being resent.'
                                });
                            }, this));

                        }, this)
                    });


                }, this),
                isShown: _.bind(function (row) {
                    return ((this.options.view === PJQ.constants.projectMessaging.views.MSGCONT) && (row.data().get('projectMessageId') > 0));
                }, this)
            },
            {
                name: 'Copy Message',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    this.options.projectMessagingView.copyProjectMessage(row.data().get('projectMessageId'));
                }, this),
                isShown: _.bind(function (row) {
                    return (row.data().get('projectMessageId') > 0);
                }, this)
            },
            {
                name: 'Export Message',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    this.export(row.data());
                }, this),
                isShown: _.bind(function (row) {
                    return (row.data().get('projectMessageId') > 0);
                }, this)
            },
            {
                name: 'Delete Message',
                iconClass: 'fal fa-trash',
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.DeleteCancel({
                        header: "Delete Message",
                        body: "Are you sure you want to delete this message?",
                        onDelete: _.bind(function () {
                            this.options.projectMessagingView.deleteProjectMessage(row.data().get('projectMessageId'), _.bind(this.options.projectMessagingView.renderView, this.options.projectMessagingView));
                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return (row.data().get('projectMessageId') > 0);
                }, this)
            }
        ];
    },
    export: function (message) {
        PJQ.app.session.fetchProjectMessageEmailTemplates(_.bind(function (templates) {
            this.options.project = PJQ.app.session.project;
            _.each(templates.models, function (temp) {
                if (temp.get('templateName') === message.get('templateName')) {
                    this.tempKey = temp.get('templateKey');
                }
            }, this)

            let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'projectmessagepreview'
                }
            ], [
                {
                    parameter: "templateKey",
                    value: this.tempKey
                }
            ]);
            new PJQ.ajax.Request({
                endpoint: endpoint
            }).post().done(_.bind(function (data) {
                this.options.tokens = data
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'projects',
                            value: this.options.project.get('projectId')
                        },
                        {
                            endpoint: 'sendprojectmessages',
                            value: message.get('projectMessageId')
                        },
                        {
                            endpoint: 'export'
                        }
                    ]),
                    data: {
                        responseType: encodeURIComponent(this.options.tokens.projectMessage.responseType),
                        responseDueDate: this.options.tokens.projectMessage.responseDueDate,
                        templateKey: this.tempKey
                    }
                }).post().success(_.bind(function (data) {
                    PJQ.files.downloadFile(data.url, {isEndpoint: false});
                }, this));
            }, this)).fail(function () {
            });
        }, this));
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['templateName', 'message', 'bidsDue', 'responseType', 'broadcastStatus', 'messageStatus', 'totalParticipants', 'sentBy', 'sentOn'];

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "width": '15px',
                "columnData": "messageContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle expand-item message-toggle-row" data-type="projectMessageId" data-id="' + row.get('projectMessageId') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'templateName':
                    columns.push({
                        "columnData": "templateName",
                        "data": "attributes.templateName",
                        "title": "Type"
                    });
                    break;
                case 'message':
                    columns.push({
                        "columnData": "message",
                        "data": "attributes.message",
                        "title": "Message",
                        "orderable": false,
                        "render": function (data, type, row) {
                            let html = '<div class="d-flex align-items-center">';
                            if (row.attributes.message && row.attributes.message !== "") {
                                html += '<div class="flex-fill">';
                                if (_.size(row.attributes.message) > 40) {
                                    html += '<a href="javascript:void(0)" data-id=" ' + row.attributes.projectMessageId + '" class="btn-show-message" title="Click to view full message">' + row.attributes.message.substr(0, 40) + '...</a>'
                                } else {
                                    html += data;
                                }
                                html += '</div>';

                                if (_.size(row.attributes.attachments) > 0) {
                                    html += '<div class=""><button type="button" class="btn btn-transparent-dark btn-view-attachments" title="View ' + _.size(row.attributes.attachments) + ' Attachments" ><i class="fal fa-sm fa-paperclip text-dark"></i></button></div>';
                                }
                            }
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'bidsDue':
                    columns.push({
                        "columnData": "bidsDue",
                        "data": "attributes.bidsDue",
                        "title": "Response Due",
                        "render": function (data, type, row) {
                            let value = '';
                            if (data) {
                                value = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                            }
                            return value;
                        }
                    });
                    break;
                case 'responseType':
                    columns.push({
                        "columnData": "responseType",
                        "data": "attributes.responseType",
                        "title": "Response Type",
                        "render": function (data, type, row) {
                            let value = 'N/A';
                            if (data === 'PROJECT')
                                value = 'Accept/Decline';
                            if (data === 'MESSAGE')
                                value = 'Yes/No';
                            return value;
                        }
                    });
                    break;
                case 'broadcastStatus':
                    columns.push({
                        "columnData": "broadcastStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';

                            let innerHtml = '';
                            _.each(row.get('broadcastStatuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + foregroundColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Broadcast Status",
                        "orderable": false
                    });
                    break;
                case 'messageStatus':
                    columns.push({
                        "columnData": "messageStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';

                            let innerHtml = '';
                            _.each(row.get('messageStatuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + foregroundColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Response",
                        "orderable": false
                    });
                    break;
                case 'totalParticipants':
                    columns.push({
                        "columnData": "totalParticipants",
                        "data": "attributes.totalParticipants",
                        "title": "Contacts",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
                case 'sentOn':
                    columns.push(
                        // There is no way to modify messages view columns currently, so just add sentBy column with sentOn.
                        // If we ever add a way to modify columns for messages then we'll want to add a case for it.
                        {
                            "columnData": "sentBy",
                            "data": "attributes.sentBy",
                            "title": "Sent By",
                            "render": function (data, type, row) {
                                let result = '';
                                if (data != null && data.id !== 0) {
                                    return PJQ.helpers.contacts.getContactAnchor({contact: data});
                                } else {
                                    result = 'N/A';
                                }
                                return result;
                            }
                        },
                        {
                            "columnData": "sentOn",
                            "data": "attributes.sentOn",
                            "title": "Sent On",
                            "render": function (data, type, row) {

                                if (type === 'sort')
                                    return data ? data : '2222-01-01T01:01:01.01Z';

                                let value = '';
                                if (data) {
                                    value = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                }
                                return value;
                            }
                        });
                    break;
            }
        }, this));

        return columns;
    },
    viewAttachments: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.getRow(tr);

        new PJQ.views.projects.dashboard.ViewMessageAttachmentsModal({
            attachments: row.data().get('attachments')
        });
    },
    showRowFullMessage: function (e) {
        let $target = $(e.currentTarget),
            message = _.find(this.options.data, function (data) {
                return data.attributes.projectMessageId === parseInt($target.data('id'));
            });
        e.target.outerHTML = message.attributes.message;
    },
    getChildTableType: function () {
        return PJQ.constants.projectMessaging.views.MSGCONT_CONT;
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (row.data().get('projectMessageId') === 0)
            statusFilter.push('UNSENT');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONT,
            projectMessageId: row.data().get('projectMessageId'),
            responseType: row.data().get('responseType'),
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    },
    afterDataTableRenderChild: function () {
        if (this.options.projectMessagingView && this.options.projectMessagingView.options.viewProjectMessageId) {
            let page_info = this.dataTable.page.info(),
                new_row_index = this.dataTable.row(_.bind(function (idx, data, node) {
                    return data.get('projectMessageId') == this.options.projectMessagingView.options.viewProjectMessageId;
                }, this)).index(),
                row_position = this.dataTable.rows({search: 'applied'})[0].indexOf(new_row_index);

            if (!(row_position >= page_info.start && row_position < page_info.end) && row_position > -1) {
                let page_to_display = Math.floor(row_position / this.dataTable.page.len());
                this.dataTable.page(page_to_display).draw(false);
            }

            if (row_position > -1)
                this.childRowToggle({currentTarget: this.$dataTable.find('i.message-toggle-row[data-id="' + this.options.projectMessagingView.options.viewProjectMessageId + '"]')});

            this.options.projectMessagingView.options.viewProjectMessageId = null;
        }
    }
});

PJQ.views.projects.ProjectMessagingResponsesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.response-toggle-row': 'childRowToggle'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = ['status', 'totalParticipants'];

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "width": '15px',
                "columnData": "responseContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle expand-item response-toggle-row" data-type="status" data-id="' + row.get('status') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.status",
                        "title": "Response",
                        "orderable": false
                    });
                    break;
                case 'totalParticipants':
                    columns.push({
                        "columnData": "totalParticipants",
                        "data": "attributes.totalParticipants",
                        "title": "Contacts",
                        "orderable": false,
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }
        }, this));

        return columns;
    },
    getChildTableType: function () {
        return this.options.view + '-contact';
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [];

        statusFilter.push(row.data().get('status'));

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONT,
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    }
});

PJQ.views.projects.ProjectMessagingCompanyDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.company-toggle-row': 'childRowToggle',
        'change select.company-project-status': 'onStatusChanged',
        'click .btn-grade-project-contact-company': 'gradeContactCompany',
        'change .select-company': 'companySelectChanged',
        'mouseover .comment-company': 'mouseoverComments',
        'mouseleave .comment-company': 'mouseleaveComments',
        'click .btn-comment-company': 'manageComments',
        'click .btn-add-comment-company': 'addComment',
        'change .select-all-companies': 'companySelectAllChanged',
        "click .btn-show-groups": "showRowGroups"
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Upload Bid Docs',
                iconClass: 'fal fa-cloud-upload',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.UploadParticipantBidDocumentsModal({
                        contact: row.data(),
                        onSave: _.bind(function () {
                            this.options.projectMessagingView.renderView();
                        }, this)
                    });
                }, this),
                isShown: _.bind(function () {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view === PJQ.constants.projectMessaging.views.COMP;
                }, this)
            },
            {
                name: 'Remove Company',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.DeleteProjectParticipants({
                        title: "Remove Company",
                        body: "Are you sure you want to remove this company from this project?",
                        onDelete: _.bind(function (isRemoveFromAB) {
                            this.options.projectMessagingView.deleteContacts(_.union(row.data().get('selectableContacts'), row.data().get('declinedContacts')), isRemoveFromAB);
                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage');
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'status', 'bidAmountTotal', 'commentsCompany', 'grade', 'contactCount'];
        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.projectMessagingView && !this.options.projectMessagingView.options.canViewBidAmount) {
                includeColumns = _.filter(includeColumns, function(column) { return column != 'bidAmountTotal' });
            }

            columns.push({
                "columnData": 'selectCompany',
                "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-companies" /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let selectedContacts = _.filter(row.get('selectableContacts'), _.bind(function (contact) {
                        return this.options.projectMessagingView.isContactSelected(contact);
                    }, this));

                    _.each(row.get('declinedContacts'), _.bind(function (contact) {
                        if (this.options.projectMessagingView.isContactSelected(contact))
                            selectedContacts.push(contact);
                    }, this));

                    let isSelected = selectedContacts.length > 0,
                        isIndeterminate = isSelected && (selectedContacts.length < _.size(row.get('selectableContacts')) + _.size(row.get('declinedContacts'))),
                        enableDeclined = this.options.projectMessagingView.isEnableDeclined(),
                        isDisabled = !enableDeclined && (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === row.get('status').toString().toLowerCase());
                    return ('<div class="text-align-center"><div class="pretty p-default p-icon p-smooth p-has-indeterminate fs-18 m-0">' +
                        '<input type="checkbox" ' + (isSelected ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + (isIndeterminate ? ' indeterminate ' : '') + ' class="select-company ' + (isIndeterminate ? ' indeterminate ' : '') + '" />' +
                        '<div class="state"><i class="icon fal fa-check-double"></i> <label class="wd-0">&nbsp;</label></div>' +
                        '<div class="state p-is-indeterminate"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div>' +
                        '</div></div>');
                }, this)
            });

            columns.push({
                "columnData": "groupCompanyContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "width": "40px",
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle expand-item company-toggle-row" data-type="contactCompanyId" data-id="' + row.get('contactCompanyId') + '"></i>';
                }
            });
        }

        let distanceThreshold = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISTANCE_ICON_THRESHOLD),
            canManage = PJQ.app.session.project.hasPermission('messaging.canManage');
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '50px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('isDirectoryContact'))
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");

                            if (row.get('hasPrequal')) {
                                icons.push("<i class='fas fa-check text-gold fs-18 mr-1' title='Prequalification Available'></i>");
                            }

                            let dist = row.get('distance');
                            if (typeof distanceThreshold === 'number' && dist != null && dist <= distanceThreshold) {
                                icons.push("<i class='fas fa-map-marker-check text-orange fs-18 mr-1' title='Within " + distanceThreshold.toString() + " miles'></i>");
                            }

                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "title": 'Labor Status',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (status.length === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "title": 'Labor Sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (status.length === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupDisplayLimit = 0, groupArray = data ? data.split(',') : [];
                            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY)) {
                                groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
                            }

                            if (groupDisplayLimit > 0 && (_.size(groupArray) > groupDisplayLimit)) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - groupDisplayLimit).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - groupDisplayLimit) + " more item(s)</a>";
                            } else {
                                return data;
                            }
                        }
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": 'status',
                        "data": {
                            "_": function (row) {
                                return row.get('status') ? row.get('status') : 'PENDING';
                            },
                            "display": function (row) {

                                if (canManage) {
                                    let html = '<select class="form-control company-project-status" style="min-width:100px;">',
                                        statuses = PJQ.app.session.project.getProjectStatusList();
                                    statuses.unshift(['PENDING', true]);
                                    _.each(statuses, _.bind(function (status, index) {
                                        html += '<option value="' + status[0] + '"' + (status[0] === row.get('status') ? ' SELECTED' : '') + '>' + status[0] + '</option>';
                                    }, this));
                                    html += '</select>';
                                    return html;
                                }

                                let status = row.get('status');
                                return '<span>' + (_.size(status) > 0 ? status.toUpperCase() : 'PENDING') + '</span>';
                            }
                        },
                        "title": 'Status',
                    });
                    break;
                case 'bidAmountTotal':
                    columns.push({
                        "columnData": "bidAmountTotal",
                        "data": "attributes.bidAmount",
                        "title": "Bid Total",
                        "render": function (data, type, row) {
                            return "<span class='bid-amount-total'>" + PJQ.helpers.formatHelpers.formatCurrency(row.get("bidAmount"))  + "</span>";
                        }
                    });
                    break;
                case 'commentsCompany':
                    columns.push({
                        "columnData": 'commentsCompany',
                        "title": 'Comments',
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:150px;" class="d-flex align-items-center">';
                            html += '<div class="flex-fill comment-company ' + (row.get('lastCompanyComment') ? '' : 'text-muted') + '">' + (row.get('lastCompanyComment') ? row.get('lastCompanyComment').comment : 'No Comments Added') + '</div>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-add-comment-company" title="Add Comment"><i class="far fa-comment-plus text-dark"></i></button>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-comment-company" title="Comments" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-comments text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'grade':
                    columns.push({
                        "columnData": 'grade',
                        "title": 'Grade',
                        "width": "40px",
                        "render": function (data, type, row) {
                            let html = '<span class="mr-1">' + row.get('gradeAverage').toString() + '</span>';
                            //todo: add preference for this
                            if (PJQ.app.session.get('portalId') !== 506) {
                                html += (row.get('grade') !== 0) ? '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact-company" title="Review Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="fas fa-star text-gold"></i></button>' : '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact-company" title="Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-star text-muted"></i></button>';
                            }
                            return html;
                        }
                    });
                    break;
                case 'contactCount':
                    columns.push({
                        "columnData": "contactCount",
                        "data": "attributes.contactCount",
                        "title": "Contacts",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));
                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }
        }, this));

        return columns;
    },
    afterDataTableRenderChild: function () {
        this.$el.find('.select-company.indeterminate').prop('indeterminate', 'true');
    },
    getChildTableType: function () {
        return this.options.view + '-contact';
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONT,
            contactCompanyId: row.data().get('contactCompanyId'),
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            groupIdList: row.data().collection.options.groupIdList,
            isPerGroup: row.data().collection.options.isPerGroup,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    },
    statusChanged: function (statuses, parentTR) {
        if(parentTR) {
            let row = this.getRow(parentTR);
            switch (this.options.view) {
                case PJQ.constants.projectMessaging.views.COMP:
                    // this view cannot have a group status, so update the regular status column and redraw the row.
                    row.data().set('status', statuses.companyStatus);
                    break;
                case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
                    // this view must have a group status
                    row.data().set('status', statuses.companyGroupStatus);
                    break;
            }
            row.invalidate().draw();
            this.setRowStyle(parentTR, row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));
        }
    },
    companySelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.getRow(tr);

        // if we were partially checked, force ourself to be unchecked
        if ($(e.currentTarget).hasClass('indeterminate'))
            $(e.currentTarget).prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');

        if ($(e.currentTarget).prop('checked')) {
            if (row.data().get('declinedContacts').length > 0)
                $(e.currentTarget).prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
            else
                $(e.currentTarget).prop('indeterminate', false).removeClass('indeterminate');

            if (_.size(row.data().get('selectableContacts')) > 0)
                this.options.projectMessagingView.addSelectedContacts(row.data().get('selectableContacts'));
            else
                $(e.currentTarget).prop('checked', false);

            if (this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                let groupId = parseInt(row.data().collection.options.groupIdList), contactGroups = [];
                _.each(row.data().get('selectableContacts'), _.bind(function (contact) {
                    contactGroups.push({contactId: contact, groupId: groupId});
                }, this));
                this.options.projectMessagingView.addSelectedContactGroups(contactGroups);
            }
        } else {
            this.options.projectMessagingView.removeSelectedContacts(_.union(row.data().get('selectableContacts'), row.data().get('declinedContacts')));

            if (this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                let groupId = parseInt(row.data().collection.options.groupIdList), contactGroups = [];
                _.each(_.union(row.data().get('selectableContacts'), row.data().get('declinedContacts')), _.bind(function (contact) {
                    contactGroups.push({contactId: contact, groupId: groupId});
                }, this));
                this.options.projectMessagingView.removeSelectedContactGroups(contactGroups);
            }
        }

        _.each(this.options.childDataTables, _.bind(function (childDT) {
            if (row.data().get('contactCompanyId') !== childDT.$el.data('id'))
                return;

            _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                let childRow = childDT.getRow($(input).closest('tr'));
                $(input).prop('checked', this.options.projectMessagingView.isContactSelected(childRow.data().get('contactId')));
            }, this));

        }, this));

    },
    companySelectAllChanged: function (e) {
        let projectStatusList = PJQ.app.session.project.getProjectStatusList(),
            isChecked = $(e.currentTarget).prop('checked'),
            isEnableDeclined = this.options.projectMessagingView.isEnableDeclined(), selectedContacts = [];

        _.each(this.dataTable.data(), _.bind(function (row) {
            if (isChecked) {
                if (!row.attributes.isBlacklisted)
                    $.merge(selectedContacts, row.attributes.selectableContacts);

                if (isEnableDeclined)
                    $.merge(selectedContacts, row.attributes.declinedContacts);
            } else {
                $.merge(selectedContacts, row.attributes.selectableContacts);
                $.merge(selectedContacts, row.attributes.declinedContacts);
            }
        }, this));

        let selectedContactGroups = [], isGroupsView = false;
        if (this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
            let groupId = parseInt(this.options.data[0].collection.options.groupIdList);
            _.each(selectedContacts, _.bind(function (contact) {
                selectedContactGroups.push({contactId: contact, groupId: groupId});
            }, this));
            isGroupsView = true;
        }

        if (isChecked) {
            this.options.projectMessagingView.addSelectedContacts(selectedContacts);

            if (isGroupsView)
                this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
        } else {
            this.options.projectMessagingView.removeSelectedContacts(selectedContacts);

            if (isGroupsView)
                this.options.projectMessagingView.removeSelectedContactGroups(selectedContactGroups);
        }

        _.each(this.$dataTable.find('tbody tr[role="row"]'), _.bind(function (tr) {
            let row = this.getRow(tr), input = $(tr).find('input.select-company');

            if (input.length === 0)
                return;

            // if is declined, skip it unless enable declined is turned on
            $(input).prop('indeterminate', false).removeClass('indeterminate');
            if ($(e.currentTarget).prop('checked') === false || (!isEnableDeclined && projectStatusList[1].toString().split(',')[0].toLowerCase() === row.data().get('status').toString().toLowerCase()) || _.size(selectedContacts) == 0)
                $(input).prop('checked', false);
            else {
                $(input).prop('checked', $(e.currentTarget).prop('checked'));

                if (row.data().get('declinedContacts').length > 0 && !isEnableDeclined)
                    $(input).prop('indeterminate', true).addClass('indeterminate');
            }


        }, this));

        _.each(this.options.childDataTables, _.bind(function (childDT) {
            _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                let childRow = childDT.getRow($(input).closest('tr'));
                $(input).prop('checked', this.options.projectMessagingView.isContactSelected(childRow.data().get('contactId')));
            }, this));
        }, this));

        this.refresh(false);
    },
    createdRow: function (row, data, dataIndex) {
        this.setRowStyle(row, data.attributes.status, data.attributes.isBlacklisted)
    },
    setRowStyle: function (row, status, isBlacklisted) {
        let statusColor = _.find(this.options.projectMessagingView.options.settings.attributes.statusColors, function (statusColor) {
            return statusColor.status === status
        });

        let blackListed = '';
        if (isBlacklisted)
            blackListed = 'text-decoration: line-through !important;';

        if (statusColor) {
            let foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(statusColor.backgroundColor);
            $(row).css({cssText: 'background-color:' + statusColor.backgroundColor + ' !important;' + 'color:' + foregroundColor + ' !important;' + blackListed});
        } else
            $(row).css({cssText: "background-color: ''; color: '';" + blackListed});
    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(','),
            groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
        target[0].outerHTML = ' ' + _.rest(groups, groupDisplayLimit).join(', ')
    }
});

PJQ.views.projects.ProjectMessagingContactDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'change select.contact-project-status': 'onStatusChanged',
        'change select.contact-message-status': 'onMessageStatusChanged',
        'click .btn-grade-project-contact': 'gradeContactCompany',
        'mouseover .comment-contact,.comment-company': 'mouseoverComments',
        'mouseleave .comment-contact,.comment-company': 'mouseleaveComments',
        'click .btn-add-comment-contact,.btn-add-comment-company': 'addComment',
        'click .btn-comment-contact,.btn-comment-contact-company': 'manageComments',
        'keyup .contact-bid-amount': 'bidAmountChanged',
        'blur .contact-bid-amount': 'bidAmountExited',
        'change .select-contact': 'contactSelectChanged',
        'change .select-all-contacts': 'contactSelectAllChanged',
        'click .btn-copy-access-key': 'copyAccessKey',
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-email': 'copyEmail',
        "click .btn-show-groups": "showRowGroups"
    },
    afterDataTableRenderChild: function () {
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.contact-bid-amount'), 2);
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'View Contact',
                iconClass: 'fal fa-search',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.BaseEditContactModal({
                        model: new PJQ.models.projectParticipants.ProjectParticipant({
                            id: row.data().get('contactId'),
                            projectId: PJQ.app.session.project.id,
                        }),
                        showNotes: true,
                        showActive: true
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return !PJQ.app.session.hasPermission('contacts.isAdmin') && !PJQ.app.session.hasPermission('contacts.canEdit')
                        && (PJQ.app.session.hasPermission('contacts.canView') || PJQ.app.session.project.hasPermission('projectContacts.canView'));
                }, this)
            },
            {
                name: 'Edit Contact',
                iconClass: 'fal fa-pencil',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.BaseEditContactModal({
                        model: new PJQ.models.projectParticipants.ProjectParticipant({
                            id: row.data().get('contactId'),
                            projectId: PJQ.app.session.project.id
                        }),
                        isShowAddContact: true,
                        showNotes: true,
                        showActive: true,
                        deleteLabel: 'Remove from Project',
                        onDelete: _.bind(function (model) {
                            this.options.projectMessagingView.deleteContacts([row.data().get('contactId')], false);

                        }, this),
                        onSave: _.bind(function (model, isNew) {
                            if (isNew) {
                                this.options.projectMessagingView.renderView();
                                return;
                            }

                            let becameInactive = false;
                            if (model.get('isBlacklisted') && !row.data().get('isBlacklisted')) {
                                becameInactive = true;
                                row.data().set('status', this.options.projectStatusList[1].toString().split(',')[0]);
                            }

                            row.data().set('isAutoSelectDisabled', model.get('isAutoSelectDisabled'));
                            row.data().set('isBlacklisted', model.get('isBlacklisted'));
                            row.data().set('contactTitle', model.get('contactTitle'));
                            row.data().set('fax', model.get('fax'));
                            row.data().set('cell', model.get('cell'));
                            row.data().set('address1', model.get('address1'));
                            row.data().set('address2', model.get('address2'));
                            row.data().set('city', model.get('city'));
                            row.data().set('zip', model.get('zip'));
                            row.data().set('state', model.get('state'));
                            row.data().set('country', model.get('country'));
                            // row.data().set('groupIdList', model.get('groupIdList'));
                            // row.data().set('groupListDisplay', model.get('groupListDisplay'));
                            row.data().set('isCompanyBlacklisted', model.get('isCompanyBlacklisted'));
                            row.data().set('isUnion', model.get('isUnion'));
                            row.data().set('isNonUnion', model.get('isNonUnion'));
                            row.data().set('isPrevailingWage', model.get('isPrevailingWage'));
                            row.data().set('isPublicSector', model.get('isPublicSector'));
                            row.data().set('isPrivateSector', model.get('isPrivateSector'));
                            row.data().set('isDBE', model.get('isDBE'));
                            row.data().set('isDVBE', model.get('isDVBE'));
                            row.data().set('isMBE', model.get('isMBE'));
                            row.data().set('isSBE', model.get('isSBE'));
                            row.data().set('isSDVBE', model.get('isSDVBE'));
                            row.data().set('isUDBE', model.get('isUDBE'));
                            row.data().set('isVSBE', model.get('isVSBE'));
                            row.data().set('isWBE', model.get('isWBE'));
                            row.data().set('phone', model.get('phone'));
                            row.data().set('phoneExtension', model.get('phoneExtension'));
                            row.data().set('companyName', model.get('companyName'));
                            row.data().set('contactName', model.get('contactName'));
                            row.data().set('distance', model.get('distance'));
                            row.data().set('email', model.get('email'));
                            row.data().set('notes', model.get('notes'));
                            row.data().set('contactCustomFieldValues', model.get('contactCustomFieldValues'));
                            row.data().set('companyCustomFieldValues', model.get('companyCustomFieldValues'));

                            row.invalidate().draw();
                            this.setRowStyle(row.node(), row.data().attributes.status, row.data().attributes.isBlacklisted || row.data().attributes.isCompanyBlacklisted);

                            let removeRow = _.bind(function () {
                                    let parentRow = this.options.parentDataTable.getRow($(row.node()).parent().closest('tr').prev());
                                    row.remove().draw();

                                    // remove company if this was the only contact listed
                                    if (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP &&
                                        parentRow.data().get('contactCount') === 1) {
                                        parentRow.remove().draw();
                                    }
                                }, this),
                                callback = _.bind(function () {
                                    if (row.child.isShown()) {
                                        row.child.hide();

                                        this.childRowToggle({
                                            currentTarget: row.selector.rows.find('i.contact-toggle-row')[0]
                                        });
                                    }

                                    if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP ||
                                        this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {

                                        let groupId = parseInt(row.data().collection.options.groupIdList);
                                        if (groupId === 0) {
                                            if (_.size(model.get('groups')) > 0) {
                                                // they had no groups but now have groups, remove from no group
                                                removeRow();
                                            }
                                        } else if (_.size(_.filter(model.get('groups'), function (group) {
                                            return group.groupId === groupId
                                        })) === 0) {
                                            // they no longer have the group of the row they are being edited in
                                            removeRow();
                                        }
                                    }
                                }, this);

                            if (becameInactive && this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP)) {
                                // update parent status and redraw
                                let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'projects',
                                        value: PJQ.app.session.project.id
                                    },
                                    {
                                        endpoint: 'participants',
                                        value: row.data().get('contactId')

                                    },
                                    {
                                        endpoint: 'companystatus'
                                    }
                                ]);
                                new PJQ.ajax.Request({
                                    endpoint: endpoint
                                }).get().done(_.bind(function (data) {
                                    let parentTR = $(row.node()).parent().closest('tr').prev();
                                    let rowParent = this.options.parentDataTable.getRow(parentTR);
                                    rowParent.data().set('status', data.status);
                                    rowParent.invalidate().draw();
                                    this.options.parentDataTable.setRowStyle(parentTR, data.status, row.data().get('isCompanyBlacklisted'));
                                    callback();

                                }, this)).fail(function () {
                                    PJQ.notifications.notify.errorNotify({
                                        message: 'Unable to get Company Status.'
                                    });
                                });
                            } else {
                                callback();
                            }

                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.isAdmin') || PJQ.app.session.hasPermission('contacts.canEdit');
                }, this)
            },
            {
                name: 'Manage Trades',
                iconClass: 'fal fa-hard-hat',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.ManageProjectParticipantTradesModal({
                        contactId: row.data().get('contactId'),
                        onSave: _.bind(function (data) {
                            // close/hide/dispose of child datatable so that it can be refreshed.  update current row's grouplist display.
                            let groupIdList = [];
                            let groupNameList = [];
                            _.each(data.models, _.bind(function (model) {
                                if (model.get('isSelected')) {
                                    groupIdList.push(model.get('groupId'));
                                    groupNameList.push(model.get('groupName'));
                                }
                            }, this));

                            row.data().set('groupIdList', groupIdList.join(','));
                            row.data().set('groupListDisplay', groupNameList.join(', '));
                            row.invalidate().draw();

                            if (row.child.isShown()) {
                                row.child.hide();

                                this.childRowToggle({
                                    currentTarget: row.selector.rows.find('i.contact-toggle-row')[0]
                                });
                            }

                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view !== PJQ.constants.projectMessaging.views.MSGCONT_CONT;
                }, this)

            },
            {
                name: 'Project History',
                iconClass: 'fal fa-history',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.ProjectParticipantHistoryModal({
                        project: this.options.project,
                        contactId: row.data().get('contactId')
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return true;
                }, this)
            },
            {
                name: 'Resend Message',
                iconClass: 'fal fa-paper-plane',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id
                            },
                            {
                                endpoint: 'projectmessages',
                                value: row.data().collection.options.projectMessageId
                            },
                            {
                                endpoint: 'resend'
                            }
                        ], [
                            {
                                parameter: 'projectMessageContactBroadcastIds',
                                value: [row.data().attributes.projectMessageContactBroadcastId]
                            }
                        ])
                    }).post().done(_.bind(function (data) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Message is being resent.'
                        });
                    }, this));

                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT;
                }, this)
            },
            {
                name: 'Upload Bid Docs',
                iconClass: 'fal fa-cloud-upload',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.UploadParticipantBidDocumentsModal({
                        contact: row.data(),
                        onSave: _.bind(function () {
                            this.options.projectMessagingView.renderView();
                        }, this)
                    });
                }, this),
                isShown: function () {
                    return PJQ.app.session.project.hasPermission('messaging.canManage');
                }
            },
            {
                name: 'Order Prints',
                iconClass: 'fal fa-shopping-cart',
                onClick: _.bind(function (row) {
                    new PJQ.views.files.OrderPrintsModal({
                        recipients: [row.data()],
                        onOrderPlaced: _.bind(function () {
                            this.options.projectMessagingView.clearSelectedContacts();
                        }, this)
                    });
                }, this),
                isShown: function () {
                    return PJQ.app.session.project.hasPermission('messaging.canManage');
                }
            },
            {
                name: 'Send Update Request',
                iconClass: 'fal fa-poll-h',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'updater'
                            }
                        ])
                    }).post().done(_.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contact Updater Request sent'
                        });
                    }, this)).fail(function (xhr, err, result) {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Contact Updater Request failed'
                        });
                    });

                }, this),
                isShown: function (row) {
                    return PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_UPDATER_ENABLED) &&
                        PJQ.app.session.project.hasPermission('messaging.canManage') &&
                        !row.data().get('isDirectoryContact');
                }
            },
            {
                name: 'Request Prequal',
                iconClass: 'fal fa-envelope-open-text',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'prequal'
                            },
                            {
                                endpoint: 'request'
                            }
                        ])
                    }).post().done(_.bind(function (data) {
                        if (data && data.success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Qualification request sent'
                            });
                        } else {
                            PJQ.notifications.notify.errorNotify({
                                message: 'Qualification update failed, invalid email address on contact'
                            });
                        }
                    }, this)).fail(function (xhr, err, result) {
                        new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
                            error: err,
                            result: result
                        });
                    });
                }, this),
                isShown: function () {
                    return PJQ.app.session.hasPermission('prequal.canView') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL);
                }
            },
            {
                name: 'Export vCard',
                iconClass: 'fal fa-address-card',
                onClick: _.bind(function (row) {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'contacts',
                            value: row.data().get('contactId')
                        },
                        {
                            endpoint: 'vcard'
                        }
                    ]));
                }, this)
            },
            {
                name: 'Copy Public Vendor',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'contacts',
                            value: row.data().get('contactId')
                        },
                        {
                            endpoint: 'copydirectorycontact'
                        }
                    ]);
                    new PJQ.ajax.Request({
                        endpoint: endpoint
                    }).post().done(_.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contact copied successfully.'
                        });
                        // todo: update this view and maybe parent view if parent view is a company?
                    }, this)).fail(function (xhr, err, result) {
                        let logicError = xhr.responseJSON.message.indexOf('logic') === -1;
                        PJQ.notifications.notify.errorNotify({
                            title: logicError ? 'Duplicate Contact' : 'Something went wrong!',
                            message: logicError ? 'Directory contact already exists in your address book.' : 'Something went wrong!'
                        });
                    });
                }, this),
                isShown: function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && row.data().get('isDirectoryContact');
                }
            },
            {
                name: 'Report',
                iconClass: 'fal fa-flag-alt',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.ReportContactModal({
                        contactId: row.data().get('contactId'),
                        showRemoveFromProject: true,
                        onReport: _.bind(function (removeFromProject) {
                            if (removeFromProject)
                                this.options.projectMessagingView.renderView();
                        }, this)
                    });
                }, this),
                isShown: function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && row.data().get('isDirectoryContact');
                }
            },
            {
                name: 'Remove Contact',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.DeleteProjectParticipants({
                        title: "Remove Participant",
                        body: "Are you sure you want to remove this contact from this project?",
                        onDelete: _.bind(function (isRemoveFromAB) {
                            this.options.projectMessagingView.deleteContacts([row.data().get('contactId')], isRemoveFromAB);
                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view !== PJQ.constants.projectMessaging.views.MSGCONT_CONT;
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'contactName', 'contactTitle', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'cell', 'fax', 'email', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'distance', 'grade', 'userType', 'commentsCompany', 'commentsContact', 'bidAmount', 'status'];

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST))
            includeColumns.push('activityRank');

        if (this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT) {
            includeColumns.push('accessKey');
            includeColumns.push('broadcastStatus');
            includeColumns.push('deliveredOn');
            includeColumns.push('openedOn');
            includeColumns.push('responded');
        }

        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('contactCustomField_' + customField.id);
        }, this));

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.projectMessagingView && !this.options.projectMessagingView.options.canViewBidAmount) {
                includeColumns = _.filter(includeColumns, function(column) { return column != 'bidAmount' });
            }

            columns.push({
                "columnData": '',
                "title": (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP)) ? '' : '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let isSelected = this.options.projectMessagingView.isContactSelected(row.get('contactId')),
                        enableDeclined = this.options.projectMessagingView.isEnableDeclined(),
                        isDisabled = !enableDeclined && (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === row.get('status').toString().toLowerCase());
                    return ('<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0">' +
                        '<input type="checkbox"' + (isSelected ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + ' class="select-contact" />' +
                        '<div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div>' +
                        '</div></div>');
                }, this)
            });

            if (!this.options.parentDataTable || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.RSPCONT || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
                columns.push({
                    "columnData": 'contactGroups',
                    "data": null,
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "width": '20px',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle expand-item contact-toggle-row" data-id="' + row.get('contactId') + '"></i>';
                    }
                });
            }
        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100,
            canManage = PJQ.app.session.project.hasPermission('messaging.canManage'),
            distanceThreshold = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISTANCE_ICON_THRESHOLD);
        _.each(includeColumns, _.bind(function (columnName) {
            let cName,
                cNameTp = typeof columnName;
            if (cNameTp === 'string') {
                cName = columnName;
            } else if (cNameTp === 'object' && typeof cNameTp.data === 'string') {
                cName = cNameTp.data;
            } else {
                return;
            }
            switch (cName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '50px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];

                            if (row.get('isDefaultContact'))
                                icons.push("<i class='far fa-crown mr-1' title='Primary Contact'></i>");

                            // proqual stuff
                            if (row.get('hasUnpaidInvites'))
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_pending.gif' title='Qualification Pending' />");
                            else if (row.get('minScreeningStatusId') < PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_inprocess.gif' title='Qualification In Process' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') === 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_review.gif' title='Qualification Needs Review' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_allclear.png' title='Qualification Approved' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.InProcess &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_processed.gif' title='All Enrolled' />");

                            if (row.get('maxScreeningInviteId') > 0 && row.get('screeningCountFeedbackItems') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_grade2.gif' title='Qualification Feedback Required' />");

                            if (row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) < new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_expired.png' title='Qualification Expired' />");

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('isDirectoryContact'))
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");

                            // message stats stuff

                            if (row.get('lastDownloadedOn'))
                                icons.push("<i class='far fa-download mr-1' title='Last downloaded on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastDownloadedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('lastViewedOn') && (!this.options.parentDataTable || this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.MSGCONT))
                                icons.push("<i class='far fa-eye mr-1' title='Last visited on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastViewedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('viewedOn') && this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.MSGCONT)
                                icons.push("<i class='far fa-eye mr-1' title='Visited on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('viewedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('openedOn') && this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.MSGCONT)
                                icons.push("<i class='far fa-envelope-open  mr-1' title='Opened email on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('openedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('lastOpenedOn') && (!this.options.parentDataTable || this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.MSGCONT))
                                icons.push("<i class='far fa-envelope-open  mr-1' title='Last opened email on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastOpenedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('deliveredOn') && this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.MSGCONT)
                                icons.push("<i class='far fa-envelope  mr-1' title='Delivered on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('deliveredOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('lastDeliveredOn') && (!this.options.parentDataTable || this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.MSGCONT))
                                icons.push("<i class='far fa-envelope  mr-1' title='Last delivered email on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastDeliveredOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");

                            if (row.get('lastBroadcastStatus') && (row.get('lastBroadcastStatus').toLowerCase().indexOf('fail') !== -1 || row.get('lastBroadcastStatus').toLowerCase().indexOf('error') !== -1))
                                icons.push("<i class='far fa-exclamation-triangle  mr-1' title='Last Message Failed'></i>");

                            let dist = row.get('distance');
                            if (typeof distanceThreshold === 'number' && dist != null && dist <= distanceThreshold) {
                                icons.push("<i class='fas fa-map-marker-check text-orange fs-18 mr-1' title='Within " + distanceThreshold.toString() + " miles'></i>");
                            }

                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'contactName':
                    columns.push({
                        "columnData": "contactName",
                        "data": "attributes.contactName",
                        "title": "Contact",
                    });
                    break;
                case 'contactTitle':
                    columns.push({
                        "columnData": "contactTitle",
                        "data": "attributes.contactTitle",
                        "title": "Title"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State",
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip",
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country",
                    });
                    break;
                case 'phone':
                    columns.push({
                        "columnData": "phone",
                        "data": "attributes.phone",
                        "title": "Phone",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A'),
                                phoneWrapped = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone'), true) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'cell':
                    columns.push({
                        "columnData": "cell",
                        "data": "attributes.cell",
                        "title": "Cell",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A'),
                                phoneWrapped = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell'), true) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-mobile-alt text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'fax':
                    columns.push({
                        "columnData": "fax",
                        "data": "attributes.fax",
                        "title": "Fax",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A'),
                                phoneWrapped = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax'), true) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'email':
                    columns.push({
                        "columnData": "email",
                        "data": "attributes.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let email = data;
                            if (_.size(email) === 0) {
                                return '';
                            }

                            let project = PJQ.app.session.project,
                                subject = project.get('projectName') + ' - ' + project.get('city') + ', ' + project.get('state'),
                                accessKey = row.get('accessKey'),
                                body;
                            if (accessKey != null && _.size(accessKey.trim()) > 0) {
                                let projectUrl = window.location.origin + '/?accessKey=' + accessKey + '#projects/' + project.id.toString() + '';
                                body = 'Click here to view the project: ' + projectUrl;
                            } else {
                                body = '';
                            }

                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                mailto = email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body),
                                emailFormatted = '<a target="_blank" title="' + email + '" style="color: inherit;" href="mailto:' + mailto + '">' + email + '</a>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';
                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "title": 'Labor Status',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "title": 'Labor Sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupDisplayLimit = 0, groupArray = data ? data.split(',') : [];
                            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY)) {
                                groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
                            }

                            if (groupDisplayLimit > 0 && (_.size(groupArray) > groupDisplayLimit)) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - groupDisplayLimit).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - groupDisplayLimit) + " more item(s)</a>";
                            } else {
                                return data;
                            }
                        }
                    });
                    break;
                case 'distance':
                    columns.push({
                        "columnData": 'distance',
                        "data": {
                            "_": function (row) {
                                return row.get('distance') == null ? 0 : row.get('distance');
                            },
                            "display": function (row) {
                                if (row.get('distance') == null) {
                                    return '';
                                }
                                return row.get('distance').toFixed(2).toString() + ' mi.';
                            }
                        },
                        "title": 'Distance',
                    });
                    break;
                case 'grade':
                    columns.push({
                        "columnData": 'grade',
                        "title": 'Grade',
                        "width": "40px",
                        "render": function (data, type, row) {
                            let html = '<span class="mr-1">' + row.get('gradeAverage').toString() + '</span>';
                            html += (row.get('grade') !== 0) ? '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact" title="Review Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="fas fa-star text-gold"></i></button>' : '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact" title="Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-star text-muted"></i></button>';
                            return html;
                        }
                    });
                    break;
                case 'userType':
                    columns.push({
                        "columnData": 'userType',
                        "title": 'Contact Type',
                        "data": 'userType',
                        "render": function (data, type, row) {
                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(false), _.bind(function (userType) {
                                return row.get('userTypeId') === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'commentsCompany':
                    columns.push({
                        "columnData": 'commentsCompany',
                        "title": 'Comments (Company)',
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:150px;" class="d-flex align-items-center">';
                            html += '<div data-id="' + row.get('contactCompanyId') + '" class="flex-fill comment-company ' + (row.get('lastCompanyComment') ? '' : 'text-muted') + '">' + (row.get('lastCompanyComment') ? row.get('lastCompanyComment').comment : 'No Comments Added') + '</div>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-add-comment-company" title="Add Comment"><i class="far fa-comment-plus text-dark"></i></button>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-comment-contact-company" title="Comments" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-comments text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'commentsContact':
                    columns.push({
                        "columnData": 'commentsContact',
                        "title": 'Comments (Contact)',
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:150px;" class="d-flex align-items-center">';
                            html += '<div data-id="' + row.get('contactId') + '" class="flex-fill comment-contact ' + (row.get('lastContactComment') ? '' : 'text-muted') + '">' + (row.get('lastContactComment') ? row.get('lastContactComment').comment : 'No Comments Added') + '</div>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-add-comment-contact" title="Add Comment"><i class="far fa-comment-plus text-dark"></i></button>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-comment-contact" title="Comments" data-contact-id="' + row.get('contactId') + '"><i class="far fa-comments text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'bidAmount':
                    columns.push({
                        "columnData": "bidAmount",
                        "width": "150px",
                        "data": {
                            "_": function (row) {
                                return row.get('bidAmount');
                            },
                            "display": function (row) {
                                if (canManage) {
                                    return '<input type="text" class="form-control contact-bid-amount input-dollars-full" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('bidAmount'), 2, false) + '" />';
                                }

                                return '<span>' + PJQ.helpers.formatHelpers.formatCurrency(row.get('bidAmount'), 2, true) + '</span>'
                            }
                        },
                        "title": "Bid Amount"
                    });
                    break;
                case 'status':
                    if (this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT) {
                        columns.push({
                            "columnData": 'status',
                            "title": 'Response',
                            "width": "180px",
                            "data": {
                                "_": function (row) {
                                    return row.get('status') ? row.get('status') : 'PENDING';
                                },
                                "display": function (row) {
                                    let html = '<select class="form-control contact-message-status" style="min-width:100px;">',
                                        statuses = [],
                                        isProjectResponse = PJQ.app.session.project.getProjectStatusList().indexOf(row.get('status')) != -1;

                                    if (row.collection.options.responseType === 'PROJECT')
                                        statuses = PJQ.app.session.project.getProjectStatusList();
                                    else if (row.collection.options.responseType === 'MESSAGE')
                                        statuses = PJQ.app.session.project.getMessageStatusList();
                                    else
                                        return _.size(row.get('status')) === 0 ? 'N/A' : row.get('status');

                                    statuses.unshift(['PENDING', true]);

                                    _.each(statuses, _.bind(function (status, index) {
                                        html += '<option value="' + status[0] + '"' + (status[0] === row.get('status') ? ' SELECTED' : '') + '>' + status[0] + '</option>';
                                    }, this));

                                    html += '</select>';

                                    if (row.collection.options.responseType === '')
                                        html = _.size(row.get('status')) === 0 ? 'N/A' : row.get('status');

                                    return html;
                                }
                            }
                        });
                    } else {
                        columns.push({
                            "columnData": 'status',
                            "title": 'Status',
                            "width": "180px",
                            "data": {
                                "_": function (row) {
                                    return row.get('status') ? row.get('status') : 'PENDING';
                                },
                                "display": function (row) {
                                    if (canManage) {
                                        let html = '<select class="form-control contact-project-status" style="min-width: 100px;">',
                                            statuses = PJQ.app.session.project.getProjectStatusList();
                                        statuses.unshift(['PENDING', true]);
                                        _.each(statuses, _.bind(function (status, index) {
                                            html += '<option value="' + status[0] + '"' + (status[0] === row.get('status') ? ' SELECTED' : '') + '>' + status[0] + '</option>';
                                        }, this));
                                        html += '</select>';
                                        return html;
                                    }

                                    let status = row.get('status');
                                    return '<span>' + (_.size(status) > 0 ? status.toUpperCase() : 'PENDING') + '</span>';
                                }
                            }
                        });
                    }
                    break;
                case 'accessKey':
                    columns.push({
                        "columnData": "accessKey",
                        "data": "attributes.accessKey",
                        "title": "Access Key",
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">';
                            html += '<div class="flex-fill ' + (row.get('accessKey') ? '' : 'text-muted') + '">' + (row.get('accessKey') ? row.get('accessKey') : '') + '</div>';
                            if (row.get('accessKey') !== '' && row.get('accessKey') !== ' ')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-access-key" title="Copy Access Key" data-access-key="' + row.get('accessKey') + '"><i class="far fa-key text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'broadcastStatus':
                    columns.push({
                        "columnData": 'broadcastStatus',
                        "data": "attributes.broadcastStatus",
                        "title": 'Broadcast Status',
                        "render": function (data, type, row) {
                            let broadcastStatus = _.size(row.get('broadcastStatus')) === 0 ? 'PENDING' : row.get('broadcastStatus');
                            return '<span title="' + (_.size(row.get('broadcastErrorMessage')) === 0 ? broadcastStatus : row.get('broadcastErrorMessage')) + '" >' + broadcastStatus + '</span>';
                        }
                    });
                    break;
                case 'responded':
                    columns.push({
                        "columnData": "responded",
                        "data": {
                            "_": function (row) {
                                return new Date(row.get('rsvpOn'));
                            },
                            "filter": "attributes.rsvpOn",
                            "display": function (row) {
                                return row.get('rsvpOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('rsvpOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true) : 'N/A';
                            }
                        },
                        "title": "Responded"
                    });
                    break;
                case 'deliveredOn':
                    columns.push({
                        "columnData": "deliveredOn",
                        "data": {
                            "_": function (row) {
                                return new Date(row.get('deliveredOn'));
                            },
                            "filter": "attributes.deliveredOn",
                            "display": function (row) {
                                return row.get('deliveredOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('deliveredOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true) : 'N/A';
                            }
                        },
                        "title": "Delivered"
                    });
                    break;
                case 'openedOn':
                    columns.push({
                        "columnData": "openedOn",
                        "data": {
                            "_": function (row) {
                                return new Date(row.get('openedOn'));
                            },
                            "filter": "attributes.openedOn",
                            "display": function (row) {
                                return row.get('openedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('openedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true) : 'N/A';
                            }
                        },
                        "title": "Opened"
                    });
                    break;
                case 'activityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'activityRank',
                            "data": 'attributes.activityRank',
                            "title": 'Activity'
                        });
                    }
                    break;

            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }

            if (columnName.startsWith('contactCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, false));
                }, this));
            }

        }, this));

        return columns;
    },
    getChildTableType: function () {
        return PJQ.constants.projectMessaging.views.CONTGROUP;
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.dom = 't';
        childOpts.parentDataTable = this;
        childOpts.paging = false;
        return new PJQ.views.projects.ProjectMessagingContactTradesDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONTGROUP,
            contactId: row.data().get('contactId')
        });
    },
    statusChanged: function (statuses, parentTR, parentView) {

        let self = this;
        if (parentTR) {
            this.statusChangedHelper(this.getRow(parentTR), statuses, parentTR, parentView);
        } else {
            this.dataTable.rows().every(function (rowIdx, tableLoop, rowLoop) {
                self.statusChangedHelper(this, statuses, parentTR, parentView);
            });
        }
        this.dataTable.draw();

        // if this is the child of the company view, update the parent as well
        if (this.options.parentDataTable != null) {
            this.options.parentDataTable.statusChanged(statuses, parentTR ? parentTR.parent().closest('tr').prev() : null, parentView);
        }

    },
    statusChangedHelper: function (row, statuses, parentTR, parentView) {
        switch (this.options.view) {
            case PJQ.constants.projectMessaging.views.COMP_CONT:
            case PJQ.constants.projectMessaging.views.CONT:
            case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
                // these views cannot have a group status, so update the regular status column and redraw the row.
                row.data().set('status', statuses.projectStatus);
                row.invalidate();
                this.setRowStyle(row.node(), row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));


                // update the groups subgrid if it exists
                if (parentView !== PJQ.constants.projectMessaging.views.CONTGROUP) {
                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        if (typeof childDT.statusChanged === 'function') {
                            childDT.statusChanged(statuses, null, this.options.view);
                        }
                    }, this));
                }
                break;
            case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
            case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
                // these views must have a group status, so update the group status column and redraw the row.
                row.data().set('status', statuses.groupStatus);
                row.invalidate();
                this.setRowStyle(row.node(), row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));

                // update the groups subgrid if it exists
                _.each(this.options.childDataTables, _.bind(function (childDT) {
                    if (typeof childDT.statusChanged === 'function') {
                        childDT.statusChanged(statuses, null, this.options.view);
                    }
                }, this));
                break;
        }
    },
    onMessageStatusChanged: function (e) {
        let $target = $(e.currentTarget),
            status = $target.val().toUpperCase(),
            row = this.getRow($target.closest('tr')),
            data = row.data();

        data.updateStatus(status, _.bind(function () {
            this.setRowStyle(row.node(), row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));
            PJQ.notifications.notify.successNotify({
                message: 'Status updated'
            });
        }, this));
        // no parents or children to update in this case as it is a Message status.
    },
    bidAmountExited: function(e) {
        let bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent());
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatCurrency(bidAmount, 2, false));
    },
    bidAmountChanged: function (e) {
        if (e.ctrlKey && e.key != 'v') {
            e.stopPropagation();
            return false;
        }

        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr),
            bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent()),
            callback = function (context) {
                if (context.options.parentDataTable !== undefined && (context.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || context.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP)) {
                    let bidAmountTotal = 0;
                    _.each(context.dataTable.data(), _.bind(function (item) {
                        if (item.get('contactCompanyId') === row.data().get('contactCompanyId'))
                            bidAmountTotal += item.get('bidAmount');
                    }, context));

                    let rowParent = context.options.parentDataTable.getRow(parentTR);
                    rowParent.data().set('bidAmount', bidAmountTotal);
                    //rowParent.invalidate().draw();
                    $(parentTR).find('.bid-amount-total').text(PJQ.helpers.formatHelpers.formatCurrency(bidAmountTotal, 2, true));
                }
            };

        row.data().set('bidAmount', bidAmount);
        row.data().set('contactCompanyId', row.data().get('contactCompanyId'));
        row.data().set('projectId', PJQ.app.session.project.id);
        row.data().set('isUpdateBidAmount', true);
        row.data().queueSave({bidAmount: bidAmount}, {
            //patch: true,
            success: _.bind(function () {
                callback(this);
            }, this)
        }, 800);

    },
    contactSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr);

        if ($(e.currentTarget).prop('checked')) {
            this.options.projectMessagingView.addSelectedContacts([row.data().get('contactId')]);

            if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {
                let groupId = parseInt(row.data().collection.options.groupIdList);
                this.options.projectMessagingView.addSelectedContactGroups([{
                    contactId: row.data().get('contactId'),
                    groupId: groupId
                }]);
            }
        } else {
            this.options.projectMessagingView.removeSelectedContacts([row.data().get('contactId')]);
            if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {
                let groupId = parseInt(row.data().collection.options.groupIdList);
                this.options.projectMessagingView.removeSelectedContactGroups([{
                    contactId: row.data().get('contactId'),
                    groupId: groupId
                }]);
            }
        }

        if (this.options.parentDataTable === undefined)
            return;

        let totalContacts = 0, selectedContacts = 0;
        _.each(this.dataTable.data(), _.bind(function (item) {
            if (item.get('contactCompanyId') === row.data().get('contactCompanyId')) {
                totalContacts++;
                if (this.options.projectMessagingView.isContactSelected(item.get('contactId')))
                    selectedContacts++;
            }
        }, this));

        if (selectedContacts === 0) {
            parentTR.find('input.select-company').prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');
        } else if (selectedContacts === totalContacts) {
            parentTR.find('input.select-company').prop('checked', true).prop('indeterminate', false).removeClass('indeterminate');
        } else {
            // indeterminate
            parentTR.find('input.select-company').prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
        }
    },
    contactSelectAllChanged: function (e) {
        let projectStatusList = PJQ.app.session.project.getProjectStatusList(),
            isChecked = $(e.currentTarget).prop('checked'),
            isEnableDeclined = this.options.projectMessagingView.isEnableDeclined(), selectedContacts = [],
            groupId = null, isGroupsView = false, selectedContactGroups = [];

        if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {
            isGroupsView = true;
            groupId = parseInt(this.options.data[0].collection.options.groupIdList);
        }

        _.each(this.dataTable.data(), _.bind(function (row) {
            if (isChecked) {
                if ((isEnableDeclined || projectStatusList[1].toString().split(',')[0].toLowerCase() !== row.attributes.status.toString().toLowerCase()) &&
                    !row.attributes.isBlacklisted && !row.attributes.isCompanyBlacklisted)
                    selectedContacts.push(row.attributes.contactId);
            } else {
                selectedContacts.push(row.attributes.contactId);
            }
        }, this));

        if (isGroupsView) {
            _.each(selectedContacts, _.bind(function (selectedContact) {
                selectedContactGroups.push({contactId: selectedContact, groupId: groupId});
            }, this));
        }

        if (isChecked) {
            this.options.projectMessagingView.addSelectedContacts(selectedContacts);
            if (isGroupsView)
                this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
        } else {
            this.options.projectMessagingView.removeSelectedContacts(selectedContacts);
            if (isGroupsView)
                this.options.projectMessagingView.removeSelectedContactGroups(selectedContactGroups);
        }

        this.refresh(false);
    },
    createdRow: function (row, data, dataIndex) {
        let status = data.attributes.status;
        if (this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT &&
            data.collection.options.responseType !== 'PROJECT'
            && data.collection.options.responseType !== 'MESSAGE')
            status = '';

        this.setRowStyle(row, status, data.attributes.isBlacklisted || data.attributes.isCompanyBlacklisted)
    },
    setRowStyle: function (row, status, isBlacklisted) {
        let statusColor = _.find(this.options.projectMessagingView.options.settings.attributes.statusColors, function (statusColor) {
            return statusColor.status === status
        }), rowCss = '';

        if (statusColor) {
            let foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(statusColor.backgroundColor);
            rowCss = 'background-color:' + statusColor.backgroundColor + ' !important;' + 'color:' + foregroundColor + ' !important;';
        }

        if (isBlacklisted)
            rowCss += ' text-decoration: line-through !important;';

        $(row).css({cssText: rowCss});

    },
    copyAccessKey: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('accessKey'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Access Key copied to clipboard.'
        });
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone').replace(/ /g,''),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(','),
            groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
        target[0].outerHTML = ' ' + _.rest(groups, groupDisplayLimit).join(', ')
    }
});

PJQ.views.projects.ProjectMessagingContactTradesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'change select.project-contact-group-status': 'onStatusChanged',
        'keyup .contact-group-bid-amount': 'bidAmountChanged',
        'blur .contact-group-bid-amount': 'bidAmountExited'
    },
    afterDataTableRenderChild: function () {
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.contact-group-bid-amount'), 2);
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [];
        columns.push({
            "columnData": "groupName",
            "data": "attributes.groupName",
            "title": "Trade",
            "orderable": false
        });

        columns.push({
            "columnData": 'groupStatus',
            "width": "180px",
            "title": 'Trade Status',
            "render": function (data, type, row) {
                let html = '<select class="form-control project-contact-group-status">',
                    statuses = PJQ.app.session.project.getProjectStatusList();
                statuses.unshift(['PENDING', true]);
                _.each(statuses, _.bind(function (status, index) {
                    html += '<option value="' + status[0] + '"' + (status[0] === row.get('groupStatus') ? ' SELECTED' : '') + '>' + status[0] + '</option>';

                }, this));
                html += '</select>';
                return html;
            },
            "orderable": false
        });

        if (this.options.projectMessagingView && this.options.projectMessagingView.options.canViewBidAmount) {
            columns.push({
                "columnData": "bidAmount",
                "data": "attributes.bidAmount",
                "width": "150px",
                "title": "Bid Amount",
                "render": function (data, type, row) {
                    return '<input type="text" class="form-control contact-group-bid-amount input-dollars-full" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('bidAmount'), 2, false) + '" />';
                }
            });
        }


        return columns;
    },
    statusChanged: function (statuses, parentTR, parentView) {
        if (!(parentView === PJQ.constants.projectMessaging.views.CONT || parentView === PJQ.constants.projectMessaging.views.COMP || parentView === PJQ.constants.projectMessaging.views.COMP_CONT || parentView === PJQ.constants.projectMessaging.views.GROUPCONT_CONT || parentView === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT || parentView === PJQ.constants.projectMessaging.views.RSPCONT_CONT || parentView === PJQ.constants.projectMessaging.views.BIDPKGS_CONT))
            return;

        let groupId = 0;
        if (parentView === PJQ.constants.projectMessaging.views.GROUPCONT_CONT || parentView === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT)
            groupId = parseInt(this.options.parentDataTable.dataTable.rows(0).row().data().collection.options.groupIdList);

        // if we are being called, we must update ALL rows(trades) in our datatable and then redraw the whole thing.
        _.each(this.dataTable.data(), _.bind(function (item) {
            if (groupId === 0 || groupId === item.get('groupId'))
                item.set('groupStatus', statuses.groupStatus);
        }, this));

        this.dataTable.rows().invalidate().draw();
    },
    bidAmountExited: function(e) {
        let bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent());
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatCurrency(bidAmount, 2, false));
    },
    bidAmountChanged: function (e) {

        if (e.ctrlKey && e.key != 'v') {
            e.stopPropagation();
            return false;
        }

        let tr = $(e.currentTarget).closest('tr'),
            parentTR = tr.parent().closest('tr').prev(),
            row = this.getRow(tr),
            bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent());

        /*
		row.data().set('contactCompanyId', row.data().get('contactCompanyId'));
		row.data().set('projectId', PJQ.app.session.project.id);
		*/

        row.data().set('bidAmount', bidAmount);
        row.data().queueSave({bidAmount: bidAmount}, {
            patch: true,
            success: _.bind(function (response) {
                //row.invalidate().draw(); -- 2023-07-31 blue: this causes the field to lose focus

                // iterate through all rows in this table to get the total for this contact
                let contactBidTotal = 0;
                _.each(this.dataTable.data(), _.bind(function (item) {
                    contactBidTotal += item.get('bidAmount');
                }, this));

                // update the contact's Bid Amount field
                let parentRow = this.options.parentDataTable.getRow(parentTR);
                parentRow.data().set('bidAmount', contactBidTotal);
                //parentRow.invalidate().draw(); -- 2023-07-31 blue: this causes the field to lose focus
                $(parentTR).find('.contact-bid-amount').val(PJQ.helpers.formatHelpers.formatCurrency(contactBidTotal, 2, false));

                // if main view is Company, iterate through all contacts to get their bid amounts
                if (this.options.projectMessagingView.currentView === PJQ.constants.projectMessaging.views.COMP || this.options.projectMessagingView.currentView === PJQ.constants.projectMessaging.views.GROUPCOMP) {

                    let companyBidTotal = 0, parentParentTR = parentTR.parent().closest('tr').prev();
                    _.each(this.options.parentDataTable.dataTable.data(), _.bind(function (item) {
                        companyBidTotal += item.get('bidAmount');
                    }, this));

                    // update parent company row's Bid Amount Total
                    let parentParentRow = this.options.parentDataTable.options.parentDataTable.getRow(parentParentTR);
                    parentParentRow.data().set('bidAmount', companyBidTotal);
                    //parentParentRow.invalidate().draw(); -- 2023-07-31 blue: this causes the field to lose focus
                    $(parentParentTR).find('.bid-amount-total').text(PJQ.helpers.formatHelpers.formatCurrency(contactBidTotal, 2, true));

                }
            }, this)
        }, 800);

    }
});

// Models
PJQ.models.projectParticipants.ProjectContactComment = PJQ.models.BaseModel.extend({
	idAttribute: "projectContactCommentId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants',
				value: this.options.contactId
			},
			{
				endpoint: 'comments',
				value: this.get('projectContactCommentId')
			}
		], [
			{
				parameter: 'isCompanyComments',
				value: this.options.isCompanyComments
			}
		])
	}
});

PJQ.models.projectParticipants.ProjectParticipantForView = PJQ.models.projectParticipants.ProjectParticipant.extend({
	updateStatus: function (status, callback) {
		let endpointArr = [
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'participants',
				value: this.id
			}
		];

		if (this.collection != null && this.collection.options.groupId > 0) {
			endpointArr.push({
				endpoint: 'groups',
				value: this.collection.options.groupId
			});
		}
		else if (this.collection != null && this.collection.options.isPerGroup) {
			endpointArr.push({
				endpoint: 'groups',
				value: parseInt(this.collection.options.groupIdList)
			});
		}

		if (this.collection != null && this.collection.options.projectMessageId > 0) {
			endpointArr.push({
				endpoint: 'messages',
				value: this.get('projectMessageContactBroadcastId')
			});
		}

		endpointArr.push({
			endpoint: 'status'
		});

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, [
				{
					parameter: "status",
					value: status
				}
			])
		}).post().done(_.bind(function (response) {
			this.set('status', status);
			callback(response);
		}, this));
	}
});

PJQ.models.projectParticipants.ProjectParticipantGroupForView = PJQ.models.projectParticipants.ProjectParticipant.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'participants',
				value: this.get('contactId')
			},
			{
				endpoint: 'groups',
				value: this.get('groupId')
			}
		]);
	},
	updateStatus: function (status, callback) {
		let endpointArr = [
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'participants',
				value: this.get('contactId')
			},
			{
				endpoint: 'groups',
				value: this.get('groupId')
			},
			{
				endpoint: 'status'
			}
		];
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, [
				{
					parameter: "status",
					value: status
				}
			])
		}).post().done(_.bind(function (response) {
			this.set('status', status);
			callback(response);
		}, this));
	}
});

PJQ.models.projectParticipants.ProjectParticipantCompanyForView = PJQ.models.projectParticipants.ProjectParticipantForView.extend({});

PJQ.models.projectParticipants.ProjectMessageForView = PJQ.models.BaseModel.extend({});

PJQ.models.projectParticipants.ProjectResponseForView = PJQ.models.BaseModel.extend({});

PJQ.models.projectParticipants.ProjectGroupForView = PJQ.models.BaseModel.extend({});

PJQ.models.projectParticipants.FilterInfo = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants'
			},
			{
				endpoint: 'views'
			},
			{
				endpoint: 'filter'
			}
		], [
			{
				parameter: 'searchFor',
				value: encodeURIComponent(this.options.searchFor ? this.options.searchFor : '')
			},
			{
				parameter: 'view',
				value: this.options.view
			},
			{
				parameter: 'projectMessageBroadcastId',
				value: this.options.projectMessageBroadcastId
			}
		])
	}
});

PJQ.models.projectParticipants.ProjectMessageViewSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'projectmessaging'
			},
			{
				endpoint: 'settings'
			}
		]);
	},
	getSettings: function (view) {
		return _.find(this.attributes.settings, _.bind(function (setting) {
			return setting.view === view;
		}, this));
	},
	parse: function (model) {
		if (model != null) {
			_.each(model.settings, function (setting) {
				if (setting.view === PJQ.constants.projectMessaging.views.COMP || setting.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
					setting.hasCustomFields = _.find(setting.columns, function (column) {
						return column.toLowerCase().indexOf('companycustomfield_') !== -1;
					}) != null;
				}
				else if (setting.view === PJQ.constants.projectMessaging.views.CONT || setting.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT
					|| setting.view === PJQ.constants.projectMessaging.views.GROUPCONT_CONT || setting.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT
					|| setting.view === PJQ.constants.projectMessaging.views.RSPCONT_CONT || setting.view === PJQ.constants.projectMessaging.views.BIDPKGS_CONT) {
					setting.hasCustomFields = _.find(setting.columns, function (column) {
						return column.toLowerCase().indexOf('contactcustomfield_') !== -1 || column.toLowerCase().indexOf('companycustomfield_') !== -1;
					}) != null;
				}
				else {
					setting.hasCustomFields = false;
				}
			}, this);
		}
		return model;
	}
});

//Collections
PJQ.collections.projectParticipants.ProjectParticipantsForView = PJQ.collections.BaseCollection.extend({
	beforeConstruct: function (models, options) {
		switch (options.view) {
			case PJQ.constants.projectMessaging.views.GROUPCOMP:
			case PJQ.constants.projectMessaging.views.GROUPCONT:
				this.model = PJQ.models.projectParticipants.ProjectGroupForView;
				break;
			case PJQ.constants.projectMessaging.views.MSGCONT:
				this.model = PJQ.models.projectParticipants.ProjectMessageForView;
				break;
			case PJQ.constants.projectMessaging.views.RSPCONT:
				this.model = PJQ.models.projectParticipants.ProjectResponseForView;
				break;
			case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
			case PJQ.constants.projectMessaging.views.COMP:
				this.model = PJQ.models.projectParticipants.ProjectParticipantCompanyForView;
				break;
			case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
			case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
			case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
			case PJQ.constants.projectMessaging.views.MSGCONT_CONT:
			case PJQ.constants.projectMessaging.views.COMP_CONT:
			case PJQ.constants.projectMessaging.views.CONT:
				this.model = PJQ.models.projectParticipants.ProjectParticipantForView;
				break;
			case PJQ.constants.projectMessaging.views.CONTGROUP:
				this.model = PJQ.models.projectParticipants.ProjectParticipantGroupForView;
				break;
		}
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants'
			},
			{
				endpoint: 'views'
			},
			{
				endpoint: this.options.view
			}
		], [
			{
				parameter: 'contactId',
				value: this.options.contactId
			},
			{
				parameter: 'contactCompanyId',
				value: this.options.contactCompanyId
			},
			{
				parameter: 'groupIdList',
				value: this.options.groupIdList
			},
			{
				parameter: 'projectMessageId',
				value: this.options.projectMessageId
			},
			{
				parameter: 'statusFilter',
				value: this.options.statusFilter
			},
			{
				parameter: 'isPerGroup',
				value: this.options.isPerGroup
			},
			{
				parameter: 'searchFor',
				value: encodeURIComponent(this.options.searchFor ? this.options.searchFor : '')
			},
			{
				parameter: 'withCustomFields',
				value: this.options.withCustomFields != null ? this.options.withCustomFields : false
			},
			{
				parameter: 'bidPackageId',
				value: this.options.bidPackageId
			}
		])
	}
});

PJQ.collections.projectParticipants.ProjectParticipantComments = PJQ.collections.BaseCollection.extend({
	idAttribute: 'commentId',
	model: PJQ.models.projectParticipants.ProjectContactComment,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants',
				value: this.options.isCompanyComments ? this.options.participant.get('contactCompanyId') : this.options.participant.get('contactId')
			},
			{
				endpoint: 'comments'
			}
		], [
			{
				parameter: 'isCompanyComments',
				value: this.options.isCompanyComments
			}
		])
	}
});

PJQ.collections.projectParticipants.ProjectParticipantGroups = PJQ.collections.BaseCollection.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: "projects",
				value: PJQ.app.session.project.id
			},
			{
				endpoint: "participants",
				value: this.options.contactId
			},
			{
				endpoint: "groups"
			}
		]);
	}
});

PJQ.views.projects.QuickAddParticipantsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Quick-Add-Participants'),
		minWidth: '400px',
		onSave: null
	},
	events: {
		'keyup .input-email': 'emailChanged',
		'click .btn-add': 'addParticipant'
	},
	emailChanged: function (e) {
		this.$('.btn-add').prop('disabled', _.size($(e.currentTarget).val()) === 0);
	},
	addParticipant: function () {
		let emails = this.$('.input-email').val().split(';');
		_.each(emails, function (email) {
			let newParticipant = new PJQ.models.projectParticipants.ProjectParticipant({
				project: this.options.project,
				email: email,
				groups: null,
				isQuickAdd: true
			});
			newParticipant.save(null, {
				notify: false,
				success: _.bind(function (mod, data) {
					if (newParticipant.get('projectId') == null && newParticipant.groups != null && _.size(newParticipant.groups.models) > 0) {
						newParticipant.set({
							id: null,
							projectId: this.options.project.id
						});
						new PJQ.views.groups.SelectGroupsModal({
							alertText: 'Select trades to add with this participant',
							selectorOptions: {
								includeGroupIds: _.map(newParticipant.groups.models, function (group) {
									return group.id;
								})
							},
							onSave: _.bind(function (groups) {
								newParticipant.groups.reset(groups.selected);
								newParticipant.save(null, {
									notify: false,
									success: _.bind(function (mod, data) {
										this.removeModal();
										if (typeof this.options.onSave === 'function') {
											this.options.onSave(newParticipant);
										}
									}, this),
									error: _.bind(function () {
										PJQ.notifications.notify.errorNotify({
											message: newParticipant.get('email') + ' already exists on this project.'
										});
									}, this)
								});
							}, this)
						});
					}
					else {
						this.removeModal();
						if (typeof this.options.onSave === 'function') {
							this.options.onSave(newParticipant);
						}
					}
				}, this),
				error: _.bind(function () {
					PJQ.notifications.notify.errorNotify({
						message: newParticipant.get('email') + ' already exists on this project.'
					});
				}, this)
			});
		}, this);
	}
});
PJQ.views.projects.AutoReport = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Auto-Report'),
        minWidth: '800px'
    },
    events: {
        'click .export-pdf': 'exportPDF'
    },
    afterRender: function() {
        // fetch and display the report contents (in HTML format)
        let loader = new PJQ.Loader(this.$('div.report-content'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'autoreport'
                }
            ])
        }).get().done(_.bind(function (response) {
            loader.remove();
            jQuery('div.report-content').html(atob(response.data));
            jQuery('div.report-content div div table tbody tr td[width="100%"]').attr('width', '0px');
        }, this));
    },
    exportPDF: function() {
        // export the report to PDF and serve up the download.
        PJQ.files.downloadFile(
            PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'autoreport'
                },
                {
                    endpoint: 'export'
                }
            ])
        );
    }
});